import { ONU_LIFECYCLE_I18N } from './i18nOnuLifecycle';
import { REPORTS_PON_I18N } from './i18nReportsPon';
import { PON_DETAIL_I18N } from './i18nPonDetail';
import { REPORTS_RBAC_I18N } from './i18nReportsRbac';
import { REPORTS_TOPOLOGY_I18N } from './i18nReportsTopology';
import { AUTO_TASKS_I18N } from './i18nAutoTasks';
import { FIBERHOME_I18N } from './i18nFiberHome';

// All copy lives here. Two languages. Multiple headline variants per language.
export const DICT = {
  pt: {
    nav: {
      features: 'Recursos',
      vendors: 'Compatibilidade',
      stats: 'Plataforma',
      pricing: 'Planos',
      contact: 'Contato',
      login: 'Entrar',
      trial: 'Teste grátis',
    },
    hero: {
      kicker: 'PLATAFORMA SAAS PARA PROVEDORES DE INTERNET',
      headlines: [
        ['Gerencie sua frota de', 'OLTs', 'em um único painel.'],
        ['Monitore', 'fibra óptica', 'em tempo real.'],
        ['Gerencie OLTs e', 'ONUs', 'em escala, sem dor de cabeça.'],
        ['Sua rede GPON,', 'sob controle', 'desde o primeiro minuto.'],
      ],
      sub: 'OLTM centraliza o gerenciamento, o monitoramento e o licenciamento de OLTs Huawei, ZTE e Fiberhome em uma só plataforma — feita para ISPs sérios.',
      cta_primary: 'Começar teste grátis',
      cta_secondary: 'Falar com especialista',
      pill_live: 'AO VIVO',
      pill_status: 'Todos os sistemas operando',
    },
    features: {
      eyebrow: '— RECURSOS',
      title: 'Tudo que seu NOC precisa.',
      sub: 'Operação enxuta, sem retrabalho. Conectividade, segurança e visibilidade num só lugar.',
      items: [
        { t: 'Gestão Multi-Vendor', d: 'Huawei, ZTE e Fiberhome através de integradores unificados. Comandos abstraídos, resultado consistente.' },
        { t: 'Segurança Enterprise', d: 'JWT RS256, MFA TOTP, RBAC granular e credenciais SNMP criptografadas em repouso.' },
        { t: 'Monitoramento em tempo real', d: 'Polling SNMP, heartbeat por instância e alertas instantâneos via webhooks ou Telegram.' },
        { t: 'Sistema todo on Cloud', d: 'Rode seu sistema todo em nosso cluster multi-tenant, com total segurança e backup de suas informações sem risco para sua operação.' },
        { t: 'API & Webhooks', d: 'Integre com seu ERP, sistema de bilhetagem e ferramentas internas. Tudo documentado.' },
        { t: 'Auditoria completa', d: 'Cada provisionamento, cada reset de ONU, cada acesso — tudo registrado e exportável.' },
      ],
    },
    vendors: {
      eyebrow: '— COMPATIBILIDADE',
      title: 'Funciona com o que você já tem.',
      sub: 'Drivers maduros para os fabricantes mais usados no Brasil e no mundo.',
      list: ['HUAWEI', 'ZTE', 'FIBERHOME', 'PARKS', 'DATACOM', 'V-SOL'],
      note: 'Quer outro fabricante? Solicite no formulário — adicionamos.',
    },
    stats: {
      eyebrow: '— EM NÚMEROS',
      title: 'A plataforma vive 24/7.',
      items: [
        { label: 'OLTs gerenciadas', key: 'olts_managed' },
        { label: 'ONUs online agora', key: 'onus_online' },
        { label: 'ISPs ativos', key: 'isps_active' },
        { label: 'Uptime (90d)', key: 'uptime', suffix: '%' },
        { label: 'Alertas tratados hoje', key: 'alerts_handled_today' },
        { label: 'Países atendidos', key: 'countries' },
      ],
    },
    misc: {
      lang_label: 'IDIOMA',
      theme_label: 'TEMA',
      reshuffle: 'Recarregar layout',
    },
    app: {
      nav: {
        dashboard: 'Painel',
        unconfigured: 'Não configuradas',
        configured: 'Configuradas',
        graphs: 'Gráficos',
        events: 'Eventos',
        diagnostics: 'Diagnóstico',
        tasks: 'Tarefas',
        reports: 'Relatórios',
        save_config: 'Salvar',
        settings: 'Configurações',
        log_out: 'Sair',
        role_owner: 'Proprietário',
      },
      reports_menu: ['Inventário de ONUs', 'Qualidade de sinal', 'Resumo de tráfego', 'Exportar auditoria', 'Quedas por porta PON', 'Resumo de OLTs', 'Coleta SNMP/SSH (poll)'],
      common: {
        search: 'Buscar…',
        filter: 'Filtrar',
        save_changes: 'Salvar alterações',
        cancel: 'Cancelar',
        prev: 'Anterior',
        next: 'Próximo',
        showing: 'Mostrando',
        of: 'de',
        all_olts: 'Todas as OLTs',
        all_zones: 'Todas as zonas',
        all_types: 'Todos os tipos',
        all_roles: 'Todos os cargos',
        all_statuses: 'Todos os status',
        all_severities: 'Todas severidades',
        last_24h: 'Últimas 24h',
        last_7d: 'Últimos 7 dias',
        last_30d: 'Últimos 30 dias',
        last_90d: 'Últimos 90 dias',
        new: 'Novo',
        add: 'Adicionar',
        back: 'Voltar',
        details: 'Detalhes',
        monitor: 'Monitorar',
        actions: 'Ações',
        status: 'Status',
        started: 'Iniciada',
        user: 'Usuário',
      },
      banner: {
        updated_to: 'foi atualizado para a versão',
        see_new: 'Ver o que há de novo',
      },
      dashboard: {
        kpis: {
          waiting_authorization: 'Aguardando autorização',
          online: 'Online',
          total_offline: 'Total offline',
          low_signals: 'Sinais baixos',
          d_resync_new: 'D: 0 · Resync: 1 · Novas: 1',
          total_authorized: 'Autorizadas: 12.648',
          pwrfail_los_na: 'PwrFail: 833 · LoS: 267 · N/A: 83',
          warning_critical: 'Alerta: 1.082 · Crítico: 232',
        },
        info_valid: 'Informação válida às 01:20',
        network_status: 'Status da rede',
        daily_network_status: 'Status diário da rede',
        more_graphs: 'Mais gráficos ▾',
        online_onus: 'ONUs online',
        power_fail: 'Falha de energia',
        signal_loss: 'Perda de sinal',
        na: 'N/D',
        maximum: 'Máximo',
        auth_per_day: 'Autorizações de ONU por dia',
        pon_outage: 'Interrupção PON',
        no_pon_outages: 'Nenhuma interrupção de PON no momento.',
        olt_name: 'Nome da OLT',
        board_port: 'Placa/Porta',
        onus: 'ONUs',
        los: 'LOS',
        power: 'Energia',
        possible_cause: 'Possível causa',
        since: 'Desde',
        olts: 'OLTs',
        all: 'Todas ▾',
        info: 'Avisos',
        view_all_info: 'Ver todos os avisos',
        olt_issues: 'OLTs com falhas',
        no_olt_issues: 'Nenhuma OLT com falhas no momento.',
        uptime: 'Uptime',
        online_series: 'Online',
        offline_series: 'Offline',
      },
      not_validated: {
        badge: 'Não validado ao vivo',
        tooltip: 'Este recurso foi testado com simulação e testes automatizados, mas ainda não foi confirmado numa OLT real. Confira o resultado na OLT depois de usar.',
      },
      unconfigured: {
        title: 'ONUs não configuradas',
        sub: 'ONUs aguardando autorização. Use presets para acelerar o onboarding.',
        cache_note: 'Esta lista vem do cache. A varredura automática das OLTs roda em ciclos longos (≈ 2 h, configurável por instância); use Atualizar para varrer agora.',
        auto_actions: 'Ações automáticas',
        serial: 'Serial',
        olt: 'OLT',
        detected: 'Detectada',
        authorize: 'Autorizar',
        waiting: 'Aguardando',
      },
      vlan_scope: {
        out_of_rule: 'fora da regra da PON',
        out_of_registry: 'fora do cadastro da OLT',
        none_allowed: 'Nenhuma VLAN está liberada para a PON {pon} — libere em OLT › VLANs. A autorização segue possível sem VLAN.',
        none_allowed_link: 'Abrir as VLANs da OLT',
        preset_vlan_skipped: 'A VLAN {vlan} da predefinição não é permitida na PON {pon} e não foi aplicada.',
        current_out_of_rule: 'A VLAN atual desta ONU ({vlan}) está fora da regra da PON {pon}; ela continua listada só para você editar sem perder o valor.',
        auto_vlan_warning: 'A VLAN {vlan} da predefinição não vale nas PONs {pons}: itens nessas PONs serão ignorados (vlan_not_allowed_on_pon).',
        auto_vlan_link: 'Ver a regra da VLAN',
      },
      vlans_tab: {
        col_vlan: 'VLAN-ID',
        col_pon: 'Portas PON',
        col_description: 'Descrição',
        col_iptv: 'IPTV',
        col_mgmt: 'Gestão/VoIP',
        col_dhcp: 'DHCP Snooping',
        col_lan2lan: 'LAN para LAN',
        col_onus: 'ONUs',
        col_actions: 'Ações',
        refresh: 'Atualizar VLANs',
        add: 'Adicionar VLAN(s)',
        delete_multiple: 'Excluir múltiplas VLANs',
        loading: 'Carregando…',
        load_error: 'Não foi possível carregar as VLANs da OLT.',
        retry: 'Tentar de novo',
        empty: 'Nenhuma VLAN descoberta. Execute um poll para coletar via SNMP.',
        pon_all: 'Todas',
        pon_all_except: 'Todas exceto',
        pon_none: 'Nenhuma',
        pon_load_error: 'Não foi possível carregar as portas PON — o resumo da coluna "Portas PON" está indisponível.',
        edit_title: 'Editar a VLAN {n}',
        onus_title: 'Ver as ONUs da VLAN {n}',
        sort_by: 'Ordenar por {c}',
        flag_on: 'Sim',
        flag_off: 'Não',
        local_only: 'Metadado local, ainda não aplicado na OLT.',
        l2l_applied_note: 'Aplicado na OLT ao salvar: a VLAN é vinculada ao perfil de serviço OLTM_L2L (user-bridging).',
        l2l_risk: 'Atenção: com LAN-to-LAN, clientes diferentes desta VLAN passam a se enxergar na camada 2 (ARP/DHCP falsos, varredura, mais broadcast). Não ligue em VLAN compartilhada por todos os clientes — use uma VLAN exclusiva.',
        l2l_confirm: '{n} ONU(s) desta VLAN passarão a se enxergar. Aplicar na OLT?',
        l2l_live_checking: 'Lendo o estado na OLT…',
        l2l_live_on: 'Na OLT: LAN-to-LAN ativo (perfil {p}).',
        l2l_live_off: 'Na OLT: LAN-to-LAN desativado.',
        l2l_live_error: 'Não foi possível ler o estado na OLT: {e}',
        l2l_live_drift: 'O estado na OLT difere do salvo no OLTM. Salvar reaplica o estado escolhido.',
        l2l_live_foreign: 'A VLAN usa um perfil de serviço que não é do OLTM ({p}); o OLTM não o altera.',
        l2l_result_on: 'LAN-to-LAN ligado na OLT (confirmado por leitura).',
        l2l_result_off: 'LAN-to-LAN desligado na OLT (confirmado por leitura).',
        l2l_result_nochange: 'A OLT já estava assim — nada foi escrito.',
        l2l_result_diverged: 'A OLT não confirmou o LAN-to-LAN pedido — confira o estado real.',
        edit: 'Editar',
        delete: 'Excluir',
        delete_confirm: 'Excluir esta VLAN?',
        delete_confirm_used: 'Em uso por {n} ONU(s) — excluir?',
        delete_ok: 'VLAN {n} excluída.',
        delete_fail: 'Falha ao excluir a VLAN {n} na OLT.',
        batch_title: 'Excluir múltiplas VLANs',
        batch_label: 'VLAN ID(s) a excluir',
        batch_placeholder: 'ex: 300 ou 300-305 ou 300,302,305',
        batch_hint: 'Um ID, uma faixa (100-105) ou uma lista separada por vírgulas. Cada VLAN é removida da OLT (undo vlan).',
        batch_invalid: 'Use apenas números de 1 a 4 dígitos separados por vírgula ou hífen (ex.: 100,102-105).',
        batch_confirm: 'Excluir estas VLANs da OLT?',
        batch_yes: 'Excluir',
        batch_no: 'Cancelar',
        batch_close: 'Fechar',
        batch_running: 'Excluindo…',
        batch_summary: '{ok} excluída(s), {fail} com falha.',
        batch_result_ok: 'excluída',
        batch_result_fail: 'falhou',
        batch_error: 'Falha ao excluir as VLANs na OLT.',
        edit_page_title: 'Editar VLAN',
        edit_load_error: 'Não foi possível carregar a VLAN.',
        edit_not_found: 'VLAN não encontrada nesta OLT.',
        field_vlan_id: 'VLAN-ID',
        field_description: 'Descrição',
        field_description_hint: 'Deixe vazio para remover a descrição da VLAN.',
        description_olt_warn: 'A descrição alterada será gravada na OLT ao salvar (vlan desc).',
        field_iptv: 'VLAN multicast, usada para IPTV',
        field_mgmt: 'VLAN de gerenciamento/VoIP',
        field_dhcp: 'DHCP Snooping na VLAN',
        field_lan2lan: 'Habilitar comunicação direta entre ONUs nesta VLAN (LAN para LAN)',
        flags_operator_note: 'IPTV e Gestão/VoIP estão definidos manualmente; o poll não os sobrescreve.',
        flags_revert: 'Voltar ao valor da OLT',
        flags_revert_hint: 'IPTV e Gestão/VoIP voltam a ser lidos da OLT. O próximo poll repõe os valores dela.',
        flags_revert_pending: 'Ao salvar, IPTV e Gestão/VoIP voltam a seguir a OLT.',
        flags_revert_undo: 'Desfazer',
        pon_block_title: 'Portas PON em que esta VLAN pode ser usada',
        pon_hint: 'Tudo marcado por padrão. Desmarcar uma PON impede usar esta VLAN nela em novas autorizações e configurações; o que já existe não muda.',
        pon_show: 'Mostrar portas PON',
        pon_hide: 'Ocultar portas PON',
        pon_total: '{c}/{t} PONs marcadas',
        pon_board: 'Placa {n}',
        pon_board_count: '{c}/{t}',
        pon_check_slot: 'marcar todas',
        pon_uncheck_slot: 'desmarcar todas',
        pon_check_all: 'Marcar todas as PONs da OLT',
        pon_none_selected: 'Nenhuma PON marcada — esta VLAN não poderá ser usada em nenhuma porta.',
        pon_empty: 'A OLT não tem portas PON cadastradas.',
        pon_edit_load_error: 'Não foi possível carregar as portas PON desta OLT.',
        save: 'Salvar',
        saving: 'Salvando…',
        cancel: 'Cancelar',
        save_confirm_none: 'Esta VLAN deixará de poder ser usada em qualquer PON. Salvar?',
        save_yes: 'Salvar',
        save_no: 'Voltar',
        save_ok: 'VLAN {n} salva.',
        save_nochange: 'Nada foi alterado.',
        save_fail: 'Falha ao salvar a VLAN {n}.',
        save_local_failed: 'A OLT foi alterada, mas o registro local da VLAN {n} falhou — repita a mesma operação para sincronizar.',
        back: 'Voltar às VLANs',
        filter_vlan_chip: 'VLAN {n} — todas as ONUs que a usam',
        filter_vlan_clear: 'Remover filtro de VLAN',
      },
      configured: {
        title: 'ONUs configuradas',
        sub: 'Todas as ONUs autorizadas da sua frota.',
        customer: 'Cliente',
        name: 'Nome',
        onu: 'ONU',
        type: 'Tipo',
        rx_signal: 'Sinal',
        uptime: 'Uptime',
        online: 'Online',
        offline: 'Offline',
        broken: 'Sinal crítico',
        high_signal: 'Sinal alto',
        serial_mac: 'SN / MAC',
        model: 'Modelo',
        zone: 'Zona',
        odb: 'ODB',
        vlan: 'VLAN',
        mode: 'B/R',
        bridge: 'Bridge',
        router: 'Router',
        voip: 'VoIP',
        tv: 'TV',
        voiptv: 'VoIP - TV',
        details: 'Visualizar',
        filter_status: 'Status',
        filter_zone: 'Zona',
        filter_odb: 'ODB',
        filter_model: 'Modelo',
        filter_mode: 'Modo',
        filter_all: 'Todos',
        columns: 'Colunas',
        no_results: 'Nenhuma ONU corresponde aos filtros.',
        not_authorized: 'Não autorizada pelo OLTM',
        mgmt_ip: 'IP de gestão',
        sw_version: 'Versão SW',
        distance: 'Distância',
        cto_port: 'Porta CTO',
        authorized_at: 'Data de autor.',
        load_more: 'Carregar mais',
        loading_more: 'Carregando mais…',
        end_of_list: 'Fim da lista',
      },
      graphs: {
        title: 'Gráficos',
        sub: 'Analytics de tráfego, PON, uplink e sinal.',
        tabs: ['OLT', 'Uplink', 'PON', 'Tráfego', 'Sinal'],
        panels: ['CPU / Memória', 'Temperatura', 'Throughput uplink', 'Potência óptica'],
        graphs_for: 'Gráficos para',
        olts: 'OLT',
        board: 'Placa',
        port: 'Porta',
        zone: 'Zona',
        cto: 'CTO (Divisor)',
        any: 'Qualquer',
        showing_for: 'Exibindo dados de',
      },
      diagnostics: {
        title: 'Diagnóstico',
        sub: 'Diagnóstico em massa para ONUs com problemas de sinal.',
        reboot_selected: 'Reiniciar selecionadas',
        resync_selected: 'Ressincronizar selecionadas',
        signal: 'Sinal',
        temp: 'Temp.',
        critical: 'Crítico',
        warning: 'Alerta',
      },
      onu_page: {
        back_to_list: 'Voltar para ONUs',
        not_found_title: 'ONU não encontrada',
        not_found_sub: 'Nenhuma ONU corresponde ao serial:',
        update_in: 'atualização em',
        olt: 'OLT',
        board: 'Placa',
        port: 'Porta',
        onu: 'ONU',
        gpon_channel: 'Canal GPON',
        sn: 'SN',
        onu_type: 'Tipo ONU',
        auth_preset: 'Predefinição de configuração',
        zone: 'Zona',
        cto: 'CTO (Divisor)',
        name: 'Nome',
        onu_name: 'Nome da ONU',
        customer_name: 'Nome do cliente',
        address: 'Endereço',
        contact: 'Contato',
        auth_date: 'Data de autorização',
        history: 'Histórico',
        external_id: 'ID externo do ONU',
        section_client: 'Cliente',
        section_network_location: 'Localização na rede',
        section_status_signal: 'Status e sinal',
        section_network_config: 'Rede e configuração',
        online_since: 'Online desde',
        distance: 'Distância',
        status: 'Status',
        rx_signal: 'Sinal Rx ONU/OLT',
        tr069: 'TR069 Profile',
        mgmt_ip: 'IP de Gerenciamento',
        vlans: 'VLANs Anexados',
        onu_mode: 'Modo ONU',
        config_mode: 'Modo de configura...',
        pppoe_user: 'Nome de usuário P...',
        pppoe_pass: 'Senha PPPoE',
        get_status: 'Obter status',
        show_running_config: 'Mostrar configuração em execução',
        sw_info: 'Informações de SW',
        live: 'LIVE!',
        traffic_signal: 'Tráfego/Sinal',
        traffic: 'tráfego',
        signal: 'sinal',
        charts_section: 'Gráficos',
        chart_signal: 'Sinal óptico',
        chart_traffic: 'Tráfego',
        chart_last_24h: 'últimas 24h',
        download: 'Download',
        upload: 'Upload',
        download_short: 'Baixar',
        read_only: 'somente leitura',
        speed_profiles: 'Perfis de velocidade',
        service_port_id: 'ID de porta de serviço',
        user_vlan: 'VLAN do Usuário',
        action: 'Ação',
        configure: 'Configurar',
        manage_service_port: 'Assumir gestão',
        sp_load_error: 'Falha ao ler service-ports da OLT',
        retry: 'Tentar novamente',
        ethernet_ports: 'Portas Ethernet',
        port_col: 'Porta',
        admin_state: 'Estado administrativo',
        mode: 'Modo',
        dhcp: 'DHCP',
        enabled: 'Habilitado',
        no_control: 'No control',
        voip_service: 'Serviço VoIP',
        sip_profile: 'Perfil SIP',
        number: 'Número',
        enable: 'Enable',
        disable: 'Disable',
        not_defined: 'Não definido',
        catv: 'CATV',
        enable_catv: 'Habilitar CATV',
        catv_unsupported: 'Não suportado pelo Tipo de ONU',
        reboot: 'Reiniciar',
        resync_config: 'Ressincronizar configuração',
        restore_defaults: 'Restaurar padrões',
        disable_onu: 'Desabilitar ONU',
        enable_onu: 'Reautorizar ONU',
        delete_onu: 'Excluir',
        confirm_prompt: 'Tem certeza?',
        confirm_yes: 'Sim',
        confirm_no: 'Não',
        move_onu_title: 'Mover ONU',
        move: 'Mover',
        close: 'Fechar',
        update_gpon_title: 'Atualizar canal GPON',
        update: 'Atualizar',
        gpon_info_1: 'SmartOLT aloca IDs de ONU da faixa 0-127 para o canal GPON e da faixa 128-255 para os canais XG/XGS-PON.',
        gpon_info_2: 'Uma vez que a faixa 128-255 está esgotada, aloca da faixa 0-127 para os canais GPON e XG/XGS-PON.',
        gpon_info_3: 'Dica: ONUs compatíveis com XGPON que foram previamente autorizados no canal GPON devem ser alterados para o canal XGPON para liberar IDs para os ONUs GPON.',
        replace_sn_title: 'Substituir ONU por SN',
        replace: 'Substituir',
        sn_helper: 'Use a lupa para pesquisar na lista de não configurados para este PON',
        location_title: 'Atualizar detalhes de localização',
        cto_port: 'Porta do CTO',
        address_full: 'Endereço ou comentário',
        latitude: 'Latitude',
        longitude: 'Longitude',
        map: 'Mapa',
        ext_id_title: 'Atualizar ID externo do ONU',
        ext_id_helper: 'Sua referência para esta ONU em sistemas de API ou faturamento (contrato, ERP…). Fica guardada só no OLTM — não é enviada à OLT. Deixe vazio para voltar ao padrão (o serial). Máx. 255 caracteres.',
        type_title: 'Trocar tipo de ONU',
        type_select: 'Tipo de ONU',
        type_placeholder: 'Selecione um tipo…',
        type_scope_note: 'Só o vínculo no OLTM muda: o tipo define o rótulo e as capacidades exibidas (portas Ethernet, modo WAN, CATV). Nada é enviado à OLT e os perfis de linha/serviço da ONU no equipamento continuam os mesmos.',
        type_summary: (from, to) => (from ? `${from} → ${to}` : `Sem tipo → ${to}`),
        type_saved: 'Tipo de ONU atualizado',
        type_save_error: 'Falha ao trocar o tipo de ONU',
        type_load_error: 'Não foi possível carregar o catálogo de tipos de ONU.',
        type_edit: 'Trocar',
        eth_modes_note: 'Os modos Hybrid, Trunk e o controle de DHCP não estão disponíveis: o comando da OLT Huawei ("ont port vlan") só aceita Acesso e Transparente.',
        mgmt_title: 'IP de gerenciamento e TR-069 (somente leitura)',
        tr069_profile_title: 'Perfil TR069',
        tr069_profile: 'Perfil TR069',
        mgmt_ip_title: 'IP de Gerenciamento',
        mgmt_ip_mode: 'Modo de IP de gerenciamento',
        mgmt_inactive: 'Inativo',
        mgmt_static: 'IP estático',
        disabled: 'Desabilitado',
        voip_enabled_switch: 'Habilitado (interruptor geral)',
        voip_attach: 'Anexar VoIP a',
        voip_hint: 'Após habilitar o serviço VoIP, vá para as configurações de portas VoIP e atribua números de telefone VoIP conforme desejado.',
      },
      autoTasks: AUTO_TASKS_I18N.pt,
      fh: FIBERHOME_I18N.pt,
      onuLifecycle: ONU_LIFECYCLE_I18N.pt,
      reportsPon: REPORTS_PON_I18N.pt,
      ponDetail: PON_DETAIL_I18N.pt,
      reportsRbac: REPORTS_RBAC_I18N.pt,
      reportsTopology: REPORTS_TOPOLOGY_I18N.pt,
      tasks: {
        title: 'Tarefas',
        sub: 'Histórico e monitoramento de operações executadas.',
        task_id: 'ID da tarefa',
        action: 'Ação',
        actions: ['Reiniciar ONU', 'Provisionar', 'Ressincronizar', 'Alterar VLAN', 'Aplicar preset', 'Restaurar padrões'],
        statuses: { completed: 'Concluída', failed: 'Falhou', running: 'Em execução' },
      },
      settings: {
        title: 'Configurações',
        sub: 'Configuração de sistema, rede e conta.',
        sidebar: {
          general: 'Geral',
          users: 'Usuários',
          api_keys: 'Chaves de API',
          integrations: 'Integrações',
          billing: 'Faturamento',
          zones: 'Zonas',
          odbs: 'ODBs / Splitters',
          onu_types: 'Tipos de ONU',
          olt_types: 'Tipos de OLT',
          speed_profiles: 'Perfis de velocidade',
          olts: 'OLTs',
          auth_presets: 'Presets de autorização',
          audit_log: 'Log de auditoria',
        },
        brand: {
          title: 'Marca (white-label)',
          sub: 'Exibida no cabeçalho, rodapé e tela de login.',
          preview: 'Prévia',
          company_name: 'Nome da empresa',
          logo_hint: 'Logo · PNG/SVG · máx 400KB',
          upload: 'Enviar logo',
          remove: 'Remover',
          saved_local: 'Salvo localmente neste navegador. As alterações são aplicadas imediatamente.',
        },
        general_fields: ['Nome da empresa', 'Fuso horário', 'Idioma', 'Moeda', 'Timeout de sessão', 'E-mail de notificações'],
        users: {
          title: 'Usuários',
          sub: 'Gerencie sua equipe, cargos, 2FA e notificações por usuário.',
          invite: 'Convidar',
          new_user: 'Novo usuário',
          search: 'Buscar por nome ou e-mail…',
          columns: { user: 'Usuário', role: 'Cargo', two_fa: '2FA', status: 'Status', last: 'Último acesso' },
          enabled: 'Ativo',
          off: 'Desligado',
          active: 'ativo',
          invited: 'convidado',
          suspended: 'suspenso',
        },
        api_keys: {
          title: 'Chaves de API',
          sub: 'Acesso programático ao seu OLT Manager. Rotacione regularmente e escopo por permissão.',
          generate: 'Gerar chave',
          active_keys: 'Chaves ativas',
          reqs_min: 'Requisições / min',
          rate_limit: 'Limite de taxa',
          rotate: 'Rotacionar',
          revoke: 'Revogar',
          created: 'Criada',
          last_used: 'Último uso',
        },
        integrations: {
          title: 'Integrações',
          sub: 'Servidores MCP que operam o OLT Manager com as permissões da conta dona da chave.',
          tabs: { servers: 'Servidores MCP', api_keys: 'Chaves de API', erps: 'ERPs' },
          servers: {
            title: 'Servidores MCP',
            sub: 'Um agente com uma chave vinculada opera o OLT Manager como um operador humano — pelas mesmas rotas REST, com o mesmo RBAC. Os escopos abaixo só subtraem do teto da conta; nunca ampliam.',
            create: 'Registrar servidor',
            empty: 'Nenhum servidor MCP registrado ainda.',
            loading: 'Carregando…',
            load_error: 'Falha ao carregar os servidores MCP.',
            view_cards: 'Cards',
            view_table: 'Tabela',
            col_server: 'Servidor',
            col_owner: 'Conta',
            col_scopes: 'Escopos',
            col_health: 'Saúde',
            col_activity: 'Atividade 24h (cham. / erros / negadas)',
            enabled: 'Habilitado',
            disabled: 'Desabilitado',
            never_seen: 'nunca visto',
            system_badge: 'Gerenciado pelo sistema',
            system_hint: 'Este servidor MCP e sua chave são criados e mantidos automaticamente pela instância. Não pode ser removido.',
            detail: 'Detalhe',
            edit: 'Editar',
            badge_read_only: 'somente leitura',
            badge_no_dangerous: 'sem perigosas',
            badge_no_generic: 'sem oltm_rest',
            badge_categories: (n) => `${n} categoria${n === 1 ? '' : 's'}`,
            badge_capture: 'grava resposta',
            badge_full: 'acesso pleno da conta',
          },
          form: {
            create_title: 'Registrar servidor MCP',
            edit_title: 'Editar servidor MCP',
            created_title: 'Servidor registrado',
            name: 'Nome',
            name_ph: 'mcp-operacao',
            description: 'Descrição',
            description_ph: 'Para quê este servidor MCP é usado',
            enabled: 'Servidor habilitado',
            scopes_legend: 'Escopos (só subtraem do RBAC da conta)',
            read_only: 'Somente leitura (apenas requisições GET)',
            allow_dangerous: 'Permitir ações perigosas (DELETE, rotas destrutivas)',
            allow_generic: 'Permitir oltm_rest (escape hatch somente-GET)',
            capture_response: 'Gravar amostra da resposta',
            capture_response_hint: 'grava os primeiros 4 KiB de cada resposta no log — pode conter dados sensíveis.',
            category_allowlist: 'Allowlist de categorias (vazio = todas)',
            rate_limit: 'Rate limit (requisições por minuto)',
            mint_key: 'Cunhar chave agora (mostrada uma única vez)',
            cancel: 'Cancelar',
            save: 'Salvar',
            create: 'Registrar',
            saving: 'Salvando…',
            finish: 'Concluir',
            name_required: 'O nome é obrigatório.',
            created_ok: (n) => `O servidor "${n}" foi registrado.`,
          },
          key_block: {
            label: 'Chave da conta (oltmk_…) — vai no header X-API-Key do processo MCP. Copie agora, não será mostrada de novo:',
            copy: 'Copiar',
            copied: 'Copiado',
          },
          detail: {
            title: 'Servidor MCP',
            loading: 'Carregando…',
            load_error: 'Falha ao carregar o servidor.',
            scopes: 'Escopos',
            all_categories: 'todas as categorias',
            rate_limit_label: (rl) => `rate limit ${rl}/min`,
            activity_24h: (c, e, d) => `24h: ${c} chamadas · ${e} erros · ${d} negadas por RBAC`,
            linked_keys: 'Chaves vinculadas',
            no_keys: 'Nenhuma chave vinculada.',
            key_never_used: 'nunca usada',
            key_used: (rel) => `usada ${rel}`,
            revoke: 'Revogar',
            mint_ph: 'Nome da nova chave',
            mint: 'Cunhar nova',
            delete_title: 'Excluir servidor',
            delete_hint: 'Remove só o registro. As chaves vinculadas continuam válidas com o RBAC da conta (ficam órfãs) — revogue-as antes se quiser cortar o acesso.',
            delete: 'Excluir servidor',
            delete_confirm: 'Excluir?',
            close: 'Fechar',
          },
          connect: {
            title: 'Conexão (.mcp.json)',
            host_label: 'Host do servidor MCP',
            host_hint: 'Endereço onde o processo oltm-mcp-server está publicado (a Sessão 08 fecha o compose).',
            note: 'O Bearer aqui é o MCP_AUTH_TOKEN — segredo do próprio processo MCP. A chave oltmk_ da conta vai em OLTM_API_KEY / X-API-Key no processo, não aqui.',
            copy: 'Copiar',
            copied: 'Copiado',
          },
          about: {
            title: 'Sobre / Como conectar',
            sub: 'Um agente com uma chave de API do OLT Manager opera a instância inteira como um operador humano — pelas mesmas rotas REST, com o mesmo RBAC.',
            security_title: 'Modelo de segurança',
            security: [
              'A chave é a conta: resolve para um usuário real e herda exatamente as permissões dele.',
              'O RBAC é o teto. O backend é o único ponto de enforcement (RequirePermission por rota) — igual para agente e humano, e agora bloqueia de verdade para chaves.',
              'Os escopos do servidor só subtraem (somente leitura, sem perigosas, allowlist de categorias). Nunca ampliam o que a chave já pode.',
              'O log é no backend, no ramo de auth por chave — captura tudo, mesmo chamadas por curl. Os headers X-MCP-Server/X-MCP-Tool só enriquecem, nunca são confiança.',
            ],
            retention_title: 'Retenção, redação e limites',
            retention: [
              'Log retido por 90 dias (MCP_LOG_RETENTION_DAYS), limpeza por loop de background.',
              'Corpo da requisição gravado com chaves sensíveis mascaradas (password, secret, token, *_hash…) e truncado a 8 KiB. A resposta não é gravada — só status e tamanho; um modo opt-in por servidor grava os primeiros 4 KiB.',
              'Rate limit por chave (padrão 120 req/min), configurável por servidor.',
              'Design stateless: sem session id, sem push do servidor.',
            ],
            practices_title: 'Boas práticas',
            practices: [
              'Um usuário/grupo dedicado por MCP, com o mínimo de permissões.',
              'read_only para agentes de análise.',
              'Revisar Relatórios → Uso de Integrações → Negações por permissão para ver onde o agente esbarra no RBAC.',
            ],
            limits_title: 'Limitações conhecidas',
            limits: [
              'Uploads binários (fotos de equipamento, backup como arquivo) não são expostos via MCP.',
              'A sessão SSH interativa da OLT não é exposta (é WS/stream, não REST).',
              'oltm_rest (escape hatch para rotas não mapeadas) é somente-GET.',
            ],
            reference: 'Referência: docs/ApiMcpOLTm/ (00-VISAO-GERAL.md §7) e o README do oltm-mcp-server.',
          },
          erps: {
            title: 'ERPs',
            coming_soon: 'Em breve',
            banner: 'As integrações com ERPs estão em desenvolvimento. Abaixo, os sistemas que planejamos suportar. Marque interesse para ser avisado quando ficar pronto.',
            interest: 'Tenho interesse',
            interest_done: 'Interesse registrado',
            interest_ok: 'Interesse registrado — avisaremos quando a integração ficar pronta.',
            interest_err: 'Não foi possível registrar seu interesse. Tente novamente.',
            items: {
              ixc: 'ERP/ISP mais usado no Brasil — clientes, contratos, financeiro e OS.',
              sgp: 'Sistema de Gestão de Provedores — cobrança, clientes e suporte.',
              voalle: 'Plataforma de gestão e automação para provedores.',
              hubsoft: 'ERP para ISPs — atendimento, financeiro e provisionamento.',
              mk_auth: 'Gerência de provedor e Radius (legado, ainda comum).',
              routerbox: 'ERP/ISP — clientes, financeiro e monitoramento.',
              topsapp: 'Gestão para provedores de pequeno e médio porte.',
              ispbox: 'Suíte de gestão para ISP.',
              synsuite: 'ERP/CRM para telecom.',
              uzzysoft: 'Gestão e cobrança para provedores.',
              radius_generico: 'Integração via RADIUS/API para provisionamento.',
              webhook_generico: 'Notificações de eventos (ONU autorizada, queda de PON) para qualquer sistema.',
            },
          },
          errors: {
            create_failed: 'Falha ao registrar o servidor MCP.',
            update_failed: 'Falha ao salvar o servidor MCP.',
            delete_failed: 'Falha ao excluir o servidor.',
            mint_failed: 'Falha ao cunhar a chave.',
            revoke_failed: 'Falha ao revogar a chave.',
          },
        },
        billing: {
          title: 'Faturamento',
          sub: 'Status de licenciamento das suas OLTs.',
          sync: 'Sincronizar',
          sync_success: 'Status de licenciamento sincronizado',
          sync_error: 'Falha ao sincronizar licenciamento',
          olt_licenses: 'Licenças por OLT',
          loading: 'Carregando...',
          no_olts: 'Nenhuma OLT cadastrada',
          expires: 'Expira em',
          no_expiry: 'Sem data de expiração',
          status_none: 'sem licença',
          renew: 'Renovar',
          checkout_started: 'Checkout iniciado',
          checkout_error: 'Falha ao iniciar checkout',
          col_id: 'OLT ID',
          col_name: 'Nome do OLT',
          col_status: 'Status da assinatura',
          col_expires_at: 'Data de término da assinatura (inclusive)',
          payment_options: 'Ver opções de pagamento',
          portal_error: 'Falha ao abrir o portal de pagamento',
          invoices_title: 'Faturas',
          invoices_empty: 'Nenhum pagamento registrado ainda.',
          col_inv_date: 'Data',
          col_inv_desc: 'Descrição',
          col_inv_olts: 'OLTs',
          col_inv_gateway: 'Pago com',
          col_inv_amount: 'Valor',
          col_inv_status: 'Status',
          pay_status_approved: 'aprovado',
          pay_status_pending: 'pendente',
          pay_status_rejected: 'rejeitado',
          pay_status_refunded: 'reembolsado',
          pay_status_expired: 'expirado',
          pay_status_canceled: 'cancelado',
          choose_gateway: 'Escolha a forma de pagamento',
          gateway_default: 'padrão',
          pix_title: 'Pagamento via PIX',
          pix_instructions: 'Escaneie o QR code ou copie o código abaixo no app do seu banco.',
          pix_copy: 'Copiar código PIX',
          pix_copied: 'Código copiado',
          close: 'Fechar',
          cancel: 'Cancelar',
        },
        zones: {
          title: 'Zonas',
          sub: 'Agrupe OLTs e ONUs por áreas geográficas ou lógicas de cobertura.',
          new_zone: 'Nova zona',
          coverage: 'Cobertura',
        },
        odbs: {
          title: 'ODBs (NAPs, CTOs) / Splitters',
          sub: 'Gerencie caixas de distribuição, capacidade dos splitters e ONUs conectadas.',
          map_view: 'Ver no mapa',
          new_odb: 'Adicionar CTO (Divisor)',
          search: 'Buscar por nome…',
          occupancy: 'Ocupação',
          occupancy_filter_all: 'Todas ocupações',
          occupancy_filter_50: '≥ 50% ocupado',
          occupancy_filter_75: '≥ 75% ocupado',
          occupancy_filter_90: '≥ 90% ocupado',
          occupancy_filter_exceeded: 'Capacidade excedida',
          delete_selected: 'Excluir selecionados',
          export: 'Exportar',
          import: 'Importar',
          stat_total: 'Total ODBs',
          stat_ports: 'Total portas',
          stat_used: 'Portas usadas',
          stat_free: 'Portas livres',
        },
        onu_types: {
          title: 'Tipos de ONU',
          sub: 'Modelos de ONU suportados por fabricante — capabilities, perfis de serviço e padrões.',
          register: 'Cadastrar modelo',
          auto_approved: 'Aprovação automática',
          configure: 'Configurar',
          import_catalog: 'Importar do catálogo central',
        },
        olt_types: {
          title: 'Tipos de OLT',
          sub: 'Modelos de OLT cadastrados — metadado complementar, não substitui o fabricante/versão de hardware da OLT.',
          register: 'Cadastrar modelo',
          import_catalog: 'Importar do catálogo central',
        },
        speed_profiles: {
          title: 'Perfis de velocidade',
          sub: 'Templates de traffic shaping aplicados aos service ports. Separado por download e upload.',
          download: 'Download',
          upload: 'Upload',
          download_profiles: 'Perfis de download',
          upload_profiles: 'Perfis de upload',
          burst: 'Burst',
          standard: 'Padrão',
          high: 'Alto',
          is_default_badge: 'Perfil padrão',
          set_default: 'Usar como padrão',
          default_hint: 'Aplicado automaticamente a equipamentos autorizados sem um perfil selecionado.',
          edit: 'Editar',
        },
        olts: {
          title: 'OLTs',
          sub: 'Cadastre e gerencie terminais de linha óptica. Configure IP, credenciais, portas e padrões.',
          register: 'Cadastrar OLT',
          onus: 'ONUs',
          temp: 'Temp',
          uptime: 'Uptime',
          pon_ports: 'Portas PON em uso',
          polled: 'consultada há 12s',
          manage: 'Gerenciar',
          online: 'Online',
          warning: 'Alerta',
          overheating: 'Superaquecendo',
        },
        auth_presets: {
          title: 'Presets de autorização',
          sub: 'Templates que autorizam ONUs entrantes com o VLAN, velocidade e WiFi corretos.',
          new_preset: 'Novo preset',
          default: 'Padrão',
          vlan: 'VLAN',
          applied_to: 'Aplicado a',
          onus_suffix: 'ONUs',
          wizard_title: 'Criar preset — assistente',
          step_of: 'Passo {a} de {b}',
          steps: [
            { label: 'Básico', desc: 'Nome, fabricante e descrição' },
            { label: 'Condições', desc: 'Quando aplicar este preset' },
            { label: 'Config ONU', desc: 'VLAN, service ports, ETH' },
            { label: 'TR069 & Mgmt', desc: 'Perfil de gerenciamento e TR069' },
            { label: 'WiFi', desc: 'SSID, senha, rádios' },
            { label: 'Revisão', desc: 'Confirmar e ativar' },
          ],
          activate: 'Ativar preset',
        },
        audit_log: {
          title: 'Log de auditoria',
          sub: 'Toda ação sensível no tenant — quem, o quê, quando e onde.',
          filter: 'Filtrar',
          export: 'Exportar CSV',
          search: 'Buscar autor, ação ou alvo…',
          tones: { ok: 'ok', critical: 'crítico', warning: 'alerta', security: 'segurança', info: 'info' },
        },
      },
      time: {
        min_ago: (n) => `há ${n} min`,
        hour_ago: (n) => `há ${n} ${n === 1 ? 'hora' : 'horas'}`,
        day_ago: (n) => `há ${n} ${n === 1 ? 'dia' : 'dias'}`,
        days: (n) => `${n} dias`,
        yesterday: 'ontem',
        two_days_ago: 'há 2 dias',
        auth: 'autorizada',
        reboot: 'Reinício',
      },
      reports: {
        common: {
          refresh: 'Atualizar',
          export_csv: 'Exportar CSV',
          export: 'Exportar',
          export_xlsx: 'Planilha (.xlsx)',
          export_print: 'Imprimir / PDF',
          loading: 'Carregando…',
          load_failed: 'Falha ao carregar o relatório',
          all_olts: 'Todas as OLTs',
          all_zones: 'Todas as zonas',
          all_statuses: 'Todos os status',
          view: 'Ver',
          olt: 'OLT',
          customer: 'Cliente',
          zone: 'Zona',
          manufacturer: 'Fabricante',
          status: 'Status',
          uptime: 'Uptime',
          temperature: 'Temperatura',
          last_poll: 'Última coleta',
          back_to_hub: 'Central de Relatórios',
          custom_period: 'Personalizado',
          none_registered_olt: 'Nenhuma OLT cadastrada.',
        },
        status_labels: {
          online: 'Online', high_signal: 'Sinal alto', broken: 'Sinal crítico',
          offline: 'Offline', unknown: 'Desconhecido',
        },
        hub: {
          title: 'Central de Relatórios',
          subtitle: 'Escolha um relatório para visualizar, filtrar e exportar os dados da sua operação — agrupados por área.',
          coming_soon: 'Em breve',
          groups: {
            maps: { title: 'Mapas & Topologia', subtitle: 'Visualização geográfica e hierárquica da rede' },
            onus: { title: 'Relatórios de ONUs', subtitle: 'Inventário, sinal e consumo dos clientes conectados' },
            olts: { title: 'Relatórios de OLTs & Rede', subtitle: 'Saúde, disponibilidade e desempenho dos equipamentos' },
            field: { title: 'Infraestrutura de Campo', subtitle: 'Caixas, CTOs e distribuição física da rede' },
            admin: { title: 'Administrativo & Auditoria', subtitle: 'Rastreabilidade de ações e conformidade do sistema' },
            finance: { title: 'Financeiro & Comercial', subtitle: 'Faturamento, licenciamento e consumo por cliente' },
          },
          cards: {
            topology: { title: 'Topologia da OLT', desc: 'Árvore visual OLT → placas → portas PON → splitters → ONUs, com status em tempo real.' },
            map: { title: 'Mapa geográfico da rede', desc: 'OLTs, caixas e CTOs geolocalizados em mapa, com status e cobertura por região.' },
            cto_occupancy: { title: 'Ocupação de CTOs no mapa', desc: 'Densidade de ocupação das caixas de atendimento visualizada geograficamente.' },
            pon_diagram: { title: 'Diagrama de portas PON', desc: 'Matriz slot × porta por OLT, cada porta colorida pela ocupação — visão visual da frota.' },
            inventory: { title: 'Inventário de ONUs', desc: 'Lista completa de ONUs autorizadas, com status, sinal e dados de provisionamento.' },
            signal_quality: { title: 'Qualidade de sinal', desc: 'Distribuição de sinal óptico (Rx) e destaque das ONUs fora da faixa aceitável.' },
            traffic_summary: { title: 'Resumo de tráfego', desc: 'Consumo de banda por ONU nas últimas 24h — atual e pico.' },
            onu_models: { title: 'ONUs por tipo/fabricante', desc: 'Distribuição do parque de ONUs por modelo e fabricante, útil para compras e suporte.' },
            onu_swaps: { title: 'Histórico de trocas de ONU', desc: 'Registro de substituições de equipamento por cliente ao longo do tempo.' },
            speed_plans: { title: 'Clientes por plano de velocidade', desc: 'Quantidade de assinantes agrupados por perfil de banda contratado.' },
            olt_overview: { title: 'Resumo de OLTs', desc: 'Visão gerencial da frota (status, uptime, temperatura) e tendência de autorizações.' },
            pon_outages: { title: 'Quedas por porta PON', desc: 'Interrupções afetando várias ONUs na mesma porta PON simultaneamente.' },
            poll_history: { title: 'Coleta SNMP/SSH (poll)', desc: 'Status e histórico dos ciclos de coleta de uma OLT — dispare um poll imediato.' },
            hardware_health: { title: 'Saúde de hardware', desc: 'Temperatura, alimentação e status de placas ao longo do tempo, com alertas de tendência.' },
            uptime: { title: 'Disponibilidade (uptime)', desc: 'Percentual de disponibilidade de cada OLT no período, para SLA e relatórios gerenciais.' },
            pon_capacity: { title: 'Ocupação de portas PON', desc: 'Capacidade utilizada versus disponível em cada porta PON de cada OLT.' },
            field_boxes: { title: 'Inventário de caixas (CTO/CEO)', desc: 'Lista de caixas cadastradas, capacidade e vínculo com portas PON.' },
            box_occupancy: { title: 'Ocupação de caixas', desc: 'Portas livres versus ocupadas por caixa, para planejar expansão.' },
            splitters: { title: 'Splitters e perdas ópticas', desc: 'Mapeamento de splitters por nível e estimativa de perda no trajeto óptico.' },
            audit_export: { title: 'Exportar auditoria', desc: 'Log de ações administrativas do sistema, filtrável e exportável.' },
            external_changes: { title: 'Mudanças externas', desc: 'Alterações feitas direto na OLT (fora do sistema) detectadas pela coleta.' },
            rbac: { title: 'Usuários e permissões', desc: 'Relatório de usuários, grupos e permissões efetivas no sistema (RBAC).' },
            bulk_jobs: { title: 'Log de tarefas em lote', desc: 'Histórico de execuções de ações em massa sobre ONUs e OLTs.' },
            backups: { title: 'Conformidade & backups', desc: 'Status dos backups automáticos de configuração das OLTs.' },
            mcp_usage: { title: 'Uso de Integrações / MCP', desc: 'Chamadas de API por chave/servidor MCP, latência, erros e permissões negadas.' },
            cli_audit: { title: 'Comandos das OLTs', desc: 'Backlog de todo comando CLI dado às OLTs: quem pediu, quando, a resposta e se deu erro.' },
            billing_olts: { title: 'Faturamento por OLT', desc: 'Consumo de licenças e cobrança por OLT contratada no plano SaaS.' },
            payments: { title: 'Pagamentos e assinaturas', desc: 'Histórico de pagamentos, métodos e status das faturas do provedor.' },
            customer_consumption: { title: 'Consumo por cliente', desc: 'Uso de banda agregado por cliente, útil para políticas de fair use.' },
          },
        },
        mcp_usage_page: {
          title: 'Uso de Integrações / MCP',
          subtitle: 'Chamadas de API por chave e servidor MCP: volume, latência, erros e permissões negadas. Tudo vem do log do backend.',
          settings_link: 'Configurações › Integrações',
          win_24h: '24h', win_7d: '7d', win_30d: '30d',
          kpi_calls: 'Chamadas',
          kpi_error_rate: '% erro',
          kpi_denied_rate: '% negado',
          kpi_p50: 'Latência p50',
          kpi_p95: 'Latência p95',
          kpi_servers: 'Servidores ativos',
          kpi_keys_sub: (n) => `${n} chave(s) ativa(s)`,
          timeline_title: 'Linha do tempo de chamadas',
          timeline_hint: 'chamadas × erros no período',
          timeline_calls: 'Chamadas',
          timeline_errors: 'Erros',
          timeline_empty: 'Sem chamadas nesta janela.',
          top_tools_title: 'Top ferramentas',
          top_tools_hint: 'por volume de chamadas',
          top_tools_empty: 'Nenhuma ferramenta identificada (chamadas diretas via curl não enviam X-MCP-Tool).',
          top_routes_title: 'Top rotas',
          routes_empty: 'Nenhuma rota registrada nesta janela.',
          denials_title: 'Permissões negadas',
          denials_sub: 'O agente tentou uma ação e o RBAC da chave bloqueou.',
          denials_empty: 'Nenhuma permissão negada nesta janela — o RBAC das chaves cobriu tudo que os agentes tentaram.',
          denials_hint: (perm, n) => `Conceda \`${perm}\` ao grupo desta chave para destravar ~${n} tentativa(s)/dia.`,
          denials_hint_unknown: (n) => `A negação não veio de uma permissão do RBAC (ex.: escopo da chave sem escrita): confira o escopo da chave — ~${n} tentativa(s)/dia.`,
          outcomes_title: 'Distribuição por resultado',
          outcomes_empty: 'Sem dados de resultado nesta janela.',
          outcome_ok: 'OK', outcome_denied: 'Negado', outcome_error: 'Erro', outcome_not_found: 'Não encontrado',
          servers_title: 'Saúde por servidor',
          servers_empty: 'Nenhum servidor MCP registrado.',
          col_method: 'Método', col_route: 'Rota', col_perm: 'Permissão faltante', col_count: 'Tentativas',
          col_hint: 'Ação sugerida', col_tool: 'Ferramenta', col_calls: 'Chamadas',
          col_server: 'Servidor', col_last_seen: 'Última atividade', col_avg_ms: 'Latência média', col_rate_hits: 'Rate-limit (429)',
          empty_title: 'Nenhuma chamada de integração nesta janela',
          empty_body: 'Crie um servidor MCP em Configurações › Integrações e conecte um agente para começar a ver uso aqui.',
          empty_cta: 'Abrir Configurações › Integrações',
          never: 'nunca',
          footer: (win) => `Janela: ${win}. Retenção do log: 90 dias.`,
          sheet_kpis: 'KPIs', sheet_timeline: 'Linha do tempo', sheet_top_tools: 'Top ferramentas',
          sheet_top_routes: 'Top rotas', sheet_denials: 'Permissões negadas', sheet_outcomes: 'Resultados', sheet_servers: 'Servidores',
          csv_kpi_h: ['Métrica', 'Valor'],
          csv_timeline_h: ['Instante', 'Chamadas', 'Erros'],
          csv_top_tools_h: ['Ferramenta', 'Chamadas'],
          csv_top_routes_h: ['Método', 'Rota', 'Chamadas'],
          csv_denials_h: ['Método', 'Rota', 'Permissão faltante', 'Tentativas', 'Tentativas/dia'],
          csv_outcomes_h: ['Resultado', 'Chamadas'],
          csv_servers_h: ['Servidor', 'Última atividade', 'Latência média (ms)', 'Rate-limit (429)'],
        },
        cli_audit_page: {
          title: 'Comandos das OLTs',
          subtitle: 'Backlog de todo comando CLI dado às OLTs — coleta, operação, ações automáticas, backup e terminal. Contém dado sensível; segredos digitados como comando aparecem mascarados.',
          period_1h: '1 h', period_24h: '24 h', period_7d: '7 d', period_30d: '30 d', period_custom: 'Personalizado',
          custom_from: 'De', custom_to: 'Até', custom_apply: 'Aplicar',
          custom_invalid: 'Informe um início anterior ao fim.',
          custom_clamped: 'A API aceita no máximo 31 dias; o início foi ajustado.',
          window_label: 'Janela',
          olt_label: 'OLT', olt_all: 'Todas as OLTs', olt_none: 'Nenhuma OLT com comandos na janela.',
          origin_label: 'Origem', origin_all: 'Todas as origens',
          actor_label: 'Quem', actor_all: 'Todos', actor_users: 'Usuário específico', actor_types: 'Tipo de ator',
          status_label: 'Status', status_all: 'Todos os status',
          selected_n: (n) => `${n} selecionado(s)`,
          origin_groups: {
            collect: 'Coleta', operation: 'Operação', auto: 'Automática', backup: 'Backup',
            terminal: 'Terminal', unclassified: 'Não classificado', other: 'Outras',
          },
          origin_group_hints: {
            collect: 'poll:*, autofind, inventário', operation: 'MÉTODO /api/… (telas e API), lotes',
            auto: 'ações automáticas', backup: 'backup e restauração', terminal: 'terminal interativo',
            unclassified: 'caminho sem origem — investigar', other: 'origens não previstas',
          },
          origin_exact: 'Origem',
          actor_type_names: {
            user: 'Usuário', system: 'Sistema', auto_task: 'Ação automática', api_key: 'Chave de API', unknown: 'Desconhecido',
          },
          actor_auto_task: (id) => (id ? `Ação automática #${id}` : 'Ação automática'),
          status_names: {
            ok: 'OK', device_error: 'Erro do equipamento', timeout: 'Timeout', transport_error: 'Falha de transporte', canceled: 'Cancelado',
          },
          only_writes: 'Só escritas', only_errors: 'Só erros', show_bootstrap: 'Mostrar bootstrap',
          search_ph: 'Buscar no comando…', search_output: 'Na saída',
          search_output_warn: 'Buscar na saída não é indexado e é lento em janelas grandes (segundos em 7 dias ou mais).',
          min_duration: 'Duração ≥', min_ph: 'ms',
          clear_filters: 'Limpar filtros',
          facets_loading: 'Carregando opções…', facets_error: 'Não foi possível carregar as opções.',
          retry: 'Tentar de novo',
          chip_user: 'Usuário', chip_session: 'Sessão', chip_remove: 'Remover filtro',
          kpi_commands: 'Comandos', kpi_errors: 'Erros', kpi_writes: 'Escritas', kpi_p95: 'p95 de duração', kpi_sessions: 'Sessões',
          kpi_errors_sub: (pct) => `${pct} dos comandos`,
          kpi_hint_errors: 'Clique para ver só os erros',
          kpi_hint_writes: 'Clique para ver só as escritas',
          kpi_hint_p95: 'Clique para ver os comandos mais lentos que o p95',
          kpi_hint_commands: 'Clique para remover os filtros de erro/escrita/duração',
          kpi_error: 'Não foi possível carregar os indicadores.',
          timeline_title: 'Linha do tempo',
          timeline_hint: 'Clique numa barra (ou arraste) para restringir o período. Vermelho = erros.',
          timeline_empty: 'Sem comandos nesta janela.',
          tl_total: 'Comandos', tl_ok: 'Sem erro', tl_errors: 'Erros', tl_writes: 'Escritas',
          tl_bucket: (label) => `Barras de ${label}`,
          col_time: 'Hora', col_olt: 'OLT', col_who: 'Quem', col_origin: 'Origem', col_command: 'Comando',
          col_status: 'Status', col_duration: 'Duração', col_response: 'Resposta',
          write_badge: 'Escrita na OLT',
          system_label: 'Sistema',
          ago: (n, unit) => `há ${n} ${{ s: 's', min: 'min', h: 'h', d: 'd' }[unit]}`,
          filter_by: (what) => `Filtrar por ${what}`,
          session_title: (id, seq) => `Sessão ${id} · comando ${seq}`,
          bootstrap_row: 'bootstrap',
          interactive_row: 'terminal',
          redacted: 'segredo mascarado',
          loaded_n: (n) => `${n} comando(s) carregado(s)`,
          load_more: 'Carregar mais', loading_more: 'Carregando…', end_of_list: 'Fim da lista.',
          empty_title: 'Nenhum comando neste filtro',
          empty_body: 'Não há comandos na janela escolhida com estes filtros. Amplie o período, limpe os filtros ou marque "Mostrar bootstrap".',
          empty_no_data_title: 'Ainda não há comandos registrados',
          empty_no_data_body: 'Assim que uma coleta, operação ou terminal falar com uma OLT, o comando aparece aqui.',
          error_title: 'Não foi possível carregar os comandos',
          open_detail: 'Abrir detalhe',
          open_terminal: 'terminal',
          // ---- Fase 14: detalhe, ao vivo, export ----
          detail_title: (id) => `Comando #${id}`,
          detail_close: 'Fechar', detail_back: 'Voltar à lista',
          detail_error_title: 'Não foi possível carregar o comando',
          detail_not_found_title: 'Comando não encontrado',
          detail_not_found_body: 'O registro pode ter sido removido pela retenção (30 dias por padrão) ou não existir nesta conta.',
          copy: 'Copiar', copied: 'Copiado', copy_failed: 'Não foi possível copiar',
          detail_command: 'Comando', detail_response: 'Resposta',
          detail_when: 'Horário', detail_duration: 'Duração', detail_olt: 'OLT', detail_view: 'Modo / visão',
          detail_protocol: 'Protocolo', detail_kind: 'Tipo',
          kind_names: { command: 'comando', bootstrap: 'bootstrap', interactive: 'terminal' },
          response_empty: 'Nenhuma resposta registrada para este comando.',
          response_error_lines: (n) => `${n} linha(s) de erro do equipamento`,
          response_truncated: (shown, total) => `Resposta truncada: ${shown} de ${total} bytes`,
          response_masked: 'mascarado',
          response_masked_hint: 'Segredos aparecem como •••• (mascarados na captura).',
          detail_who: 'Quem / de onde',
          who_actor: 'Ator', who_ip: 'IP', who_request_id: 'Request ID', who_origin: 'Origem',
          who_auto_task: 'Ação automática', who_api_key: 'Chave de API', who_none: '—',
          open_auto_task: 'Abrir ação automática',
          detail_session: 'Sessão',
          session_pos: (pos, size) => `Comando ${pos} de ${size} nesta conexão`,
          session_prev: 'Comando anterior da sessão', session_next: 'Próximo comando da sessão',
          session_filter: 'Filtrar a lista por esta sessão',
          session_truncated: (n) => `Mostrando só os primeiros ${n} comandos da sessão.`,
          session_error: 'Não foi possível carregar a sessão.', session_loading: 'Carregando a sessão…',
          detail_links: 'Ligações',
          link_audit_log: 'Ver ação no log de auditoria',
          link_audit_log_hint: (email) => `Abre o log de auditoria buscando por ${email}. O log de auditoria não guarda o Request ID — use-o para cruzar com o inspetor de API.`,
          link_onu: (serial) => `Abrir ONU ${serial}`,
          link_onu_note: 'Serial lido do próprio comando (busca simples) e confirmado no cadastro de ONUs.',
          link_olt: 'Abrir OLT',
          shortcuts_title: 'Atalhos',
          shortcut_prev: 'comando anterior', shortcut_next: 'próximo comando', shortcut_close: 'fechar',
          live_label: 'Ao vivo',
          live_disabled_custom: 'O modo ao vivo vale só para períodos relativos (1 h a 30 d).',
          live_state_running: 'Ao vivo · a cada 5 s',
          live_state_scrolled: 'Pausado ao rolar a lista',
          live_state_detail: 'Pausado com o detalhe aberto',
          live_state_hidden: 'Aba oculta — sem consultas',
          live_state_error: (msg) => `Falha ao atualizar: ${msg}`,
          live_new_n: (n) => `${n} novo(s)`,
          live_received_n: (n) => `+${n} desde que ligou`,
          live_flush: 'Mostrar agora',
          live_gap: 'Chegaram comandos demais para mesclar — atualizar a lista',
          export_csv: 'Exportar CSV', export_running: 'Exportando…',
          export_confirm_title: 'Exportar com os filtros atuais?',
          export_confirm_body: (n, max) => (n == null
            ? `A janela é grande; o arquivo pode ter até ${max} linhas.`
            : `Cerca de ${n} comandos; o arquivo tem no máximo ${max} linhas.`),
          export_cut_warn: (max) => `Passa do limite: só os ${max} mais recentes serão exportados.`,
          export_include_output: 'Incluir a resposta do equipamento (arquivo bem maior)',
          export_go: 'Exportar', export_cancel: 'Cancelar',
          export_done: (name) => `CSV baixado: ${name}`,
          export_truncated: (rows, max) => `Exportação cortada no limite: ${rows} de mais de ${max} linhas. Restrinja o período ou os filtros.`,
          export_interrupted: 'A exportação foi interrompida no servidor — o arquivo está incompleto.',
          export_failed: (msg) => `Falha ao exportar: ${msg}`,
          link_commands: 'Comandos executados', link_commands_hint: 'Abre o relatório de comandos desta OLT nas últimas 24 h.',
        },
        inventory: {
          title: 'Inventário de ONUs',
          subtitle: 'Lista completa de ONUs autorizadas, com status, sinal e dados de provisionamento — filtre e exporte para análise externa.',
          search_ph: 'Serial, MAC ou cliente…',
          stat_total: 'Total no filtro', stat_online: 'Online', stat_critical: 'Sinal crítico', stat_offline: 'Offline',
          col_serial_mac: 'Serial / MAC', col_pon: 'PON', col_rx: 'Sinal RX', col_type: 'Tipo', col_vlan: 'VLAN', col_authorized_at: 'Autorizada em',
          empty: 'Nenhuma ONU encontrada com os filtros atuais.',
          csv_h: ['Status', 'Cliente', 'Serial', 'MAC', 'OLT', 'PON', 'Sinal RX (dBm)', 'Tipo', 'VLAN', 'Modo', 'Autorizada em'],
          mode_routing: 'Roteamento', mode_bridge: 'Bridge',
        },
        signal: {
          title: 'Qualidade de sinal',
          subtitle: 'Distribuição de sinal óptico (Rx) das ONUs online, com destaque para as que estão fora da faixa aceitável (muito fraco ou saturando o receptor).',
          stat_with_reading: 'ONUs com leitura', stat_avg: 'Sinal médio (dBm)', stat_best: 'Melhor sinal (dBm)', stat_worst: 'Pior sinal (dBm)',
          weak_title: 'Sinal crítico (fraco)', high_title: 'Sinal alto (saturando)',
          weak_empty: 'Nenhuma ONU com sinal crítico.', high_empty: 'Nenhuma ONU com sinal saturando.',
          csv_h: ['Motivo', 'Cliente', 'Serial', 'OLT', 'PON', 'Sinal RX (dBm)'],
          csv_reason_weak: 'Sinal crítico (fraco)', csv_reason_high: 'Sinal alto (saturando)',
        },
        traffic: {
          title: 'Resumo de tráfego',
          subtitle: 'Consumo de banda por ONU nas últimas 24h — atual e pico, ordenado pelas maiores consumidoras da rede.',
          load_failed: 'Falha ao carregar relatório de tráfego',
          fetch_failed: 'Falha ao carregar tráfego.',
          search_ph: 'Cliente ou dispositivo…',
          stat_count: 'ONUs no filtro', stat_dl_agg: 'Download atual agregado', stat_ul_agg: 'Upload atual agregado', stat_peak_dl: 'Maior pico (download)',
          truncated: (n) => `Lista limitada às primeiras ${n} ONUs para manter a página responsiva — refine o filtro de OLT para ver o restante.`,
          col_onu: 'ONU', col_device: 'Dispositivo', col_dl_cur: 'Download atual', col_ul_cur: 'Upload atual', col_dl_peak: 'Pico download', col_ul_peak: 'Pico upload',
          empty: 'Nenhuma ONU com tráfego nas últimas 24h.',
          csv_h: ['ONU', 'Dispositivo', 'Download atual (Mbps)', 'Upload atual (Mbps)', 'Pico download (Mbps)', 'Pico upload (Mbps)'],
        },
        pon_outages: {
          title: 'Quedas por porta PON',
          subtitle: 'Interrupções detectadas afetando várias ONUs na mesma porta PON simultaneamente — geralmente indica rompimento de fibra ou falha na porta/placa da OLT, não problema individual do cliente.',
          fetch_failed: 'Falha ao carregar quedas por porta PON.',
          badge_one: 'interrupção não confirmada', badge_many: 'interrupções não confirmadas',
          search_ph: 'OLT ou porta PON…',
          col_pon: 'Porta PON', col_affected: 'ONUs afetadas', col_cause: 'Causa provável', col_since: 'Desde',
          empty: 'Nenhuma interrupção de porta PON no momento.',
          csv_h: ['OLT', 'Porta PON', 'ONUs afetadas', 'ONUs no total', 'Causa provável', 'Desde'],
        },
        olt_overview: {
          title: 'Resumo de OLTs',
          subtitle: 'Visão gerencial da frota de OLTs (status, uptime, temperatura) e da tendência de crescimento de autorizações de ONU ao longo do tempo.',
          fetch_failed: 'Falha ao carregar resumo de OLTs.',
          chart_title: (n) => `Autorizações de ONU por dia — ${n} no período`,
          chart_series: 'Autorizações',
          search_ph: 'Nome da OLT ou fabricante…',
          empty: 'Nenhuma OLT cadastrada.',
          csv_h: ['OLT', 'Fabricante', 'Status', 'Uptime', 'Temperatura (°C)', 'Última coleta'],
        },
        poll_history: {
          title: 'Coleta SNMP/SSH (poll)',
          subtitle: 'Status e histórico dos ciclos de coleta (SNMP/SSH) de uma OLT — dispare um poll imediato ou acompanhe a duração e o resultado dos últimos ciclos agendados.',
          status_failed: 'Erro ao carregar status de coleta.',
          trigger_failed: 'Erro ao disparar coleta.',
          running: '● Poll em execução…',
          waiting: 'Aguardando próximo poll agendado',
          trigger: 'Disparar poll imediato', triggering: 'Disparando…',
          col_start: 'Início', col_duration: 'Duração', col_method: 'Método', col_boards: 'Placas', col_ports: 'Portas', col_onus: 'ONUs',
          empty: 'Sem histórico de coleta para esta OLT.',
          csv_h: ['Início', 'Duração (ms)', 'Método', 'Status', 'Placas', 'Portas', 'ONUs'],
        },
        models: {
          title: 'ONUs por tipo/fabricante',
          subtitle: 'Distribuição do parque de ONUs por modelo e fabricante — útil para compras e suporte. Clique num modelo na tabela para ver as ONUs.',
          fetch_failed: 'Falha ao carregar o parque de ONUs.',
          all_vendors: 'Todos os fabricantes',
          kpi_vendors: 'Fabricantes', kpi_models: 'Modelos', kpi_top_model: 'Modelo mais comum', kpi_top3: 'Top 3 modelos', kpi_no_type: 'Sem tipo identificado',
          loading: 'Carregando o parque de ONUs…',
          chart_treemap: 'Fabricante → modelo', chart_treemap_hint: 'área = nº de ONUs',
          chart_top15: 'Top 15 modelos', chart_top15_hint: 'empilhado por status',
          chart_empty: 'Sem ONUs no filtro.', onus: 'ONUs',
          col_vendor: 'Fabricante', col_model: 'Modelo', col_category: 'Categoria', col_total: 'Total', col_online: 'Online', col_offline: 'Offline', col_critical: 'Sinal crítico', col_pct: '% do parque',
          table_empty: 'Nenhuma ONU no filtro atual.',
          footer: (models, onus) => `${models} modelos · ${onus} ONUs no filtro (parque inteiro carregado).`,
          drawer_close: 'Fechar', unknown: 'Não identificado',
          mode_routing: 'Roteamento', mode_bridge: 'Bridge',
          csv_model_h: ['Fabricante', 'Modelo', 'Categoria', 'Total', 'Online', 'Offline', 'Sinal crítico', '% do parque'],
          csv_onu_h: ['Serial', 'Cliente', 'Fabricante', 'Modelo', 'Categoria', 'OLT', 'Zona', 'Status'],
          sheet_by_model: 'Por modelo', sheet_onus: 'ONUs',
        },
        plans: {
          title: 'Clientes por plano de velocidade',
          subtitle: 'Assinantes agrupados pelo par de perfis de banda (download / upload) que o OLTM registrou ter aplicado. Clique num plano para ver a distribuição por OLT.',
          kpi_plans: 'Planos', kpi_subs: 'Assinantes com plano', kpi_pct: '% do parque com plano', kpi_top: 'Plano mais vendido', kpi_no_plan: 'Assinantes sem plano',
          loading: 'Carregando planos…',
          empty: 'Nenhum plano de velocidade aplicado às ONUs no filtro atual.',
          no_plan: 'Sem plano', subscribers: 'assinantes',
          drawer_by_olt: 'Distribuição por OLT', drawer_no_dist: 'Sem distribuição por OLT.', drawer_close: 'Fechar',
          chart_subs: 'Assinantes por plano', chart_subs_hint: (n) => `${n} planos`,
          chart_share: 'Participação', chart_share_hint: 'assinantes por plano',
          tt_online: 'Online', tt_subscribers: 'Assinantes',
          col_plan: 'Plano', col_download: 'Download', col_upload: 'Upload', col_subscribers: 'Assinantes', col_online: 'Online', col_pct: '% do total',
          table_empty: 'Nenhum plano no filtro atual.',
          disclaimer: 'O relatório reflete o que o OLTM registrou ter aplicado (onu_speed_profiles), não o que está configurado no equipamento — o modelo Huawei atual pode não aplicar a banda de fato em muitos casos.',
          csv_plan_h: ['Plano', 'Download (kbps)', 'Upload (kbps)', 'Assinantes', 'Online', '% do total'],
          csv_byolt_h: ['Plano', 'OLT', 'Assinantes'],
          sheet_plans: 'Planos', sheet_byolt: 'Planos x OLT',
        },
        uptime_page: {
          title: 'Disponibilidade (uptime)',
          subtitle: 'Percentual de tempo em que cada OLT esteve online no período, para SLA e relatórios gerenciais. O histórico começa quando o coletor registrou a primeira transição de status — janelas anteriores contam como "sem dados", não como queda.',
          sla_meta: 'Meta SLA', no_data_badge: 'sem dados', coverage_short: 'cob.',
          st_error: 'Erro de coleta', st_degraded: 'Degradada',
          kpi_fleet: 'Uptime médio da frota', kpi_worst: 'Pior uptime', kpi_incidents: 'Incidentes no período', kpi_longest: 'Maior queda contínua', kpi_partial_cov: 'OLTs com cobertura < 100%',
          loading: 'Carregando disponibilidade…', empty: 'Nenhuma OLT cadastrada.',
          since_notice: (d) => `Dados de disponibilidade desde ${d} — o período selecionado começa antes disso, e o trecho anterior aparece como "sem dados" (reduz a cobertura, não conta como queda).`,
          no_data_notice: 'O coletor ainda não registrou nenhuma transição de status de OLT. O relatório passa a valer da primeira mudança detectada.',
          ribbon_title: (from, to) => `Fita de disponibilidade — ${from} a ${to}`,
          legend_online: 'Online', legend_down: 'Indisponível', legend_no_data: 'Sem dados',
          d_incidents: 'Incidentes', d_downtime: 'Downtime', d_longest: 'Maior queda',
          d_windows: 'Janelas de indisponibilidade', d_see_alerts: 'Ver alertas', d_no_incidents: 'Nenhuma indisponibilidade registrada no período.',
          d_uptime_cov: (u, c) => `${u}% de uptime · cobertura ${c}%`, d_no_data_period: 'sem dados de disponibilidade no período', d_until: 'até', d_close: 'Fechar',
          tip_no_data: 'Sem dados',
          col_uptime: 'Uptime', col_downtime: 'Downtime', col_incidents: 'Incidentes', col_longest: 'Maior queda', col_coverage: 'Cobertura', col_status_now: 'Status atual',
          table_empty: 'Nenhuma OLT.',
          footer: (n, sla) => `${n} OLTs · uptime medido só sobre o tempo com dados (cobertura) · meta de SLA ${sla}% · clique numa OLT para ver as janelas de queda.`,
          csv_summary_h: ['OLT', 'Uptime %', 'Cobertura %', 'Downtime (s)', 'Incidentes', 'Maior queda (s)', 'Status atual'],
          csv_incidents_h: ['OLT', 'Início', 'Fim', 'Duração (s)', 'Status'],
          csv_no_incidents: '— nenhum incidente no período —',
          sheet_summary: 'Resumo', sheet_incidents: 'Incidentes',
        },
        swaps: {
          title: 'Histórico de trocas de ONU',
          subtitle: 'Substituições de equipamento por cliente ao longo do tempo — mesmo ponto/cliente, serial diferente (RMA, upgrade, defeito). Ajuste o motivo direto na tabela.',
          req_failed: 'Falha na requisição.',
          reason_saved: 'Motivo atualizado', reason_save_failed: 'Falha ao salvar motivo',
          reasons: { rma: 'RMA', upgrade: 'Upgrade', defect: 'Defeito', reinstall: 'Reinstalação', unknown: 'A classificar' },
          all_reasons: 'Todos os motivos', all_types: 'Trocas e reinstalações', type_swap: 'Só trocas de equipamento', type_reinstall: 'Só reinstalações',
          filter_customer_ph: 'Filtrar por cliente…',
          kpi_swaps: 'Trocas no período', kpi_customers: 'Clientes afetados', kpi_avg_gap: 'Tempo médio sem ONU', kpi_top_reason: 'Motivo predominante', kpi_last30: 'Trocas nos últimos 30d',
          loading: 'Carregando trocas…',
          empty: 'Nenhuma troca de ONU registrada no período/filtro atual.',
          months: (n) => `${n} troca${n > 1 ? 's' : ''}`,
          col_date: 'Data', col_pon: 'PON', col_cto: 'CTO', col_serial: 'Serial (antigo → novo)', col_model: 'Modelo', col_gap: 'Sem ONU', col_reason: 'Motivo', col_detected: 'Detecção', col_by: 'Por',
          table_empty: 'Nenhuma troca no filtro atual.',
          footer: (shown, total) => `${shown} de ${total} trocas no período · detecção automática no momento da autorização + backfill histórico.`,
          d_title: 'Troca de ONU', d_close: 'Fechar',
          d_equipment: 'Equipamento', d_model: 'Modelo', d_reason: 'Motivo', d_detection: 'Detecção', d_gap: 'Cliente sem ONU', d_registered_by: 'Registrado por',
          d_old: 'Antiga', d_new: 'Nova', d_onu_gone: 'ONU não está mais no cadastro.',
          csv_h: ['Data', 'Cliente', 'ONU (nome)', 'OLT', 'PON', 'CTO', 'Serial antigo', 'Serial novo', 'Modelo antigo', 'Modelo novo', 'Motivo', 'Detecção', 'Registrado por', 'Tempo sem ONU (s)'],
          sheet: 'Trocas de ONU',
        },
        consumption: {
          title: 'Consumo por cliente',
          subtitle: 'Uso de banda agregado por cliente no período — P95, média, pico e total em GB. O tráfego de todas as ONUs de um cliente é somado por instante antes do percentil. Útil para políticas de fair use.',
          fetch_failed: 'Falha ao carregar.',
          search_ph: 'Buscar cliente…', fairuse_label: 'Limiar fair use', only_over: 'Só acima do limiar',
          truncated: 'Lista truncada nos 2000 clientes com maior P95 de download. Refine por OLT/zona para ver o restante.',
          kpi_customers: 'Clientes com tráfego', kpi_total: 'Consumo total da base', kpi_top1: 'Cliente top-1 (P95)', kpi_avg_p95: 'P95 médio da base', kpi_over: 'Acima do limiar',
          kpi_over_sub: (gb) => `≥ ${gb} GB`, kpi_over_none: 'defina um limiar',
          loading: 'Carregando consumo por cliente…',
          empty: 'Nenhum cliente com tráfego coletado no período. Verifique se as ONUs têm o campo "cliente" preenchido e se a coleta de tráfego está ativa.',
          chart_top20: 'Top 20 clientes por P95 de download', chart_hint: (n) => `${n} clientes`, chart_tt: 'P95 download',
          col_customer: 'Cliente', col_onus: 'ONUs', col_p95_down: 'P95 down', col_p95_up: 'P95 up', col_avg_down: 'Média down', col_peak_down: 'Pico down', col_total: 'Total (down+up)', col_olts: 'OLT(s)', col_zone: 'Zona',
          table_empty: 'Nenhum cliente no filtro atual.',
          footer: (shown, total) => `${shown} de ${total} clientes · métrica principal: percentil 95 de download · clique num cliente para ver a série agregada e as ONUs.`,
          d_onus_period: (n) => `${n} ONU${n === 1 ? '' : 's'} · consumo agregado no período`,
          d_close: 'Fechar', d_loading_series: 'Carregando série…',
          d_p95_down: 'P95 download', d_peak_down: 'Pico download', d_total: 'Total (down+up)',
          d_agg_traffic: 'Tráfego agregado do cliente', d_no_samples: 'Sem amostras de tráfego no período.',
          d_customer_onus: 'ONUs do cliente', d_no_onu: 'Nenhuma ONU com tráfego no período.',
          csv_h: ['Cliente', 'ONUs', 'P95 down (Mbps)', 'P95 up (Mbps)', 'Média down (Mbps)', 'Pico down (Mbps)', 'Total down (GB)', 'Total up (GB)', 'Total (GB)', 'Acima do limiar', 'OLT(s)', 'Zona(s)'],
          csv_yes: 'sim', sheet: 'Clientes',
        },
        bulk: {
          title: 'Log de tarefas em lote',
          subtitle: 'Histórico das execuções de ações em massa sobre ONUs — reinício e mudança de zona aplicados a um conjunto filtrado. Clique numa linha para ver os parâmetros e o resultado item a item.',
          req_failed: 'Falha na requisição.',
          st: { pending: 'Aguardando', running: 'Em execução', completed: 'Concluído', failed: 'Falhou', partial: 'Parcial' },
          ist: { pending: 'Aguardando', running: 'Processando', success: 'Sucesso', failed: 'Falha' },
          actions: { restart: 'Reiniciar ONUs', change_zone: 'Alterar zona' },
          onu_st: { unconfigured: 'não configurada', online: 'online', offline: 'offline', los: 'LOS', dyinggasp: 'dying-gasp', disabled: 'desabilitada', removed: 'removida' },
          unknown_ref: 'desconhecida', system_user: 'sistema',
          new_bulk: 'Nova ação em lote',
          tgt_olt: (n) => `OLT ${n}`, tgt_zone: (n) => `zona ${n}`, tgt_pon: '1 porta PON',
          tgt_status: (s) => `status ${s}`, tgt_selected: (n) => `${n} ONUs selecionadas`, tgt_all: 'todas as ONUs', tgt_suffix: (n) => `${n} ONUs`,
          all_statuses: 'Todos os status', all_actions: 'Todas as ações', all_users: 'Todos os usuários',
          search_ph: 'Buscar em filtro / parâmetros…',
          kpi_jobs: 'Jobs no período', kpi_onus: 'ONUs afetadas', kpi_success_rate: 'Taxa de sucesso', kpi_problem: 'Jobs falhos / parciais', kpi_biggest: 'Maior job', kpi_biggest_sub: 'ONUs num único job',
          loading: 'Carregando tarefas em lote…', empty: 'Nenhuma tarefa em lote no período / filtro atual.',
          chart_daily: 'Jobs por dia', chart_daily_hint: 'ONUs processadas · sucesso vs falha', chart_no_period: 'Sem dados no período.',
          chart_by_action: 'Jobs por ação', chart_by_action_hint: 'nº de execuções', chart_no_data: 'Sem dados.',
          tt_success: 'Sucesso', tt_failure: 'Falha', tt_jobs: 'jobs',
          col_date: 'Data', col_action: 'Ação', col_user: 'Usuário', col_target: 'Alvo', col_progress: 'Progresso', col_status: 'Status', col_duration: 'Duração',
          table_empty: 'Nenhum job no filtro atual.',
          footer: (shown, total) => `${shown} de ${total} jobs no período.`, footer_more: ' Mostrando os 500 jobs mais recentes — reduza o período para ver mais.',
          prog: (ok, fail, total) => `${ok} ok · ${fail} falha · ${total} total`,
          d_close: 'Fechar', d_status: 'Status', d_total_onus: 'Total ONUs', d_success_fail: 'Sucesso / Falha', d_duration: 'Duração',
          d_filter: 'Filtro do job', d_no_filter: '— sem filtro (todas as ONUs) —', d_params: 'Parâmetros', d_no_params: '— nenhum —',
          d_items: (n) => `Itens (${n})`, d_loading_items: 'Carregando itens…', d_no_items: 'Este job não tem itens.',
          d_showing_items: (shown, total) => `Mostrando os primeiros ${shown} de ${total} itens.`,
          col_serial: 'Serial', col_error: 'Erro',
          csv_jobs_h: ['Data', 'Ação', 'Usuário', 'Alvo', 'Total ONUs', 'Sucesso', 'Falha', 'Status', 'Início', 'Fim', 'Duração'],
          csv_items_h: ['Data do job', 'Ação', 'Serial', 'Cliente', 'OLT', 'Status', 'Erro'],
          csv_items_failed: 'Falha ao carregar itens para o Excel', csv_cap: (n) => `Exportação de itens limitada a ${n} linhas.`,
          sheet_jobs: 'Jobs', sheet_items: 'Itens',
        },
      },
    },
  },
  en: {
    nav: {
      features: 'Features',
      vendors: 'Compatibility',
      stats: 'Platform',
      pricing: 'Pricing',
      contact: 'Contact',
      login: 'Sign in',
      trial: 'Free trial',
    },
    hero: {
      kicker: 'SAAS PLATFORM FOR ISPS & TELECOM',
      headlines: [
        ['Manage your', 'OLT fleet', 'from a single pane of glass.'],
        ['Monitor', 'fiber optics', 'in real time.'],
        ['Manage OLTs and', 'ONUs', 'at scale, without the headache.'],
        ['Your GPON network,', 'under control', 'from minute one.'],
      ],
      sub: 'OLTM centralizes OLT management, monitoring and licensing for Huawei, ZTE and Fiberhome on one platform — built for serious ISPs.',
      cta_primary: 'Start free trial',
      cta_secondary: 'Talk to an engineer',
      pill_live: 'LIVE',
      pill_status: 'All systems operational',
    },
    features: {
      eyebrow: '— FEATURES',
      title: 'Everything your NOC needs.',
      sub: 'Lean operations, no rework. Connectivity, security and visibility in one place.',
      items: [
        { t: 'Multi-Vendor Management', d: 'Huawei, ZTE and Fiberhome through unified integrators. Abstracted commands, consistent results.' },
        { t: 'Enterprise Security', d: 'JWT RS256, MFA TOTP, granular RBAC, and SNMP credentials encrypted at rest.' },
        { t: 'Real-time Monitoring', d: 'SNMP polling, per-instance heartbeat and instant alerts via webhooks or Telegram.' },
        { t: 'Fully Cloud-managed', d: 'Run your entire stack on our multi-tenant cluster with enterprise-grade security and automated backups — zero risk to your operation.' },
        { t: 'API & Webhooks', d: 'Plug into your ERP, billing system and internal tools. Fully documented.' },
        { t: 'Full Audit Trail', d: 'Every provision, every ONU reset, every access — logged and exportable.' },
      ],
    },
    vendors: {
      eyebrow: '— COMPATIBILITY',
      title: 'Works with what you already have.',
      sub: 'Mature drivers for the most-used vendors in Brazil and worldwide.',
      list: ['HUAWEI', 'ZTE', 'FIBERHOME', 'PARKS', 'DATACOM', 'V-SOL'],
      note: 'Need another vendor? Request it in the form — we ship it.',
    },
    stats: {
      eyebrow: '— BY THE NUMBERS',
      title: 'The platform runs 24/7.',
      items: [
        { label: 'OLTs managed', key: 'olts_managed' },
        { label: 'ONUs online now', key: 'onus_online' },
        { label: 'Active ISPs', key: 'isps_active' },
        { label: 'Uptime (90d)', key: 'uptime', suffix: '%' },
        { label: 'Alerts handled today', key: 'alerts_handled_today' },
        { label: 'Countries served', key: 'countries' },
      ],
    },
    misc: {
      lang_label: 'LANG',
      theme_label: 'THEME',
      reshuffle: 'Reshuffle layout',
    },
    app: {
      nav: {
        dashboard: 'Dashboard',
        unconfigured: 'Unconfigured',
        configured: 'Configured',
        graphs: 'Graphs',
        events: 'Events',
        diagnostics: 'Diagnostics',
        tasks: 'Tasks',
        reports: 'Reports',
        save_config: 'Save',
        settings: 'Settings',
        log_out: 'Log out',
        role_owner: 'Owner',
      },
      reports_menu: ['ONU inventory', 'Signal quality', 'Traffic summary', 'Audit export', 'PON port outages', 'OLT overview', 'SNMP/SSH collection (poll)'],
      common: {
        search: 'Search…',
        filter: 'Filter',
        save_changes: 'Save changes',
        cancel: 'Cancel',
        prev: 'Prev',
        next: 'Next',
        showing: 'Showing',
        of: 'of',
        all_olts: 'All OLTs',
        all_zones: 'All zones',
        all_types: 'All types',
        all_roles: 'All roles',
        all_statuses: 'All statuses',
        all_severities: 'All severities',
        last_24h: 'Last 24h',
        last_7d: 'Last 7 days',
        last_30d: 'Last 30 days',
        last_90d: 'Last 90 days',
        new: 'New',
        add: 'Add',
        back: 'Back',
        details: 'Details',
        monitor: 'Monitor',
        actions: 'Actions',
        status: 'Status',
        started: 'Started',
        user: 'User',
      },
      banner: {
        updated_to: 'has been updated to version',
        see_new: "See what's new",
      },
      dashboard: {
        kpis: {
          waiting_authorization: 'Waiting authorization',
          online: 'Online',
          total_offline: 'Total offline',
          low_signals: 'Low signals',
          d_resync_new: 'D: 0 · Resync: 1 · New: 1',
          total_authorized: 'Total authorized: 12.648',
          pwrfail_los_na: 'PwrFail: 833 · LoS: 267 · N/A: 83',
          warning_critical: 'Warning: 1.082 · Critical: 232',
        },
        info_valid: 'Information valid at 01:20',
        network_status: 'Network status',
        daily_network_status: 'Daily network status',
        more_graphs: 'More graphs ▾',
        online_onus: 'Online ONUs',
        power_fail: 'Power fail',
        signal_loss: 'Signal loss',
        na: 'N/A',
        maximum: 'Maximum',
        auth_per_day: 'ONU authorizations per day',
        pon_outage: 'PON outage',
        no_pon_outages: 'No PON outages at the moment.',
        olt_name: 'OLT name',
        board_port: 'Board/Port',
        onus: 'ONUs',
        los: 'LOS',
        power: 'Power',
        possible_cause: 'Possible cause',
        since: 'Since',
        olts: 'OLTs',
        all: 'All ▾',
        info: 'Info',
        view_all_info: 'View all info',
        olt_issues: 'OLTs with issues',
        no_olt_issues: 'No OLTs with issues at the moment.',
        uptime: 'Uptime',
        online_series: 'Online',
        offline_series: 'Offline',
      },
      not_validated: {
        badge: 'Not validated live',
        tooltip: 'This feature was tested with simulation and automated tests, but has not yet been confirmed on a real OLT. Check the result on the OLT after using it.',
      },
      unconfigured: {
        title: 'Unconfigured ONUs',
        sub: 'ONUs pending authorization. Use presets to speed up onboarding.',
        cache_note: 'This list comes from the cache. The automatic OLT scan runs in long cycles (≈ 2 h, configurable per instance); use Refresh to scan now.',
        auto_actions: 'Auto actions',
        serial: 'Serial',
        olt: 'OLT',
        detected: 'Detected',
        authorize: 'Authorize',
        waiting: 'Waiting',
      },
      vlan_scope: {
        out_of_rule: 'outside the PON rule',
        out_of_registry: 'not in the OLT registry',
        none_allowed: 'No VLAN is allowed on PON {pon} — allow one in OLT › VLANs. You can still authorize without a VLAN.',
        none_allowed_link: 'Open the OLT VLANs',
        preset_vlan_skipped: 'The preset VLAN {vlan} is not allowed on PON {pon} and was not applied.',
        current_out_of_rule: "This ONU's current VLAN ({vlan}) is outside the rule for PON {pon}; it stays listed only so you can edit without losing the value.",
        auto_vlan_warning: 'The preset VLAN {vlan} is not allowed on PONs {pons}: items on those PONs will be skipped (vlan_not_allowed_on_pon).',
        auto_vlan_link: 'See the VLAN rule',
      },
      vlans_tab: {
        col_vlan: 'VLAN-ID',
        col_pon: 'PON ports',
        col_description: 'Description',
        col_iptv: 'IPTV',
        col_mgmt: 'Mgmt/VoIP',
        col_dhcp: 'DHCP Snooping',
        col_lan2lan: 'LAN to LAN',
        col_onus: 'ONUs',
        col_actions: 'Actions',
        refresh: 'Refresh VLANs',
        add: 'Add VLAN(s)',
        delete_multiple: 'Delete multiple VLANs',
        loading: 'Loading…',
        load_error: 'Could not load the OLT VLANs.',
        retry: 'Try again',
        empty: 'No VLAN discovered. Run a poll to collect via SNMP.',
        pon_all: 'All',
        pon_all_except: 'All except',
        pon_none: 'None',
        pon_load_error: 'Could not load the PON ports — the "PON ports" column summary is unavailable.',
        edit_title: 'Edit VLAN {n}',
        onus_title: 'See the ONUs on VLAN {n}',
        sort_by: 'Sort by {c}',
        flag_on: 'Yes',
        flag_off: 'No',
        local_only: 'Local metadata, not applied to the OLT yet.',
        l2l_applied_note: 'Applied to the OLT on save: the VLAN is bound to the OLTM_L2L service profile (user-bridging).',
        l2l_risk: 'Warning: with LAN-to-LAN, different customers on this VLAN can reach each other at layer 2 (fake ARP/DHCP, scans, more broadcast). Do not enable it on a VLAN shared by all customers — use a dedicated VLAN.',
        l2l_confirm: '{n} ONU(s) on this VLAN will see each other. Apply to the OLT?',
        l2l_live_checking: 'Reading the state from the OLT…',
        l2l_live_on: 'On the OLT: LAN-to-LAN active (profile {p}).',
        l2l_live_off: 'On the OLT: LAN-to-LAN disabled.',
        l2l_live_error: 'Could not read the state from the OLT: {e}',
        l2l_live_drift: 'The state on the OLT differs from what OLTM saved. Saving re-applies the chosen state.',
        l2l_live_foreign: 'The VLAN uses a service profile that is not managed by OLTM ({p}); OLTM will not change it.',
        l2l_result_on: 'LAN-to-LAN enabled on the OLT (confirmed by read-back).',
        l2l_result_off: 'LAN-to-LAN disabled on the OLT (confirmed by read-back).',
        l2l_result_nochange: 'The OLT was already like this — nothing was written.',
        l2l_result_diverged: 'The OLT did not confirm the requested LAN-to-LAN — check the real state.',
        edit: 'Edit',
        delete: 'Delete',
        delete_confirm: 'Delete this VLAN?',
        delete_confirm_used: 'In use by {n} ONU(s) — delete?',
        delete_ok: 'VLAN {n} deleted.',
        delete_fail: 'Failed to delete VLAN {n} on the OLT.',
        batch_title: 'Delete multiple VLANs',
        batch_label: 'VLAN ID(s) to delete',
        batch_placeholder: 'e.g. 300 or 300-305 or 300,302,305',
        batch_hint: 'One ID, a range (100-105) or a comma-separated list. Each VLAN is removed from the OLT (undo vlan).',
        batch_invalid: 'Use only 1–4 digit numbers separated by comma or hyphen (e.g. 100,102-105).',
        batch_confirm: 'Delete these VLANs from the OLT?',
        batch_yes: 'Delete',
        batch_no: 'Cancel',
        batch_close: 'Close',
        batch_running: 'Deleting…',
        batch_summary: '{ok} deleted, {fail} failed.',
        batch_result_ok: 'deleted',
        batch_result_fail: 'failed',
        batch_error: 'Failed to delete the VLANs on the OLT.',
        edit_page_title: 'Edit VLAN',
        edit_load_error: 'Could not load the VLAN.',
        edit_not_found: 'VLAN not found on this OLT.',
        field_vlan_id: 'VLAN-ID',
        field_description: 'Description',
        field_description_hint: 'Leave empty to remove the VLAN description.',
        description_olt_warn: 'The changed description will be written to the OLT on save (vlan desc).',
        field_iptv: 'Multicast VLAN, used for IPTV',
        field_mgmt: 'Management/VoIP VLAN',
        field_dhcp: 'DHCP Snooping on the VLAN',
        field_lan2lan: 'Enable direct communication between ONUs on this VLAN (LAN to LAN)',
        flags_operator_note: 'IPTV and Mgmt/VoIP are set manually; the poll does not overwrite them.',
        flags_revert: 'Revert to the OLT value',
        flags_revert_hint: 'IPTV and Mgmt/VoIP are read from the OLT again. The next poll restores its values.',
        flags_revert_pending: 'On save, IPTV and Mgmt/VoIP go back to following the OLT.',
        flags_revert_undo: 'Undo',
        pon_block_title: 'PON ports where this VLAN can be used',
        pon_hint: 'Everything is checked by default. Unchecking a PON stops this VLAN from being used on it in new authorizations and configurations; what already exists is unchanged.',
        pon_show: 'Show PON ports',
        pon_hide: 'Hide PON ports',
        pon_total: '{c}/{t} PONs checked',
        pon_board: 'Board {n}',
        pon_board_count: '{c}/{t}',
        pon_check_slot: 'check all',
        pon_uncheck_slot: 'uncheck all',
        pon_check_all: 'Check every PON on the OLT',
        pon_none_selected: 'No PON checked — this VLAN will not be usable on any port.',
        pon_empty: 'This OLT has no PON ports registered.',
        pon_edit_load_error: "Could not load this OLT's PON ports.",
        save: 'Save',
        saving: 'Saving…',
        cancel: 'Cancel',
        save_confirm_none: 'This VLAN will no longer be usable on any PON. Save?',
        save_yes: 'Save',
        save_no: 'Back',
        save_ok: 'VLAN {n} saved.',
        save_nochange: 'Nothing changed.',
        save_fail: 'Failed to save VLAN {n}.',
        save_local_failed: 'The OLT was changed, but saving VLAN {n} locally failed — repeat the same operation to sync.',
        back: 'Back to VLANs',
        filter_vlan_chip: 'VLAN {n} — every ONU that uses it',
        filter_vlan_clear: 'Remove VLAN filter',
      },
      configured: {
        title: 'Configured ONUs',
        sub: 'All authorized ONUs across your fleet.',
        customer: 'Customer',
        name: 'Name',
        onu: 'ONU',
        type: 'Type',
        rx_signal: 'Signal',
        uptime: 'Uptime',
        online: 'Online',
        offline: 'Offline',
        broken: 'Critical signal',
        high_signal: 'High signal',
        serial_mac: 'SN / MAC',
        model: 'Model',
        zone: 'Zone',
        odb: 'ODB',
        vlan: 'VLAN',
        mode: 'B/R',
        bridge: 'Bridge',
        router: 'Router',
        voip: 'VoIP',
        tv: 'TV',
        voiptv: 'VoIP - TV',
        details: 'View',
        filter_status: 'Status',
        filter_zone: 'Zone',
        filter_odb: 'ODB',
        filter_model: 'Model',
        filter_mode: 'Mode',
        filter_all: 'All',
        columns: 'Columns',
        no_results: 'No ONU matches the current filters.',
        not_authorized: 'Not authorized by OLTM',
        mgmt_ip: 'Mgmt IP',
        sw_version: 'SW version',
        distance: 'Distance',
        cto_port: 'CTO port',
        authorized_at: 'Authorized at',
        load_more: 'Load more',
        loading_more: 'Loading more…',
        end_of_list: 'End of list',
      },
      graphs: {
        title: 'Graphs',
        sub: 'Traffic, PON, uplink and signal analytics.',
        tabs: ['OLT', 'Uplink', 'PON', 'Traffic', 'Signal'],
        panels: ['CPU / Memory', 'Temperature', 'Uplink throughput', 'Optical power'],
        graphs_for: 'Graphs for',
        olts: 'OLT',
        board: 'Board',
        port: 'Port',
        zone: 'Zone',
        cto: 'CTO (Splitter)',
        any: 'Any',
        showing_for: 'Showing data for',
      },
      diagnostics: {
        title: 'Diagnostics',
        sub: 'Bulk diagnostics for ONUs with signal issues.',
        reboot_selected: 'Reboot selected',
        resync_selected: 'Resync selected',
        signal: 'Signal',
        temp: 'Temp',
        critical: 'Critical',
        warning: 'Warning',
      },
      onu_page: {
        back_to_list: 'Back to ONUs',
        not_found_title: 'ONU not found',
        not_found_sub: 'No ONU matches serial:',
        update_in: 'update in',
        olt: 'OLT',
        board: 'Board',
        port: 'Port',
        onu: 'ONU',
        gpon_channel: 'GPON Channel',
        sn: 'SN',
        onu_type: 'ONU Type',
        auth_preset: 'Configuration preset',
        zone: 'Zone',
        cto: 'CTO (Splitter)',
        name: 'Name',
        onu_name: 'ONU name',
        customer_name: 'Customer name',
        address: 'Address',
        contact: 'Contact',
        auth_date: 'Auth date',
        history: 'History',
        external_id: 'External ONU ID',
        section_client: 'Customer',
        section_network_location: 'Network location',
        section_status_signal: 'Status & signal',
        section_network_config: 'Network & config',
        online_since: 'Online since',
        distance: 'Distance',
        status: 'Status',
        rx_signal: 'Rx signal ONU/OLT',
        tr069: 'TR069 Profile',
        mgmt_ip: 'Management IP',
        vlans: 'Attached VLANs',
        onu_mode: 'ONU Mode',
        config_mode: 'Config mode',
        pppoe_user: 'PPPoE username',
        pppoe_pass: 'PPPoE password',
        get_status: 'Get status',
        show_running_config: 'Show running config',
        sw_info: 'SW info',
        live: 'LIVE!',
        traffic_signal: 'Traffic/Signal',
        traffic: 'traffic',
        signal: 'signal',
        charts_section: 'Charts',
        chart_signal: 'Optical signal',
        chart_traffic: 'Traffic',
        chart_last_24h: 'last 24h',
        download: 'Download',
        upload: 'Upload',
        download_short: 'Download',
        read_only: 'read-only',
        speed_profiles: 'Speed profiles',
        service_port_id: 'Service port ID',
        user_vlan: 'User VLAN',
        action: 'Action',
        configure: 'Configure',
        manage_service_port: 'Take over management',
        sp_load_error: 'Failed to read service-ports from the OLT',
        retry: 'Retry',
        ethernet_ports: 'Ethernet ports',
        port_col: 'Port',
        admin_state: 'Admin state',
        mode: 'Mode',
        dhcp: 'DHCP',
        enabled: 'Enabled',
        no_control: 'No control',
        voip_service: 'VoIP service',
        sip_profile: 'SIP profile',
        number: 'Number',
        enable: 'Enable',
        disable: 'Disable',
        not_defined: 'Not defined',
        catv: 'CATV',
        enable_catv: 'Enable CATV',
        catv_unsupported: 'Not supported by ONU Type',
        reboot: 'Reboot',
        resync_config: 'Resync config',
        restore_defaults: 'Restore defaults',
        disable_onu: 'Disable ONU',
        enable_onu: 'Re-authorize ONU',
        delete_onu: 'Delete',
        confirm_prompt: 'Are you sure?',
        confirm_yes: 'Yes',
        confirm_no: 'No',
        move_onu_title: 'Move ONU',
        move: 'Move',
        close: 'Close',
        update_gpon_title: 'Update GPON channel',
        update: 'Update',
        gpon_info_1: 'SmartOLT allocates ONU IDs from the 0-127 range for the GPON channel and from the 128-255 range for the XG/XGS-PON channels.',
        gpon_info_2: 'Once the 128-255 range is exhausted, it allocates from the 0-127 range for both GPON and XG/XGS-PON channels.',
        gpon_info_3: 'Tip: XGPON-capable ONUs that were previously authorized on the GPON channel should be changed to the XGPON channel to free IDs for GPON ONUs.',
        replace_sn_title: 'Replace ONU by SN',
        replace: 'Replace',
        sn_helper: 'Use the magnifier to search the unconfigured list for this PON',
        location_title: 'Update location details',
        cto_port: 'CTO port',
        address_full: 'Address or comment',
        latitude: 'Latitude',
        longitude: 'Longitude',
        map: 'Map',
        ext_id_title: 'Update external ONU ID',
        ext_id_helper: 'Your own reference for this ONU in API or billing systems (contract, ERP…). Stored only in OLTM — it is not sent to the OLT. Leave empty to fall back to the default (the serial). Max 255 characters.',
        type_title: 'Change ONU type',
        type_select: 'ONU type',
        type_placeholder: 'Select a type…',
        type_scope_note: 'Only the OLTM link changes: the type defines the label and the capabilities shown (Ethernet ports, WAN mode, CATV). Nothing is sent to the OLT and the line/service profiles of the ONU on the device stay the same.',
        type_summary: (from, to) => (from ? `${from} → ${to}` : `No type → ${to}`),
        type_saved: 'ONU type updated',
        type_save_error: 'Failed to change the ONU type',
        type_load_error: 'Could not load the ONU type catalog.',
        type_edit: 'Change',
        eth_modes_note: 'Hybrid and Trunk modes and DHCP control are not available: the Huawei OLT command ("ont port vlan") only accepts Access and Transparent.',
        mgmt_title: 'Management IP and TR-069 (read-only)',
        tr069_profile_title: 'TR069 profile',
        tr069_profile: 'TR069 profile',
        mgmt_ip_title: 'Management IP',
        mgmt_ip_mode: 'Management IP mode',
        mgmt_inactive: 'Inactive',
        mgmt_static: 'Static IP',
        disabled: 'Disabled',
        voip_enabled_switch: 'Enabled (main switch)',
        voip_attach: 'Attach VoIP to',
        voip_hint: 'After enabling VoIP service, go to VoIP port settings and assign VoIP phone numbers as desired.',
      },
      autoTasks: AUTO_TASKS_I18N.en,
      fh: FIBERHOME_I18N.en,
      onuLifecycle: ONU_LIFECYCLE_I18N.en,
      reportsPon: REPORTS_PON_I18N.en,
      ponDetail: PON_DETAIL_I18N.en,
      reportsRbac: REPORTS_RBAC_I18N.en,
      reportsTopology: REPORTS_TOPOLOGY_I18N.en,
      tasks: {
        title: 'Tasks',
        sub: 'History and monitoring of executed operations.',
        task_id: 'Task ID',
        action: 'Action',
        actions: ['Reboot ONU', 'Provision', 'Resync config', 'Change VLAN', 'Apply preset', 'Restore defaults'],
        statuses: { completed: 'Completed', failed: 'Failed', running: 'Running' },
      },
      settings: {
        title: 'Settings',
        sub: 'System, network and account configuration.',
        sidebar: {
          general: 'General',
          users: 'Users',
          api_keys: 'API Keys',
          integrations: 'Integrations',
          billing: 'Billing',
          zones: 'Zones',
          odbs: 'ODBs / Splitters',
          onu_types: 'ONU Types',
          olt_types: 'OLT Types',
          speed_profiles: 'Speed Profiles',
          olts: 'OLTs',
          auth_presets: 'Authorization Presets',
          audit_log: 'Audit Log',
        },
        brand: {
          title: 'Brand (white-label)',
          sub: 'Displayed in the header, footer and login screen.',
          preview: 'Preview',
          company_name: 'Company name',
          logo_hint: 'Logo · PNG/SVG · max 400KB',
          upload: 'Upload logo',
          remove: 'Remove',
          saved_local: 'Saved locally in this browser. Changes apply immediately across the app.',
        },
        general_fields: ['Company name', 'Timezone', 'Language', 'Currency', 'Session timeout', 'Notification email'],
        users: {
          title: 'Users',
          sub: 'Manage teammates, roles, 2FA and per-user notifications.',
          invite: 'Invite',
          new_user: 'New user',
          search: 'Search by name or email…',
          columns: { user: 'User', role: 'Role', two_fa: '2FA', status: 'Status', last: 'Last' },
          enabled: 'Enabled',
          off: 'Off',
          active: 'active',
          invited: 'invited',
          suspended: 'suspended',
        },
        api_keys: {
          title: 'API Keys',
          sub: 'Programmatic access to your OLT Manager tenant. Rotate regularly and scope by permission.',
          generate: 'Generate key',
          active_keys: 'Active keys',
          reqs_min: 'Requests / min',
          rate_limit: 'Rate limit',
          rotate: 'Rotate',
          revoke: 'Revoke',
          created: 'Created',
          last_used: 'last used',
        },
        integrations: {
          title: 'Integrations',
          sub: 'MCP servers that operate OLT Manager with the permissions of the account that owns the key.',
          tabs: { servers: 'MCP servers', api_keys: 'API keys', erps: 'ERPs' },
          servers: {
            title: 'MCP servers',
            sub: 'An agent holding a linked key operates OLT Manager like a human operator — over the same REST routes, with the same RBAC. The scopes below only subtract from the account ceiling; they never widen it.',
            create: 'Register server',
            empty: 'No MCP server registered yet.',
            loading: 'Loading…',
            load_error: 'Failed to load MCP servers.',
            view_cards: 'Cards',
            view_table: 'Table',
            col_server: 'Server',
            col_owner: 'Account',
            col_scopes: 'Scopes',
            col_health: 'Health',
            col_activity: 'Activity 24h (calls / errors / denied)',
            enabled: 'Enabled',
            disabled: 'Disabled',
            never_seen: 'never seen',
            system_badge: 'System-managed',
            system_hint: 'This MCP server and its key are created and kept in sync automatically by the instance. It cannot be removed.',
            detail: 'Details',
            edit: 'Edit',
            badge_read_only: 'read only',
            badge_no_dangerous: 'no dangerous',
            badge_no_generic: 'no oltm_rest',
            badge_categories: (n) => `${n} categor${n === 1 ? 'y' : 'ies'}`,
            badge_capture: 'captures response',
            badge_full: 'full account access',
          },
          form: {
            create_title: 'Register MCP server',
            edit_title: 'Edit MCP server',
            created_title: 'Server registered',
            name: 'Name',
            name_ph: 'mcp-operations',
            description: 'Description',
            description_ph: 'What this MCP server is used for',
            enabled: 'Server enabled',
            scopes_legend: 'Scopes (only subtract from the account RBAC)',
            read_only: 'Read only (GET requests only)',
            allow_dangerous: 'Allow dangerous actions (DELETE, destructive routes)',
            allow_generic: 'Allow oltm_rest (GET-only escape hatch)',
            capture_response: 'Capture a response sample',
            capture_response_hint: 'stores the first 4 KiB of each response in the log — may contain sensitive data.',
            category_allowlist: 'Category allowlist (empty = all)',
            rate_limit: 'Rate limit (requests per minute)',
            mint_key: 'Mint a key now (shown once)',
            cancel: 'Cancel',
            save: 'Save',
            create: 'Register',
            saving: 'Saving…',
            finish: 'Done',
            name_required: 'Name is required.',
            created_ok: (n) => `Server "${n}" was registered.`,
          },
          key_block: {
            label: 'Account key (oltmk_…) — goes in the X-API-Key header of the MCP process. Copy it now, it will not be shown again:',
            copy: 'Copy',
            copied: 'Copied',
          },
          detail: {
            title: 'MCP server',
            loading: 'Loading…',
            load_error: 'Failed to load the server.',
            scopes: 'Scopes',
            all_categories: 'all categories',
            rate_limit_label: (rl) => `rate limit ${rl}/min`,
            activity_24h: (c, e, d) => `24h: ${c} calls · ${e} errors · ${d} denied by RBAC`,
            linked_keys: 'Linked keys',
            no_keys: 'No linked key.',
            key_never_used: 'never used',
            key_used: (rel) => `used ${rel}`,
            revoke: 'Revoke',
            mint_ph: 'New key name',
            mint: 'Mint new',
            delete_title: 'Delete server',
            delete_hint: 'Removes the registration only. Linked keys stay valid with the account RBAC (they become orphaned) — revoke them first if you want to cut access.',
            delete: 'Delete server',
            delete_confirm: 'Delete?',
            close: 'Close',
          },
          connect: {
            title: 'Connection (.mcp.json)',
            host_label: 'MCP server host',
            host_hint: 'Address where the oltm-mcp-server process is published (Session 08 finalizes the compose).',
            note: 'The Bearer here is MCP_AUTH_TOKEN — the MCP process’s own secret. The account oltmk_ key goes in OLTM_API_KEY / X-API-Key on the process, not here.',
            copy: 'Copy',
            copied: 'Copied',
          },
          about: {
            title: 'About / How to connect',
            sub: 'An agent holding an OLT Manager API key operates the whole instance like a human operator — over the same REST routes, with the same RBAC.',
            security_title: 'Security model',
            security: [
              'The key is the account: it resolves to a real user and inherits exactly their permissions.',
              'RBAC is the ceiling. The backend is the only enforcement point (RequirePermission per route) — same for agent and human, and it now truly blocks for keys.',
              'Server scopes only subtract (read only, no dangerous, category allowlist). They never widen what the key can already do.',
              'The log lives in the backend, on the key-auth branch — it captures everything, even curl calls. The X-MCP-Server/X-MCP-Tool headers only enrich, never trust.',
            ],
            retention_title: 'Retention, redaction and limits',
            retention: [
              'Log retained for 90 days (MCP_LOG_RETENTION_DAYS), cleaned by a background loop.',
              'Request body stored with sensitive keys masked (password, secret, token, *_hash…) and truncated to 8 KiB. The response is not stored — only status and size; an opt-in per-server mode stores the first 4 KiB.',
              'Per-key rate limit (default 120 req/min), configurable per server.',
              'Stateless design: no session id, no server push.',
            ],
            practices_title: 'Best practices',
            practices: [
              'A dedicated user/group per MCP, with the minimum permissions.',
              'read_only for analysis agents.',
              'Review Reports → Integrations usage → Permission denials to see where the agent hits RBAC.',
            ],
            limits_title: 'Known limitations',
            limits: [
              'Binary uploads (equipment photos, backup as a file) are not exposed via MCP.',
              'The interactive OLT SSH session is not exposed (it is WS/stream, not REST).',
              'oltm_rest (escape hatch for unmapped routes) is GET-only.',
            ],
            reference: 'Reference: docs/ApiMcpOLTm/ (00-VISAO-GERAL.md §7) and the oltm-mcp-server README.',
          },
          erps: {
            title: 'ERPs',
            coming_soon: 'Coming soon',
            banner: 'ERP integrations are under development. Below are the systems we plan to support. Mark your interest to be notified when one is ready.',
            interest: "I'm interested",
            interest_done: 'Interest registered',
            interest_ok: "Interest registered — we'll let you know when the integration is ready.",
            interest_err: 'Could not register your interest. Please try again.',
            items: {
              ixc: 'Most widely used ERP/ISP in Brazil — customers, contracts, finance, work orders.',
              sgp: 'ISP management system — billing, customers and support.',
              voalle: 'Management and automation platform for ISPs.',
              hubsoft: 'ERP for ISPs — support, finance and provisioning.',
              mk_auth: 'ISP management and RADIUS (legacy, still common).',
              routerbox: 'ERP/ISP — customers, finance and monitoring.',
              topsapp: 'Management for small and mid-size ISPs.',
              ispbox: 'ISP management suite.',
              synsuite: 'ERP/CRM for telecom.',
              uzzysoft: 'Management and billing for ISPs.',
              radius_generico: 'Generic RADIUS/API integration for provisioning.',
              webhook_generico: 'Event notifications (ONU authorized, PON outage) for any system.',
            },
          },
          errors: {
            create_failed: 'Failed to register the MCP server.',
            update_failed: 'Failed to save the MCP server.',
            delete_failed: 'Failed to delete the server.',
            mint_failed: 'Failed to mint the key.',
            revoke_failed: 'Failed to revoke the key.',
          },
        },
        billing: {
          title: 'Billing',
          sub: 'License status for your OLTs.',
          sync: 'Sync',
          sync_success: 'License status synced',
          sync_error: 'Failed to sync licensing',
          olt_licenses: 'Licenses by OLT',
          loading: 'Loading...',
          no_olts: 'No OLTs registered',
          expires: 'Expires on',
          no_expiry: 'No expiration date',
          status_none: 'no license',
          renew: 'Renew',
          checkout_started: 'Checkout started',
          checkout_error: 'Failed to start checkout',
          col_id: 'OLT ID',
          col_name: 'OLT Name',
          col_status: 'Subscription status',
          col_expires_at: 'Subscription end date (inclusive)',
          payment_options: 'View payment options',
          portal_error: 'Failed to open the payment portal',
          invoices_title: 'Invoices',
          invoices_empty: 'No payments recorded yet.',
          col_inv_date: 'Date',
          col_inv_desc: 'Description',
          col_inv_olts: 'OLTs',
          col_inv_gateway: 'Paid with',
          col_inv_amount: 'Amount',
          col_inv_status: 'Status',
          pay_status_approved: 'approved',
          pay_status_pending: 'pending',
          pay_status_rejected: 'rejected',
          pay_status_refunded: 'refunded',
          pay_status_expired: 'expired',
          pay_status_canceled: 'canceled',
          choose_gateway: 'Choose a payment method',
          gateway_default: 'default',
          pix_title: 'Pay with PIX',
          pix_instructions: 'Scan the QR code or copy the code below in your bank app.',
          pix_copy: 'Copy PIX code',
          pix_copied: 'Code copied',
          close: 'Close',
          cancel: 'Cancel',
        },
        zones: {
          title: 'Zones',
          sub: 'Group OLTs and ONUs by geographic or logical coverage areas.',
          new_zone: 'New zone',
          coverage: 'Coverage',
        },
        odbs: {
          title: 'ODBs (NAPs, CTOs) / Splitters',
          sub: 'Manage distribution boxes, splitter capacity and connected ONUs.',
          map_view: 'Map view',
          new_odb: 'Add CTO (Splitter)',
          search: 'Search by name…',
          occupancy: 'Occupancy',
          occupancy_filter_all: 'All occupancy',
          occupancy_filter_50: '≥ 50% occupied',
          occupancy_filter_75: '≥ 75% occupied',
          occupancy_filter_90: '≥ 90% occupied',
          occupancy_filter_exceeded: 'Over capacity',
          delete_selected: 'Delete selected',
          export: 'Export',
          import: 'Import',
          stat_total: 'Total ODBs',
          stat_ports: 'Total ports',
          stat_used: 'Used ports',
          stat_free: 'Free ports',
        },
        onu_types: {
          title: 'ONU Types',
          sub: 'Supported ONU models across vendors — capabilities, service profiles and defaults.',
          register: 'Register model',
          auto_approved: 'Auto-approved',
          configure: 'Configure',
          import_catalog: 'Import from central catalog',
        },
        olt_types: {
          title: 'OLT Types',
          sub: 'Registered OLT models — supplementary metadata, does not replace the OLT vendor/hardware version.',
          register: 'Register model',
          import_catalog: 'Import from central catalog',
        },
        speed_profiles: {
          title: 'Speed Profiles',
          sub: 'Traffic shaping templates applied to service ports. Split by download and upload.',
          download: 'Download',
          upload: 'Upload',
          download_profiles: 'Download profiles',
          upload_profiles: 'Upload profiles',
          burst: 'Burst',
          standard: 'Standard',
          high: 'High',
          is_default_badge: 'Default profile',
          set_default: 'Set as default',
          default_hint: 'Automatically applied to authorized equipment with no profile selected.',
          edit: 'Edit',
        },
        olts: {
          title: 'OLTs',
          sub: 'Register and manage optical line terminals. Configure IP, credentials, ports and defaults.',
          register: 'Register OLT',
          onus: 'ONUs',
          temp: 'Temp',
          uptime: 'Uptime',
          pon_ports: 'PON ports in use',
          polled: 'polled 12s ago',
          manage: 'Manage',
          online: 'Online',
          warning: 'Warning',
          overheating: 'Overheating',
        },
        auth_presets: {
          title: 'Authorization Presets',
          sub: 'Templates that authorize incoming ONUs with the correct VLAN, speed and WiFi settings.',
          new_preset: 'New preset',
          default: 'Default',
          vlan: 'VLAN',
          applied_to: 'Applied to',
          onus_suffix: 'ONUs',
          wizard_title: 'Create preset — wizard',
          step_of: 'Step {a} of {b}',
          steps: [
            { label: 'Basics', desc: 'Name, vendor & description' },
            { label: 'Conditions', desc: 'When to apply this preset' },
            { label: 'ONU Settings', desc: 'VLAN, service ports, ETH' },
            { label: 'TR069 & Mgmt', desc: 'Management & TR069 profile' },
            { label: 'WiFi', desc: 'SSID, password, radios' },
            { label: 'Review', desc: 'Confirm & activate' },
          ],
          activate: 'Activate preset',
        },
        audit_log: {
          title: 'Audit Log',
          sub: 'Every sensitive action across the tenant — who, what, when and where.',
          filter: 'Filter',
          export: 'Export CSV',
          search: 'Search actor, action or target…',
          tones: { ok: 'ok', critical: 'critical', warning: 'warning', security: 'security', info: 'info' },
        },
      },
      time: {
        min_ago: (n) => `${n} min ago`,
        hour_ago: (n) => `${n} ${n === 1 ? 'hour' : 'hours'} ago`,
        day_ago: (n) => `${n} ${n === 1 ? 'day' : 'days'} ago`,
        days: (n) => `${n} days`,
        yesterday: 'yesterday',
        two_days_ago: '2 days ago',
        auth: 'authorized',
        reboot: 'Reboot',
      },
      reports: {
        common: {
          refresh: 'Refresh',
          export_csv: 'Export CSV',
          export: 'Export',
          export_xlsx: 'Spreadsheet (.xlsx)',
          export_print: 'Print / PDF',
          loading: 'Loading…',
          load_failed: 'Failed to load the report',
          all_olts: 'All OLTs',
          all_zones: 'All zones',
          all_statuses: 'All statuses',
          view: 'View',
          olt: 'OLT',
          customer: 'Customer',
          zone: 'Zone',
          manufacturer: 'Vendor',
          status: 'Status',
          uptime: 'Uptime',
          temperature: 'Temperature',
          last_poll: 'Last poll',
          back_to_hub: 'Reports Center',
          custom_period: 'Custom',
          none_registered_olt: 'No OLT registered.',
        },
        status_labels: {
          online: 'Online', high_signal: 'High signal', broken: 'Critical signal',
          offline: 'Offline', unknown: 'Unknown',
        },
        hub: {
          title: 'Reports Center',
          subtitle: 'Pick a report to view, filter and export your operation data — grouped by area.',
          coming_soon: 'Soon',
          groups: {
            maps: { title: 'Maps & Topology', subtitle: 'Geographic and hierarchical view of the network' },
            onus: { title: 'ONU reports', subtitle: 'Inventory, signal and usage of connected subscribers' },
            olts: { title: 'OLT & Network reports', subtitle: 'Health, availability and performance of the equipment' },
            field: { title: 'Field infrastructure', subtitle: 'Boxes, splitters and the physical layout of the network' },
            admin: { title: 'Admin & Audit', subtitle: 'Action traceability and system compliance' },
            finance: { title: 'Finance & Commercial', subtitle: 'Billing, licensing and per-customer usage' },
          },
          cards: {
            topology: { title: 'OLT topology', desc: 'Visual tree OLT -> boards -> PON ports -> splitters -> ONUs, with real-time status.' },
            map: { title: 'Network map', desc: 'OLTs, boxes and splitters geolocated on a map, with status and coverage by region.' },
            cto_occupancy: { title: 'Splitter occupancy on the map', desc: 'Occupancy density of service boxes shown geographically.' },
            pon_diagram: { title: 'PON port diagram', desc: 'Slot x port matrix per OLT, each port colored by occupancy — a visual fleet view.' },
            inventory: { title: 'ONU inventory', desc: 'Full list of authorized ONUs, with status, signal and provisioning data.' },
            signal_quality: { title: 'Signal quality', desc: 'Optical signal (Rx) distribution and ONUs outside the acceptable range.' },
            traffic_summary: { title: 'Traffic summary', desc: 'Bandwidth usage per ONU over the last 24h — current and peak.' },
            onu_models: { title: 'ONUs by type/vendor', desc: 'Distribution of the ONU fleet by model and vendor, useful for purchasing and support.' },
            onu_swaps: { title: 'ONU swap history', desc: 'Record of equipment replacements per customer over time.' },
            speed_plans: { title: 'Customers by speed plan', desc: 'Number of subscribers grouped by contracted bandwidth profile.' },
            olt_overview: { title: 'OLT overview', desc: 'Management view of the fleet (status, uptime, temperature) and authorization trend.' },
            pon_outages: { title: 'PON port outages', desc: 'Outages affecting several ONUs on the same PON port at once.' },
            poll_history: { title: 'SNMP/SSH collection (poll)', desc: 'Status and history of an OLT collection cycles — trigger an immediate poll.' },
            hardware_health: { title: 'Hardware health', desc: 'Temperature, power and board status over time, with trend alerts.' },
            uptime: { title: 'Availability (uptime)', desc: 'Availability percentage of each OLT in the period, for SLA and management reports.' },
            pon_capacity: { title: 'PON port occupancy', desc: 'Used versus available capacity on each PON port of each OLT.' },
            field_boxes: { title: 'Box inventory (CTO/CEO)', desc: 'List of registered boxes, capacity and link to PON ports.' },
            box_occupancy: { title: 'Box occupancy', desc: 'Free versus used ports per box, to plan expansion.' },
            splitters: { title: 'Splitters and optical loss', desc: 'Splitter mapping by level and estimated loss along the optical path.' },
            audit_export: { title: 'Audit export', desc: 'Log of administrative actions, filterable and exportable.' },
            external_changes: { title: 'External changes', desc: 'Changes made directly on the OLT (outside the system) detected by collection.' },
            rbac: { title: 'Users and permissions', desc: 'Report of users, groups and effective permissions in the system (RBAC).' },
            bulk_jobs: { title: 'Bulk job log', desc: 'History of mass-action runs over ONUs and OLTs.' },
            backups: { title: 'Compliance & backups', desc: 'Status of automatic OLT configuration backups.' },
            mcp_usage: { title: 'Integrations / MCP usage', desc: 'API calls per key/MCP server, latency, errors and denied permissions.' },
            cli_audit: { title: 'OLT commands', desc: 'Backlog of every CLI command sent to the OLTs: who asked, when, the response and whether it failed.' },
            billing_olts: { title: 'Billing per OLT', desc: 'License usage and charges per OLT contracted on the SaaS plan.' },
            payments: { title: 'Payments and subscriptions', desc: 'History of payments, methods and invoice status of the provider.' },
            customer_consumption: { title: 'Per-customer usage', desc: 'Aggregated bandwidth usage per customer, useful for fair-use policies.' },
          },
        },
        mcp_usage_page: {
          title: 'Integrations / MCP usage',
          subtitle: 'API calls per key and MCP server: volume, latency, errors and denied permissions. Everything comes from the backend log.',
          settings_link: 'Settings › Integrations',
          win_24h: '24h', win_7d: '7d', win_30d: '30d',
          kpi_calls: 'Calls',
          kpi_error_rate: '% error',
          kpi_denied_rate: '% denied',
          kpi_p50: 'Latency p50',
          kpi_p95: 'Latency p95',
          kpi_servers: 'Active servers',
          kpi_keys_sub: (n) => `${n} active key(s)`,
          timeline_title: 'Call timeline',
          timeline_hint: 'calls vs. errors over the period',
          timeline_calls: 'Calls',
          timeline_errors: 'Errors',
          timeline_empty: 'No calls in this window.',
          top_tools_title: 'Top tools',
          top_tools_hint: 'by call volume',
          top_tools_empty: 'No tool identified (direct curl calls do not send X-MCP-Tool).',
          top_routes_title: 'Top routes',
          routes_empty: 'No route recorded in this window.',
          denials_title: 'Denied permissions',
          denials_sub: 'The agent attempted an action and the key RBAC blocked it.',
          denials_empty: 'No permission denied in this window — the key RBAC covered everything the agents tried.',
          denials_hint: (perm, n) => `Grant \`${perm}\` to this key's group to unblock ~${n} attempt(s)/day.`,
          denials_hint_unknown: (n) => `The denial did not come from an RBAC permission (e.g. a key scope without write): check the key's scope — ~${n} attempt(s)/day.`,
          outcomes_title: 'Outcome distribution',
          outcomes_empty: 'No outcome data in this window.',
          outcome_ok: 'OK', outcome_denied: 'Denied', outcome_error: 'Error', outcome_not_found: 'Not found',
          servers_title: 'Health per server',
          servers_empty: 'No MCP server registered.',
          col_method: 'Method', col_route: 'Route', col_perm: 'Missing permission', col_count: 'Attempts',
          col_hint: 'Suggested action', col_tool: 'Tool', col_calls: 'Calls',
          col_server: 'Server', col_last_seen: 'Last activity', col_avg_ms: 'Avg latency', col_rate_hits: 'Rate-limit (429)',
          empty_title: 'No integration call in this window',
          empty_body: 'Create an MCP server in Settings › Integrations and connect an agent to start seeing usage here.',
          empty_cta: 'Open Settings › Integrations',
          never: 'never',
          footer: (win) => `Window: ${win}. Log retention: 90 days.`,
          sheet_kpis: 'KPIs', sheet_timeline: 'Timeline', sheet_top_tools: 'Top tools',
          sheet_top_routes: 'Top routes', sheet_denials: 'Denied permissions', sheet_outcomes: 'Outcomes', sheet_servers: 'Servers',
          csv_kpi_h: ['Metric', 'Value'],
          csv_timeline_h: ['Timestamp', 'Calls', 'Errors'],
          csv_top_tools_h: ['Tool', 'Calls'],
          csv_top_routes_h: ['Method', 'Route', 'Calls'],
          csv_denials_h: ['Method', 'Route', 'Missing permission', 'Attempts', 'Attempts/day'],
          csv_outcomes_h: ['Outcome', 'Calls'],
          csv_servers_h: ['Server', 'Last activity', 'Avg latency (ms)', 'Rate-limit (429)'],
        },
        cli_audit_page: {
          title: 'OLT commands',
          subtitle: 'Backlog of every CLI command sent to the OLTs — collection, operations, automatic actions, backup and terminal. Contains sensitive data; secrets typed as commands are masked.',
          period_1h: '1 h', period_24h: '24 h', period_7d: '7 d', period_30d: '30 d', period_custom: 'Custom',
          custom_from: 'From', custom_to: 'To', custom_apply: 'Apply',
          custom_invalid: 'Enter a start before the end.',
          custom_clamped: 'The API accepts at most 31 days; the start was adjusted.',
          window_label: 'Window',
          olt_label: 'OLT', olt_all: 'All OLTs', olt_none: 'No OLT has commands in the window.',
          origin_label: 'Origin', origin_all: 'All origins',
          actor_label: 'Who', actor_all: 'Everyone', actor_users: 'Specific user', actor_types: 'Actor type',
          status_label: 'Status', status_all: 'All statuses',
          selected_n: (n) => `${n} selected`,
          origin_groups: {
            collect: 'Collection', operation: 'Operation', auto: 'Automatic', backup: 'Backup',
            terminal: 'Terminal', unclassified: 'Unclassified', other: 'Other',
          },
          origin_group_hints: {
            collect: 'poll:*, autofind, inventory', operation: 'METHOD /api/… (screens and API), bulk jobs',
            auto: 'automatic actions', backup: 'backup and restore', terminal: 'interactive terminal',
            unclassified: 'path with no origin — investigate', other: 'unexpected origins',
          },
          origin_exact: 'Origin',
          actor_type_names: {
            user: 'User', system: 'System', auto_task: 'Automatic action', api_key: 'API key', unknown: 'Unknown',
          },
          actor_auto_task: (id) => (id ? `Automatic action #${id}` : 'Automatic action'),
          status_names: {
            ok: 'OK', device_error: 'Device error', timeout: 'Timeout', transport_error: 'Transport failure', canceled: 'Canceled',
          },
          only_writes: 'Writes only', only_errors: 'Errors only', show_bootstrap: 'Show bootstrap',
          search_ph: 'Search the command…', search_output: 'In output',
          search_output_warn: 'Output search is not indexed and is slow on large windows (seconds at 7 days or more).',
          min_duration: 'Duration ≥', min_ph: 'ms',
          clear_filters: 'Clear filters',
          facets_loading: 'Loading options…', facets_error: 'Could not load the options.',
          retry: 'Try again',
          chip_user: 'User', chip_session: 'Session', chip_remove: 'Remove filter',
          kpi_commands: 'Commands', kpi_errors: 'Errors', kpi_writes: 'Writes', kpi_p95: 'p95 duration', kpi_sessions: 'Sessions',
          kpi_errors_sub: (pct) => `${pct} of commands`,
          kpi_hint_errors: 'Click to show errors only',
          kpi_hint_writes: 'Click to show writes only',
          kpi_hint_p95: 'Click to show commands slower than the p95',
          kpi_hint_commands: 'Click to remove the error/write/duration filters',
          kpi_error: 'Could not load the indicators.',
          timeline_title: 'Timeline',
          timeline_hint: 'Click a bar (or drag) to narrow the period. Red = errors.',
          timeline_empty: 'No commands in this window.',
          tl_total: 'Commands', tl_ok: 'No error', tl_errors: 'Errors', tl_writes: 'Writes',
          tl_bucket: (label) => `${label} bars`,
          col_time: 'Time', col_olt: 'OLT', col_who: 'Who', col_origin: 'Origin', col_command: 'Command',
          col_status: 'Status', col_duration: 'Duration', col_response: 'Response',
          write_badge: 'Write to the OLT',
          system_label: 'System',
          ago: (n, unit) => `${n} ${{ s: 's', min: 'min', h: 'h', d: 'd' }[unit]} ago`,
          filter_by: (what) => `Filter by ${what}`,
          session_title: (id, seq) => `Session ${id} · command ${seq}`,
          bootstrap_row: 'bootstrap',
          interactive_row: 'terminal',
          redacted: 'secret masked',
          loaded_n: (n) => `${n} command(s) loaded`,
          load_more: 'Load more', loading_more: 'Loading…', end_of_list: 'End of list.',
          empty_title: 'No commands match this filter',
          empty_body: 'There are no commands in the chosen window with these filters. Widen the period, clear the filters or tick "Show bootstrap".',
          empty_no_data_title: 'No commands recorded yet',
          empty_no_data_body: 'As soon as a collection, an operation or the terminal talks to an OLT, the command shows up here.',
          error_title: 'Could not load the commands',
          open_detail: 'Open detail',
          open_terminal: 'terminal',
          // ---- Phase 14: detail, live, export ----
          detail_title: (id) => `Command #${id}`,
          detail_close: 'Close', detail_back: 'Back to the list',
          detail_error_title: 'Could not load the command',
          detail_not_found_title: 'Command not found',
          detail_not_found_body: 'The record may have been removed by retention (30 days by default) or does not exist in this account.',
          copy: 'Copy', copied: 'Copied', copy_failed: 'Could not copy',
          detail_command: 'Command', detail_response: 'Response',
          detail_when: 'Time', detail_duration: 'Duration', detail_olt: 'OLT', detail_view: 'Mode / view',
          detail_protocol: 'Protocol', detail_kind: 'Type',
          kind_names: { command: 'command', bootstrap: 'bootstrap', interactive: 'terminal' },
          response_empty: 'No response was recorded for this command.',
          response_error_lines: (n) => `${n} device error line(s)`,
          response_truncated: (shown, total) => `Response truncated: ${shown} of ${total} bytes`,
          response_masked: 'masked',
          response_masked_hint: 'Secrets appear as •••• (masked at capture).',
          detail_who: 'Who / from where',
          who_actor: 'Actor', who_ip: 'IP', who_request_id: 'Request ID', who_origin: 'Origin',
          who_auto_task: 'Automatic action', who_api_key: 'API key', who_none: '—',
          open_auto_task: 'Open automatic action',
          detail_session: 'Session',
          session_pos: (pos, size) => `Command ${pos} of ${size} on this connection`,
          session_prev: 'Previous command in the session', session_next: 'Next command in the session',
          session_filter: 'Filter the list by this session',
          session_truncated: (n) => `Showing only the first ${n} commands of the session.`,
          session_error: 'Could not load the session.', session_loading: 'Loading the session…',
          detail_links: 'Links',
          link_audit_log: 'See the action in the audit log',
          link_audit_log_hint: (email) => `Opens the audit log searching for ${email}. The audit log does not store the Request ID — use it to cross-check with the API inspector.`,
          link_onu: (serial) => `Open ONU ${serial}`,
          link_onu_note: 'Serial read from the command itself (simple match) and confirmed in the ONU registry.',
          link_olt: 'Open OLT',
          shortcuts_title: 'Shortcuts',
          shortcut_prev: 'previous command', shortcut_next: 'next command', shortcut_close: 'close',
          live_label: 'Live',
          live_disabled_custom: 'Live mode only works with relative periods (1 h to 30 d).',
          live_state_running: 'Live · every 5 s',
          live_state_scrolled: 'Paused while scrolling the list',
          live_state_detail: 'Paused while the detail is open',
          live_state_hidden: 'Tab hidden — no requests',
          live_state_error: (msg) => `Update failed: ${msg}`,
          live_new_n: (n) => `${n} new`,
          live_received_n: (n) => `+${n} since enabled`,
          live_flush: 'Show now',
          live_gap: 'Too many new commands to merge — refresh the list',
          export_csv: 'Export CSV', export_running: 'Exporting…',
          export_confirm_title: 'Export with the current filters?',
          export_confirm_body: (n, max) => (n == null
            ? `The window is large; the file may have up to ${max} rows.`
            : `About ${n} commands; the file has at most ${max} rows.`),
          export_cut_warn: (max) => `Over the limit: only the ${max} most recent will be exported.`,
          export_include_output: 'Include the device response (much larger file)',
          export_go: 'Export', export_cancel: 'Cancel',
          export_done: (name) => `CSV downloaded: ${name}`,
          export_truncated: (rows, max) => `Export cut at the limit: ${rows} of more than ${max} rows. Narrow the period or the filters.`,
          export_interrupted: 'The export was interrupted on the server — the file is incomplete.',
          export_failed: (msg) => `Export failed: ${msg}`,
          link_commands: 'Executed commands', link_commands_hint: 'Opens the command report for this OLT over the last 24 h.',
        },
        inventory: {
          title: 'ONU inventory',
          subtitle: 'Full list of authorized ONUs, with status, signal and provisioning data — filter and export for external analysis.',
          search_ph: 'Serial, MAC or customer…',
          stat_total: 'Total in filter', stat_online: 'Online', stat_critical: 'Critical signal', stat_offline: 'Offline',
          col_serial_mac: 'Serial / MAC', col_pon: 'PON', col_rx: 'Rx signal', col_type: 'Type', col_vlan: 'VLAN', col_authorized_at: 'Authorized at',
          empty: 'No ONU found with the current filters.',
          csv_h: ['Status', 'Customer', 'Serial', 'MAC', 'OLT', 'PON', 'Rx signal (dBm)', 'Type', 'VLAN', 'Mode', 'Authorized at'],
          mode_routing: 'Routing', mode_bridge: 'Bridge',
        },
        signal: {
          title: 'Signal quality',
          subtitle: 'Optical signal (Rx) distribution of online ONUs, highlighting those outside the acceptable range (too weak or saturating the receiver).',
          stat_with_reading: 'ONUs with a reading', stat_avg: 'Average signal (dBm)', stat_best: 'Best signal (dBm)', stat_worst: 'Worst signal (dBm)',
          weak_title: 'Critical signal (weak)', high_title: 'High signal (saturating)',
          weak_empty: 'No ONU with critical signal.', high_empty: 'No ONU with saturating signal.',
          csv_h: ['Reason', 'Customer', 'Serial', 'OLT', 'PON', 'Rx signal (dBm)'],
          csv_reason_weak: 'Critical signal (weak)', csv_reason_high: 'High signal (saturating)',
        },
        traffic: {
          title: 'Traffic summary',
          subtitle: 'Bandwidth usage per ONU over the last 24h — current and peak, sorted by the biggest consumers on the network.',
          load_failed: 'Failed to load the traffic report',
          fetch_failed: 'Failed to load traffic.',
          search_ph: 'Customer or device…',
          stat_count: 'ONUs in filter', stat_dl_agg: 'Aggregated current download', stat_ul_agg: 'Aggregated current upload', stat_peak_dl: 'Biggest peak (download)',
          truncated: (n) => `List limited to the first ${n} ONUs to keep the page responsive — refine the OLT filter to see the rest.`,
          col_onu: 'ONU', col_device: 'Device', col_dl_cur: 'Current download', col_ul_cur: 'Current upload', col_dl_peak: 'Peak download', col_ul_peak: 'Peak upload',
          empty: 'No ONU with traffic in the last 24h.',
          csv_h: ['ONU', 'Device', 'Current download (Mbps)', 'Current upload (Mbps)', 'Peak download (Mbps)', 'Peak upload (Mbps)'],
        },
        pon_outages: {
          title: 'PON port outages',
          subtitle: 'Detected outages affecting several ONUs on the same PON port at once — usually a fiber cut or an OLT port/board fault, not an individual customer problem.',
          fetch_failed: 'Failed to load PON port outages.',
          badge_one: 'unconfirmed outage', badge_many: 'unconfirmed outages',
          search_ph: 'OLT or PON port…',
          col_pon: 'PON port', col_affected: 'Affected ONUs', col_cause: 'Probable cause', col_since: 'Since',
          empty: 'No PON port outage right now.',
          csv_h: ['OLT', 'PON port', 'Affected ONUs', 'Total ONUs', 'Probable cause', 'Since'],
        },
        olt_overview: {
          title: 'OLT overview',
          subtitle: 'Management view of the OLT fleet (status, uptime, temperature) and the growth trend of ONU authorizations over time.',
          fetch_failed: 'Failed to load OLT overview.',
          chart_title: (n) => `ONU authorizations per day — ${n} in the period`,
          chart_series: 'Authorizations',
          search_ph: 'OLT name or vendor…',
          empty: 'No OLT registered.',
          csv_h: ['OLT', 'Vendor', 'Status', 'Uptime', 'Temperature (°C)', 'Last poll'],
        },
        poll_history: {
          title: 'SNMP/SSH collection (poll)',
          subtitle: 'Status and history of an OLT collection cycles (SNMP/SSH) — trigger an immediate poll or follow the duration and result of the last scheduled cycles.',
          status_failed: 'Error loading collection status.',
          trigger_failed: 'Error triggering collection.',
          running: '● Poll running…',
          waiting: 'Waiting for the next scheduled poll',
          trigger: 'Trigger immediate poll', triggering: 'Triggering…',
          col_start: 'Start', col_duration: 'Duration', col_method: 'Method', col_boards: 'Boards', col_ports: 'Ports', col_onus: 'ONUs',
          empty: 'No collection history for this OLT.',
          csv_h: ['Start', 'Duration (ms)', 'Method', 'Status', 'Boards', 'Ports', 'ONUs'],
        },
        models: {
          title: 'ONUs by type/vendor',
          subtitle: 'Distribution of the ONU fleet by model and vendor — useful for purchasing and support. Click a model in the table to see its ONUs.',
          fetch_failed: 'Failed to load the ONU fleet.',
          all_vendors: 'All vendors',
          kpi_vendors: 'Vendors', kpi_models: 'Models', kpi_top_model: 'Most common model', kpi_top3: 'Top 3 models', kpi_no_type: 'No type identified',
          loading: 'Loading the ONU fleet…',
          chart_treemap: 'Vendor → model', chart_treemap_hint: 'area = # of ONUs',
          chart_top15: 'Top 15 models', chart_top15_hint: 'stacked by status',
          chart_empty: 'No ONUs in the filter.', onus: 'ONUs',
          col_vendor: 'Vendor', col_model: 'Model', col_category: 'Category', col_total: 'Total', col_online: 'Online', col_offline: 'Offline', col_critical: 'Critical signal', col_pct: '% of fleet',
          table_empty: 'No ONU in the current filter.',
          footer: (models, onus) => `${models} models · ${onus} ONUs in filter (whole fleet loaded).`,
          drawer_close: 'Close', unknown: 'Unidentified',
          mode_routing: 'Routing', mode_bridge: 'Bridge',
          csv_model_h: ['Vendor', 'Model', 'Category', 'Total', 'Online', 'Offline', 'Critical signal', '% of fleet'],
          csv_onu_h: ['Serial', 'Customer', 'Vendor', 'Model', 'Category', 'OLT', 'Zone', 'Status'],
          sheet_by_model: 'By model', sheet_onus: 'ONUs',
        },
        plans: {
          title: 'Customers by speed plan',
          subtitle: 'Subscribers grouped by the bandwidth profile pair (download / upload) that OLTM recorded having applied. Click a plan to see its per-OLT breakdown.',
          kpi_plans: 'Plans', kpi_subs: 'Subscribers with a plan', kpi_pct: '% of fleet with a plan', kpi_top: 'Best-selling plan', kpi_no_plan: 'Subscribers with no plan',
          loading: 'Loading plans…',
          empty: 'No speed plan applied to ONUs in the current filter.',
          no_plan: 'No plan', subscribers: 'subscribers',
          drawer_by_olt: 'Breakdown by OLT', drawer_no_dist: 'No per-OLT breakdown.', drawer_close: 'Close',
          chart_subs: 'Subscribers per plan', chart_subs_hint: (n) => `${n} plans`,
          chart_share: 'Share', chart_share_hint: 'subscribers per plan',
          tt_online: 'Online', tt_subscribers: 'Subscribers',
          col_plan: 'Plan', col_download: 'Download', col_upload: 'Upload', col_subscribers: 'Subscribers', col_online: 'Online', col_pct: '% of total',
          table_empty: 'No plan in the current filter.',
          disclaimer: 'The report reflects what OLTM recorded having applied (onu_speed_profiles), not what is configured on the equipment — the current Huawei model may not actually apply the bandwidth in many cases.',
          csv_plan_h: ['Plan', 'Download (kbps)', 'Upload (kbps)', 'Subscribers', 'Online', '% of total'],
          csv_byolt_h: ['Plan', 'OLT', 'Subscribers'],
          sheet_plans: 'Plans', sheet_byolt: 'Plans x OLT',
        },
        uptime_page: {
          title: 'Availability (uptime)',
          subtitle: 'Percentage of time each OLT was online in the period, for SLA and management reports. History starts when the collector recorded the first status transition — earlier windows count as "no data", not as downtime.',
          sla_meta: 'SLA target', no_data_badge: 'no data', coverage_short: 'cov.',
          st_error: 'Collection error', st_degraded: 'Degraded',
          kpi_fleet: 'Fleet average uptime', kpi_worst: 'Worst uptime', kpi_incidents: 'Incidents in the period', kpi_longest: 'Longest continuous outage', kpi_partial_cov: 'OLTs with coverage < 100%',
          loading: 'Loading availability…', empty: 'No OLT registered.',
          since_notice: (d) => `Availability data since ${d} — the selected period starts before that, and the earlier stretch shows as "no data" (lowers coverage, does not count as downtime).`,
          no_data_notice: 'The collector has not recorded any OLT status transition yet. The report applies from the first change detected.',
          ribbon_title: (from, to) => `Availability strip — ${from} to ${to}`,
          legend_online: 'Online', legend_down: 'Down', legend_no_data: 'No data',
          d_incidents: 'Incidents', d_downtime: 'Downtime', d_longest: 'Longest outage',
          d_windows: 'Downtime windows', d_see_alerts: 'View alerts', d_no_incidents: 'No downtime recorded in the period.',
          d_uptime_cov: (u, c) => `${u}% uptime · coverage ${c}%`, d_no_data_period: 'no availability data in the period', d_until: 'until', d_close: 'Close',
          tip_no_data: 'No data',
          col_uptime: 'Uptime', col_downtime: 'Downtime', col_incidents: 'Incidents', col_longest: 'Longest outage', col_coverage: 'Coverage', col_status_now: 'Current status',
          table_empty: 'No OLT.',
          footer: (n, sla) => `${n} OLTs · uptime measured only over the time with data (coverage) · SLA target ${sla}% · click an OLT to see its downtime windows.`,
          csv_summary_h: ['OLT', 'Uptime %', 'Coverage %', 'Downtime (s)', 'Incidents', 'Longest outage (s)', 'Current status'],
          csv_incidents_h: ['OLT', 'Start', 'End', 'Duration (s)', 'Status'],
          csv_no_incidents: '— no incident in the period —',
          sheet_summary: 'Summary', sheet_incidents: 'Incidents',
        },
        swaps: {
          title: 'ONU swap history',
          subtitle: 'Equipment replacements per customer over time — same point/customer, different serial (RMA, upgrade, defect). Adjust the reason directly in the table.',
          req_failed: 'Request failed.',
          reason_saved: 'Reason updated', reason_save_failed: 'Failed to save reason',
          reasons: { rma: 'RMA', upgrade: 'Upgrade', defect: 'Defect', reinstall: 'Reinstall', unknown: 'To classify' },
          all_reasons: 'All reasons', all_types: 'Swaps and reinstalls', type_swap: 'Equipment swaps only', type_reinstall: 'Reinstalls only',
          filter_customer_ph: 'Filter by customer…',
          kpi_swaps: 'Swaps in the period', kpi_customers: 'Affected customers', kpi_avg_gap: 'Average time without ONU', kpi_top_reason: 'Predominant reason', kpi_last30: 'Swaps in the last 30d',
          loading: 'Loading swaps…',
          empty: 'No ONU swap recorded for the current period/filter.',
          months: (n) => `${n} swap${n > 1 ? 's' : ''}`,
          col_date: 'Date', col_pon: 'PON', col_cto: 'Splitter', col_serial: 'Serial (old → new)', col_model: 'Model', col_gap: 'Without ONU', col_reason: 'Reason', col_detected: 'Detection', col_by: 'By',
          table_empty: 'No swap in the current filter.',
          footer: (shown, total) => `${shown} of ${total} swaps in the period · automatic detection at authorization time + historical backfill.`,
          d_title: 'ONU swap', d_close: 'Close',
          d_equipment: 'Equipment', d_model: 'Model', d_reason: 'Reason', d_detection: 'Detection', d_gap: 'Customer without ONU', d_registered_by: 'Registered by',
          d_old: 'Old', d_new: 'New', d_onu_gone: 'ONU is no longer in the registry.',
          csv_h: ['Date', 'Customer', 'ONU (name)', 'OLT', 'PON', 'Splitter', 'Old serial', 'New serial', 'Old model', 'New model', 'Reason', 'Detection', 'Registered by', 'Time without ONU (s)'],
          sheet: 'ONU swaps',
        },
        consumption: {
          title: 'Per-customer usage',
          subtitle: 'Aggregated bandwidth usage per customer in the period — P95, average, peak and total in GB. The traffic of all a customer ONUs is summed per instant before the percentile. Useful for fair-use policies.',
          fetch_failed: 'Failed to load.',
          search_ph: 'Search customer…', fairuse_label: 'Fair-use threshold', only_over: 'Only above threshold',
          truncated: 'List truncated to the 2000 customers with the highest download P95. Refine by OLT/zone to see the rest.',
          kpi_customers: 'Customers with traffic', kpi_total: 'Total base usage', kpi_top1: 'Top-1 customer (P95)', kpi_avg_p95: 'Base average P95', kpi_over: 'Above threshold',
          kpi_over_sub: (gb) => `≥ ${gb} GB`, kpi_over_none: 'set a threshold',
          loading: 'Loading per-customer usage…',
          empty: 'No customer with traffic collected in the period. Check that ONUs have the "customer" field filled and that traffic collection is active.',
          chart_top20: 'Top 20 customers by download P95', chart_hint: (n) => `${n} customers`, chart_tt: 'P95 download',
          col_customer: 'Customer', col_onus: 'ONUs', col_p95_down: 'P95 down', col_p95_up: 'P95 up', col_avg_down: 'Avg down', col_peak_down: 'Peak down', col_total: 'Total (down+up)', col_olts: 'OLT(s)', col_zone: 'Zone',
          table_empty: 'No customer in the current filter.',
          footer: (shown, total) => `${shown} of ${total} customers · main metric: 95th percentile of download · click a customer to see the aggregated series and its ONUs.`,
          d_onus_period: (n) => `${n} ONU${n === 1 ? '' : 's'} · aggregated usage in the period`,
          d_close: 'Close', d_loading_series: 'Loading series…',
          d_p95_down: 'P95 download', d_peak_down: 'Peak download', d_total: 'Total (down+up)',
          d_agg_traffic: 'Customer aggregated traffic', d_no_samples: 'No traffic samples in the period.',
          d_customer_onus: 'Customer ONUs', d_no_onu: 'No ONU with traffic in the period.',
          csv_h: ['Customer', 'ONUs', 'P95 down (Mbps)', 'P95 up (Mbps)', 'Avg down (Mbps)', 'Peak down (Mbps)', 'Total down (GB)', 'Total up (GB)', 'Total (GB)', 'Above threshold', 'OLT(s)', 'Zone(s)'],
          csv_yes: 'yes', sheet: 'Customers',
        },
        bulk: {
          title: 'Bulk job log',
          subtitle: 'History of mass-action runs over ONUs — restart and zone change applied to a filtered set. Click a row to see the parameters and the item-by-item result.',
          req_failed: 'Request failed.',
          st: { pending: 'Pending', running: 'Running', completed: 'Completed', failed: 'Failed', partial: 'Partial' },
          ist: { pending: 'Pending', running: 'Processing', success: 'Success', failed: 'Failed' },
          actions: { restart: 'Restart ONUs', change_zone: 'Change zone' },
          onu_st: { unconfigured: 'unconfigured', online: 'online', offline: 'offline', los: 'LOS', dyinggasp: 'dying-gasp', disabled: 'disabled', removed: 'removed' },
          unknown_ref: 'unknown', system_user: 'system',
          new_bulk: 'New bulk action',
          tgt_olt: (n) => `OLT ${n}`, tgt_zone: (n) => `zone ${n}`, tgt_pon: '1 PON port',
          tgt_status: (s) => `status ${s}`, tgt_selected: (n) => `${n} selected ONUs`, tgt_all: 'all ONUs', tgt_suffix: (n) => `${n} ONUs`,
          all_statuses: 'All statuses', all_actions: 'All actions', all_users: 'All users',
          search_ph: 'Search in filter / parameters…',
          kpi_jobs: 'Jobs in the period', kpi_onus: 'Affected ONUs', kpi_success_rate: 'Success rate', kpi_problem: 'Failed / partial jobs', kpi_biggest: 'Biggest job', kpi_biggest_sub: 'ONUs in a single job',
          loading: 'Loading bulk jobs…', empty: 'No bulk job for the current period / filter.',
          chart_daily: 'Jobs per day', chart_daily_hint: 'processed ONUs · success vs failure', chart_no_period: 'No data in the period.',
          chart_by_action: 'Jobs per action', chart_by_action_hint: '# of runs', chart_no_data: 'No data.',
          tt_success: 'Success', tt_failure: 'Failure', tt_jobs: 'jobs',
          col_date: 'Date', col_action: 'Action', col_user: 'User', col_target: 'Target', col_progress: 'Progress', col_status: 'Status', col_duration: 'Duration',
          table_empty: 'No job in the current filter.',
          footer: (shown, total) => `${shown} of ${total} jobs in the period.`, footer_more: ' Showing the 500 most recent jobs — narrow the period to see more.',
          prog: (ok, fail, total) => `${ok} ok · ${fail} fail · ${total} total`,
          d_close: 'Close', d_status: 'Status', d_total_onus: 'Total ONUs', d_success_fail: 'Success / Failure', d_duration: 'Duration',
          d_filter: 'Job filter', d_no_filter: '— no filter (all ONUs) —', d_params: 'Parameters', d_no_params: '— none —',
          d_items: (n) => `Items (${n})`, d_loading_items: 'Loading items…', d_no_items: 'This job has no items.',
          d_showing_items: (shown, total) => `Showing the first ${shown} of ${total} items.`,
          col_serial: 'Serial', col_error: 'Error',
          csv_jobs_h: ['Date', 'Action', 'User', 'Target', 'Total ONUs', 'Success', 'Failure', 'Status', 'Start', 'End', 'Duration'],
          csv_items_h: ['Job date', 'Action', 'Serial', 'Customer', 'OLT', 'Status', 'Error'],
          csv_items_failed: 'Failed to load items for the spreadsheet', csv_cap: (n) => `Item export limited to ${n} rows.`,
          sheet_jobs: 'Jobs', sheet_items: 'Items',
        },
      },
    },
  },
  es: {
    nav: {
      features: 'Funciones',
      vendors: 'Compatibilidad',
      stats: 'Plataforma',
      pricing: 'Planes',
      contact: 'Contacto',
      login: 'Ingresar',
      trial: 'Prueba gratis',
    },
    hero: {
      kicker: 'PLATAFORMA SAAS PARA PROVEEDORES DE INTERNET',
      headlines: [
        ['Gestiona tu flota de', 'OLTs', 'en un solo panel.'],
        ['Monitorea', 'fibra óptica', 'en tiempo real.'],
        ['Administra OLTs y', 'ONUs', 'a escala, sin dolor de cabeza.'],
        ['Tu red GPON,', 'bajo control', 'desde el primer minuto.'],
      ],
      sub: 'OLTM centraliza la gestión, el monitoreo y el licenciamiento de OLTs Huawei, ZTE y Fiberhome en una sola plataforma — hecha para ISPs serios.',
      cta_primary: 'Comenzar prueba gratis',
      cta_secondary: 'Hablar con un experto',
      pill_live: 'EN VIVO',
      pill_status: 'Todos los sistemas operando',
    },
    features: {
      eyebrow: '— FUNCIONES',
      title: 'Todo lo que tu NOC necesita.',
      sub: 'Operación esbelta, sin retrabajo. Conectividad, seguridad y visibilidad en un solo lugar.',
      items: [
        { t: 'Gestión Multi-Vendor', d: 'Huawei, ZTE y Fiberhome mediante integradores unificados. Comandos abstraídos, resultado consistente.' },
        { t: 'Seguridad Enterprise', d: 'JWT RS256, MFA TOTP, RBAC granular y credenciales SNMP cifradas en reposo.' },
        { t: 'Monitoreo en tiempo real', d: 'Polling SNMP, heartbeat por instancia y alertas instantáneas vía webhooks o Telegram.' },
        { t: 'Sistema todo en Cloud', d: 'Ejecuta tu sistema completo en nuestro clúster multi-tenant, con total seguridad y respaldos.' },
        { t: 'API & Webhooks', d: 'Integra con tu ERP, sistema de facturación y herramientas internas. Todo documentado.' },
        { t: 'Auditoría completa', d: 'Cada provisión, cada reset de ONU, cada acceso — todo registrado y exportable.' },
      ],
    },
    vendors: {
      eyebrow: '— COMPATIBILIDAD',
      title: 'Funciona con lo que ya tienes.',
      sub: 'Drivers maduros para los fabricantes más utilizados en LatAm y el mundo.',
      list: ['HUAWEI', 'ZTE', 'FIBERHOME', 'PARKS', 'DATACOM', 'V-SOL'],
      note: '¿Necesitas otro fabricante? Solicítalo en el formulario — lo agregamos.',
    },
    stats: {
      eyebrow: '— EN NÚMEROS',
      title: 'La plataforma corre 24/7.',
      items: [
        { label: 'OLTs gestionadas', key: 'olts_managed' },
        { label: 'ONUs en línea ahora', key: 'onus_online' },
        { label: 'ISPs activos', key: 'isps_active' },
        { label: 'Uptime (90d)', key: 'uptime', suffix: '%' },
        { label: 'Alertas tratadas hoy', key: 'alerts_handled_today' },
        { label: 'Países atendidos', key: 'countries' },
      ],
    },
    misc: {
      lang_label: 'IDIOMA',
      theme_label: 'TEMA',
      reshuffle: 'Recargar layout',
    },
    app: {
      nav: {
        dashboard: 'Panel',
        unconfigured: 'No configuradas',
        configured: 'Configuradas',
        graphs: 'Gráficos',
        events: 'Eventos',
        diagnostics: 'Diagnóstico',
        tasks: 'Tareas',
        reports: 'Reportes',
        save_config: 'Guardar',
        settings: 'Ajustes',
        log_out: 'Salir',
        role_owner: 'Propietario',
      },
      reports_menu: ['Inventario de ONUs', 'Calidad de señal', 'Resumen de tráfico', 'Exportar auditoría', 'Caídas por puerto PON', 'Resumen de OLTs', 'Recolección SNMP/SSH (poll)'],
      common: {
        search: 'Buscar…',
        filter: 'Filtrar',
        save_changes: 'Guardar cambios',
        cancel: 'Cancelar',
        prev: 'Anterior',
        next: 'Siguiente',
        showing: 'Mostrando',
        of: 'de',
        all_olts: 'Todas las OLTs',
        all_zones: 'Todas las zonas',
        all_types: 'Todos los tipos',
        all_roles: 'Todos los roles',
        all_statuses: 'Todos los estados',
        all_severities: 'Todas las severidades',
        last_24h: 'Últimas 24h',
        last_7d: 'Últimos 7 días',
        last_30d: 'Últimos 30 días',
        last_90d: 'Últimos 90 días',
        new: 'Nuevo',
        add: 'Agregar',
        back: 'Volver',
        details: 'Detalles',
        monitor: 'Monitorear',
        actions: 'Acciones',
        status: 'Estado',
        started: 'Iniciada',
        user: 'Usuario',
      },
      banner: {
        updated_to: 'ha sido actualizado a la versión',
        see_new: 'Ver novedades',
      },
      dashboard: {
        kpis: {
          waiting_authorization: 'Esperando autorización',
          online: 'En línea',
          total_offline: 'Total offline',
          low_signals: 'Señales bajas',
          d_resync_new: 'D: 0 · Resync: 1 · Nuevas: 1',
          total_authorized: 'Autorizadas: 12.648',
          pwrfail_los_na: 'PwrFail: 833 · LoS: 267 · N/A: 83',
          warning_critical: 'Alerta: 1.082 · Crítico: 232',
        },
        info_valid: 'Información válida a las 01:20',
        network_status: 'Estado de la red',
        daily_network_status: 'Estado diario de la red',
        more_graphs: 'Más gráficos ▾',
        online_onus: 'ONUs en línea',
        power_fail: 'Falla eléctrica',
        signal_loss: 'Pérdida de señal',
        na: 'N/D',
        maximum: 'Máximo',
        auth_per_day: 'Autorizaciones de ONU por día',
        pon_outage: 'Interrupción PON',
        no_pon_outages: 'Ninguna interrupción de PON en este momento.',
        olt_name: 'Nombre de OLT',
        board_port: 'Placa/Puerto',
        onus: 'ONUs',
        los: 'LOS',
        power: 'Energía',
        possible_cause: 'Causa posible',
        since: 'Desde',
        olts: 'OLTs',
        all: 'Todas ▾',
        info: 'Avisos',
        view_all_info: 'Ver todos los avisos',
        olt_issues: 'OLTs con fallas',
        no_olt_issues: 'Ninguna OLT con fallas en este momento.',
        uptime: 'Uptime',
        online_series: 'Online',
        offline_series: 'Offline',
      },
      not_validated: {
        badge: 'No validado en vivo',
        tooltip: 'Esta función se probó con simulación y pruebas automatizadas, pero aún no se confirmó en una OLT real. Verifica el resultado en la OLT después de usarla.',
      },
      unconfigured: {
        title: 'ONUs no configuradas',
        sub: 'ONUs esperando autorización. Usa presets para acelerar el onboarding.',
        cache_note: 'Esta lista proviene de la caché. El escaneo automático de las OLTs corre en ciclos largos (≈ 2 h, configurable por instancia); usa Actualizar para escanear ahora.',
        auto_actions: 'Acciones automáticas',
        serial: 'Serial',
        olt: 'OLT',
        detected: 'Detectada',
        authorize: 'Autorizar',
        waiting: 'Esperando',
      },
      vlan_scope: {
        out_of_rule: 'fuera de la regla de la PON',
        out_of_registry: 'fuera del registro de la OLT',
        none_allowed: 'Ninguna VLAN está habilitada para la PON {pon} — habilítela en OLT › VLANs. Aún puede autorizar sin VLAN.',
        none_allowed_link: 'Abrir las VLANs de la OLT',
        preset_vlan_skipped: 'La VLAN {vlan} del preset no está permitida en la PON {pon} y no se aplicó.',
        current_out_of_rule: 'La VLAN actual de esta ONU ({vlan}) está fuera de la regla de la PON {pon}; sigue listada solo para editar sin perder el valor.',
        auto_vlan_warning: 'La VLAN {vlan} del preset no vale en las PONs {pons}: los elementos en esas PONs se omitirán (vlan_not_allowed_on_pon).',
        auto_vlan_link: 'Ver la regla de la VLAN',
      },
      vlans_tab: {
        col_vlan: 'VLAN-ID',
        col_pon: 'Puertos PON',
        col_description: 'Descripción',
        col_iptv: 'IPTV',
        col_mgmt: 'Gestión/VoIP',
        col_dhcp: 'DHCP Snooping',
        col_lan2lan: 'LAN a LAN',
        col_onus: 'ONUs',
        col_actions: 'Acciones',
        refresh: 'Actualizar VLANs',
        add: 'Agregar VLAN(s)',
        delete_multiple: 'Eliminar múltiples VLANs',
        loading: 'Cargando…',
        load_error: 'No se pudieron cargar las VLANs de la OLT.',
        retry: 'Intentar de nuevo',
        empty: 'Ninguna VLAN descubierta. Ejecute un poll para recolectar vía SNMP.',
        pon_all: 'Todas',
        pon_all_except: 'Todas excepto',
        pon_none: 'Ninguna',
        pon_load_error: 'No se pudieron cargar los puertos PON — el resumen de la columna "Puertos PON" no está disponible.',
        edit_title: 'Editar la VLAN {n}',
        onus_title: 'Ver las ONUs de la VLAN {n}',
        sort_by: 'Ordenar por {c}',
        flag_on: 'Sí',
        flag_off: 'No',
        local_only: 'Metadato local, aún no aplicado en la OLT.',
        l2l_applied_note: 'Se aplica en la OLT al guardar: la VLAN se vincula al perfil de servicio OLTM_L2L (user-bridging).',
        l2l_risk: 'Atención: con LAN-to-LAN, clientes distintos de esta VLAN pasan a verse en la capa 2 (ARP/DHCP falsos, escaneos, más broadcast). No lo active en una VLAN compartida por todos los clientes — use una VLAN exclusiva.',
        l2l_confirm: '{n} ONU(s) de esta VLAN pasarán a verse entre sí. ¿Aplicar en la OLT?',
        l2l_live_checking: 'Leyendo el estado en la OLT…',
        l2l_live_on: 'En la OLT: LAN-to-LAN activo (perfil {p}).',
        l2l_live_off: 'En la OLT: LAN-to-LAN desactivado.',
        l2l_live_error: 'No se pudo leer el estado en la OLT: {e}',
        l2l_live_drift: 'El estado en la OLT difiere del guardado en OLTM. Guardar reaplica el estado elegido.',
        l2l_live_foreign: 'La VLAN usa un perfil de servicio que no es de OLTM ({p}); OLTM no lo modifica.',
        l2l_result_on: 'LAN-to-LAN activado en la OLT (confirmado por lectura).',
        l2l_result_off: 'LAN-to-LAN desactivado en la OLT (confirmado por lectura).',
        l2l_result_nochange: 'La OLT ya estaba así — no se escribió nada.',
        l2l_result_diverged: 'La OLT no confirmó el LAN-to-LAN pedido — revise el estado real.',
        edit: 'Editar',
        delete: 'Eliminar',
        delete_confirm: '¿Eliminar esta VLAN?',
        delete_confirm_used: 'En uso por {n} ONU(s) — ¿eliminar?',
        delete_ok: 'VLAN {n} eliminada.',
        delete_fail: 'Error al eliminar la VLAN {n} en la OLT.',
        batch_title: 'Eliminar múltiples VLANs',
        batch_label: 'VLAN ID(s) a eliminar',
        batch_placeholder: 'ej: 300 o 300-305 o 300,302,305',
        batch_hint: 'Un ID, un rango (100-105) o una lista separada por comas. Cada VLAN se quita de la OLT (undo vlan).',
        batch_invalid: 'Use solo números de 1 a 4 dígitos separados por coma o guion (ej.: 100,102-105).',
        batch_confirm: '¿Eliminar estas VLANs de la OLT?',
        batch_yes: 'Eliminar',
        batch_no: 'Cancelar',
        batch_close: 'Cerrar',
        batch_running: 'Eliminando…',
        batch_summary: '{ok} eliminada(s), {fail} con error.',
        batch_result_ok: 'eliminada',
        batch_result_fail: 'falló',
        batch_error: 'Error al eliminar las VLANs en la OLT.',
        edit_page_title: 'Editar VLAN',
        edit_load_error: 'No se pudo cargar la VLAN.',
        edit_not_found: 'VLAN no encontrada en esta OLT.',
        field_vlan_id: 'VLAN-ID',
        field_description: 'Descripción',
        field_description_hint: 'Déjela vacía para eliminar la descripción de la VLAN.',
        description_olt_warn: 'La descripción modificada se grabará en la OLT al guardar (vlan desc).',
        field_iptv: 'VLAN multicast, usada para IPTV',
        field_mgmt: 'VLAN de gestión/VoIP',
        field_dhcp: 'DHCP Snooping en la VLAN',
        field_lan2lan: 'Habilitar comunicación directa entre ONUs en esta VLAN (LAN a LAN)',
        flags_operator_note: 'IPTV y Gestión/VoIP están definidos manualmente; el poll no los sobrescribe.',
        flags_revert: 'Volver al valor de la OLT',
        flags_revert_hint: 'IPTV y Gestión/VoIP vuelven a leerse de la OLT. El próximo poll repone sus valores.',
        flags_revert_pending: 'Al guardar, IPTV y Gestión/VoIP vuelven a seguir la OLT.',
        flags_revert_undo: 'Deshacer',
        pon_block_title: 'Puertos PON en los que esta VLAN puede usarse',
        pon_hint: 'Todo marcado por defecto. Desmarcar una PON impide usar esta VLAN en ella en nuevas autorizaciones y configuraciones; lo que ya existe no cambia.',
        pon_show: 'Mostrar puertos PON',
        pon_hide: 'Ocultar puertos PON',
        pon_total: '{c}/{t} PONs marcadas',
        pon_board: 'Placa {n}',
        pon_board_count: '{c}/{t}',
        pon_check_slot: 'marcar todas',
        pon_uncheck_slot: 'desmarcar todas',
        pon_check_all: 'Marcar todas las PONs de la OLT',
        pon_none_selected: 'Ninguna PON marcada — esta VLAN no podrá usarse en ningún puerto.',
        pon_empty: 'La OLT no tiene puertos PON registrados.',
        pon_edit_load_error: 'No se pudieron cargar los puertos PON de esta OLT.',
        save: 'Guardar',
        saving: 'Guardando…',
        cancel: 'Cancelar',
        save_confirm_none: 'Esta VLAN dejará de poder usarse en cualquier PON. ¿Guardar?',
        save_yes: 'Guardar',
        save_no: 'Volver',
        save_ok: 'VLAN {n} guardada.',
        save_nochange: 'Nada cambió.',
        save_fail: 'Error al guardar la VLAN {n}.',
        save_local_failed: 'La OLT fue modificada, pero falló el registro local de la VLAN {n} — repita la misma operación para sincronizar.',
        back: 'Volver a las VLANs',
        filter_vlan_chip: 'VLAN {n} — todas las ONUs que la usan',
        filter_vlan_clear: 'Quitar filtro de VLAN',
      },
      configured: {
        title: 'ONUs configuradas',
        sub: 'Todas las ONUs autorizadas de tu flota.',
        customer: 'Cliente',
        name: 'Nombre',
        onu: 'ONU',
        type: 'Tipo',
        rx_signal: 'Señal',
        uptime: 'Uptime',
        online: 'En línea',
        offline: 'Offline',
        broken: 'Señal crítica',
        high_signal: 'Señal alta',
        serial_mac: 'SN / MAC',
        model: 'Modelo',
        zone: 'Zona',
        odb: 'ODB',
        vlan: 'VLAN',
        mode: 'B/R',
        bridge: 'Bridge',
        router: 'Router',
        voip: 'VoIP',
        tv: 'TV',
        voiptv: 'VoIP - TV',
        details: 'Ver',
        filter_status: 'Estado',
        filter_zone: 'Zona',
        filter_odb: 'ODB',
        filter_model: 'Modelo',
        filter_mode: 'Modo',
        filter_all: 'Todos',
        columns: 'Columnas',
        no_results: 'Ninguna ONU coincide con los filtros.',
        not_authorized: 'No autorizada por OLTM',
        mgmt_ip: 'IP de gestión',
        sw_version: 'Versión SW',
        distance: 'Distancia',
        cto_port: 'Puerto CTO',
        authorized_at: 'Fecha de autor.',
        load_more: 'Cargar más',
        loading_more: 'Cargando más…',
        end_of_list: 'Fin de la lista',
      },
      graphs: {
        title: 'Gráficos',
        sub: 'Analítica de tráfico, PON, uplink y señal.',
        tabs: ['OLT', 'Uplink', 'PON', 'Tráfico', 'Señal'],
        panels: ['CPU / Memoria', 'Temperatura', 'Throughput uplink', 'Potencia óptica'],
        graphs_for: 'Gráficos para',
        olts: 'OLT',
        board: 'Placa',
        port: 'Puerto',
        zone: 'Zona',
        cto: 'CTO (Divisor)',
        any: 'Cualquiera',
        showing_for: 'Mostrando datos de',
      },
      diagnostics: {
        title: 'Diagnóstico',
        sub: 'Diagnóstico masivo para ONUs con problemas de señal.',
        reboot_selected: 'Reiniciar seleccionadas',
        resync_selected: 'Resincronizar seleccionadas',
        signal: 'Señal',
        temp: 'Temp.',
        critical: 'Crítico',
        warning: 'Alerta',
      },
      onu_page: {
        back_to_list: 'Volver a ONUs',
        not_found_title: 'ONU no encontrada',
        not_found_sub: 'Ninguna ONU coincide con el serial:',
        update_in: 'actualización en',
        olt: 'OLT',
        board: 'Placa',
        port: 'Puerto',
        onu: 'ONU',
        gpon_channel: 'Canal GPON',
        sn: 'SN',
        onu_type: 'Tipo ONU',
        auth_preset: 'Preselección de configuración',
        zone: 'Zona',
        cto: 'CTO (Divisor)',
        name: 'Nombre',
        onu_name: 'Nombre de la ONU',
        customer_name: 'Nombre del cliente',
        address: 'Dirección',
        contact: 'Contacto',
        auth_date: 'Fecha de autorización',
        history: 'Historial',
        external_id: 'ID externo de la ONU',
        section_client: 'Cliente',
        section_network_location: 'Ubicación en la red',
        section_status_signal: 'Estado y señal',
        section_network_config: 'Red y configuración',
        online_since: 'En línea desde',
        distance: 'Distancia',
        status: 'Estado',
        rx_signal: 'Señal Rx ONU/OLT',
        tr069: 'TR069 Profile',
        mgmt_ip: 'IP de gestión',
        vlans: 'VLANs anexadas',
        onu_mode: 'Modo ONU',
        config_mode: 'Modo de config...',
        pppoe_user: 'Usuario PPPoE',
        pppoe_pass: 'Contraseña PPPoE',
        get_status: 'Obtener estado',
        show_running_config: 'Mostrar config en ejecución',
        sw_info: 'Información SW',
        live: '¡LIVE!',
        traffic_signal: 'Tráfico/Señal',
        traffic: 'tráfico',
        signal: 'señal',
        charts_section: 'Gráficos',
        chart_signal: 'Señal óptica',
        chart_traffic: 'Tráfico',
        chart_last_24h: 'últimas 24h',
        download: 'Descarga',
        upload: 'Subida',
        download_short: 'Descargar',
        read_only: 'solo lectura',
        speed_profiles: 'Perfiles de velocidad',
        service_port_id: 'ID puerto de servicio',
        user_vlan: 'VLAN del usuario',
        action: 'Acción',
        configure: 'Configurar',
        manage_service_port: 'Asumir gestión',
        sp_load_error: 'Fallo al leer service-ports de la OLT',
        retry: 'Reintentar',
        ethernet_ports: 'Puertos Ethernet',
        port_col: 'Puerto',
        admin_state: 'Estado administrativo',
        mode: 'Modo',
        dhcp: 'DHCP',
        enabled: 'Habilitado',
        no_control: 'No control',
        voip_service: 'Servicio VoIP',
        sip_profile: 'Perfil SIP',
        number: 'Número',
        enable: 'Habilitar',
        disable: 'Deshabilitar',
        not_defined: 'No definido',
        catv: 'CATV',
        enable_catv: 'Habilitar CATV',
        catv_unsupported: 'No soportado por el Tipo de ONU',
        reboot: 'Reiniciar',
        resync_config: 'Resincronizar configuración',
        restore_defaults: 'Restaurar valores',
        disable_onu: 'Deshabilitar ONU',
        enable_onu: 'Reautorizar ONU',
        delete_onu: 'Eliminar',
        confirm_prompt: '¿Está seguro?',
        confirm_yes: 'Sí',
        confirm_no: 'No',
        move_onu_title: 'Mover ONU',
        move: 'Mover',
        close: 'Cerrar',
        update_gpon_title: 'Actualizar canal GPON',
        update: 'Actualizar',
        gpon_info_1: 'SmartOLT asigna IDs de ONU del rango 0-127 al canal GPON y del rango 128-255 a los canales XG/XGS-PON.',
        gpon_info_2: 'Una vez agotado el rango 128-255, asigna del rango 0-127 tanto para GPON como para XG/XGS-PON.',
        gpon_info_3: 'Consejo: las ONUs compatibles con XGPON previamente autorizadas en el canal GPON deben cambiarse al canal XGPON para liberar IDs para las ONUs GPON.',
        replace_sn_title: 'Reemplazar ONU por SN',
        replace: 'Reemplazar',
        sn_helper: 'Use la lupa para buscar en la lista de no configuradas para este PON',
        location_title: 'Actualizar detalles de ubicación',
        cto_port: 'Puerto del CTO',
        address_full: 'Dirección o comentario',
        latitude: 'Latitud',
        longitude: 'Longitud',
        map: 'Mapa',
        ext_id_title: 'Actualizar ID externo de la ONU',
        ext_id_helper: 'Su referencia para esta ONU en sistemas de API o facturación (contrato, ERP…). Se guarda solo en OLTM — no se envía a la OLT. Déjelo vacío para volver al valor por defecto (el serial). Máx. 255 caracteres.',
        type_title: 'Cambiar tipo de ONU',
        type_select: 'Tipo de ONU',
        type_placeholder: 'Seleccione un tipo…',
        type_scope_note: 'Solo cambia el vínculo en OLTM: el tipo define la etiqueta y las capacidades mostradas (puertos Ethernet, modo WAN, CATV). No se envía nada a la OLT y los perfiles de línea/servicio de la ONU en el equipo siguen igual.',
        type_summary: (from, to) => (from ? `${from} → ${to}` : `Sin tipo → ${to}`),
        type_saved: 'Tipo de ONU actualizado',
        type_save_error: 'Error al cambiar el tipo de ONU',
        type_load_error: 'No se pudo cargar el catálogo de tipos de ONU.',
        type_edit: 'Cambiar',
        eth_modes_note: 'Los modos Hybrid, Trunk y el control de DHCP no están disponibles: el comando de la OLT Huawei ("ont port vlan") solo acepta Acceso y Transparente.',
        mgmt_title: 'IP de gestión y TR-069 (solo lectura)',
        tr069_profile_title: 'Perfil TR069',
        tr069_profile: 'Perfil TR069',
        mgmt_ip_title: 'IP de gestión',
        mgmt_ip_mode: 'Modo de IP de gestión',
        mgmt_inactive: 'Inactivo',
        mgmt_static: 'IP estática',
        disabled: 'Deshabilitado',
        voip_enabled_switch: 'Habilitado (interruptor principal)',
        voip_attach: 'Anexar VoIP a',
        voip_hint: 'Después de habilitar el servicio VoIP, vaya a la configuración de puertos VoIP y asigne los números de teléfono deseados.',
      },
      autoTasks: AUTO_TASKS_I18N.es,
      fh: FIBERHOME_I18N.es,
      onuLifecycle: ONU_LIFECYCLE_I18N.es,
      reportsPon: REPORTS_PON_I18N.es,
      ponDetail: PON_DETAIL_I18N.es,
      reportsRbac: REPORTS_RBAC_I18N.es,
      reportsTopology: REPORTS_TOPOLOGY_I18N.es,
      tasks: {
        title: 'Tareas',
        sub: 'Historial y monitoreo de operaciones ejecutadas.',
        task_id: 'ID de tarea',
        action: 'Acción',
        actions: ['Reiniciar ONU', 'Provisionar', 'Resincronizar', 'Cambiar VLAN', 'Aplicar preset', 'Restaurar valores'],
        statuses: { completed: 'Completada', failed: 'Falló', running: 'En ejecución' },
      },
      settings: {
        title: 'Ajustes',
        sub: 'Configuración de sistema, red y cuenta.',
        sidebar: {
          general: 'General',
          users: 'Usuarios',
          api_keys: 'Claves API',
          integrations: 'Integraciones',
          billing: 'Facturación',
          zones: 'Zonas',
          odbs: 'ODBs / Splitters',
          onu_types: 'Tipos de ONU',
          olt_types: 'Tipos de OLT',
          speed_profiles: 'Perfiles de velocidad',
          olts: 'OLTs',
          auth_presets: 'Presets de autorización',
          audit_log: 'Log de auditoría',
        },
        brand: {
          title: 'Marca (white-label)',
          sub: 'Se muestra en el header, footer y pantalla de login.',
          preview: 'Vista previa',
          company_name: 'Nombre de la empresa',
          logo_hint: 'Logo · PNG/SVG · máx 400KB',
          upload: 'Subir logo',
          remove: 'Quitar',
          saved_local: 'Guardado localmente en este navegador. Los cambios se aplican al instante.',
        },
        general_fields: ['Nombre de la empresa', 'Zona horaria', 'Idioma', 'Moneda', 'Timeout de sesión', 'Email de notificaciones'],
        users: {
          title: 'Usuarios',
          sub: 'Gestiona tu equipo, roles, 2FA y notificaciones por usuario.',
          invite: 'Invitar',
          new_user: 'Nuevo usuario',
          search: 'Buscar por nombre o email…',
          columns: { user: 'Usuario', role: 'Rol', two_fa: '2FA', status: 'Estado', last: 'Último acceso' },
          enabled: 'Activo',
          off: 'Apagado',
          active: 'activo',
          invited: 'invitado',
          suspended: 'suspendido',
        },
        api_keys: {
          title: 'Claves API',
          sub: 'Acceso programático a tu tenant OLT Manager. Rota regularmente y limita por permiso.',
          generate: 'Generar clave',
          active_keys: 'Claves activas',
          reqs_min: 'Solicitudes / min',
          rate_limit: 'Límite de tasa',
          rotate: 'Rotar',
          revoke: 'Revocar',
          created: 'Creada',
          last_used: 'último uso',
        },
        integrations: {
          title: 'Integraciones',
          sub: 'Servidores MCP que operan OLT Manager con los permisos de la cuenta dueña de la clave.',
          tabs: { servers: 'Servidores MCP', api_keys: 'Claves API', erps: 'ERPs' },
          servers: {
            title: 'Servidores MCP',
            sub: 'Un agente con una clave vinculada opera OLT Manager como un operador humano — por las mismas rutas REST, con el mismo RBAC. Los alcances de abajo solo restan del techo de la cuenta; nunca amplían.',
            create: 'Registrar servidor',
            empty: 'Aún no hay servidores MCP registrados.',
            loading: 'Cargando…',
            load_error: 'Error al cargar los servidores MCP.',
            view_cards: 'Tarjetas',
            view_table: 'Tabla',
            col_server: 'Servidor',
            col_owner: 'Cuenta',
            col_scopes: 'Alcances',
            col_health: 'Salud',
            col_activity: 'Actividad 24h (llam. / errores / denegadas)',
            enabled: 'Habilitado',
            disabled: 'Deshabilitado',
            never_seen: 'nunca visto',
            system_badge: 'Gestionado por el sistema',
            system_hint: 'Este servidor MCP y su clave se crean y mantienen automáticamente en la instancia. No se puede eliminar.',
            detail: 'Detalle',
            edit: 'Editar',
            badge_read_only: 'solo lectura',
            badge_no_dangerous: 'sin peligrosas',
            badge_no_generic: 'sin oltm_rest',
            badge_categories: (n) => `${n} categoría${n === 1 ? '' : 's'}`,
            badge_capture: 'graba respuesta',
            badge_full: 'acceso pleno de la cuenta',
          },
          form: {
            create_title: 'Registrar servidor MCP',
            edit_title: 'Editar servidor MCP',
            created_title: 'Servidor registrado',
            name: 'Nombre',
            name_ph: 'mcp-operacion',
            description: 'Descripción',
            description_ph: 'Para qué se usa este servidor MCP',
            enabled: 'Servidor habilitado',
            scopes_legend: 'Alcances (solo restan del RBAC de la cuenta)',
            read_only: 'Solo lectura (solo solicitudes GET)',
            allow_dangerous: 'Permitir acciones peligrosas (DELETE, rutas destructivas)',
            allow_generic: 'Permitir oltm_rest (escape hatch solo-GET)',
            capture_response: 'Grabar una muestra de la respuesta',
            capture_response_hint: 'graba los primeros 4 KiB de cada respuesta en el log — puede contener datos sensibles.',
            category_allowlist: 'Allowlist de categorías (vacío = todas)',
            rate_limit: 'Rate limit (solicitudes por minuto)',
            mint_key: 'Acuñar clave ahora (se muestra una sola vez)',
            cancel: 'Cancelar',
            save: 'Guardar',
            create: 'Registrar',
            saving: 'Guardando…',
            finish: 'Listo',
            name_required: 'El nombre es obligatorio.',
            created_ok: (n) => `El servidor "${n}" fue registrado.`,
          },
          key_block: {
            label: 'Clave de la cuenta (oltmk_…) — va en el header X-API-Key del proceso MCP. Cópiala ahora, no se mostrará de nuevo:',
            copy: 'Copiar',
            copied: 'Copiado',
          },
          detail: {
            title: 'Servidor MCP',
            loading: 'Cargando…',
            load_error: 'Error al cargar el servidor.',
            scopes: 'Alcances',
            all_categories: 'todas las categorías',
            rate_limit_label: (rl) => `rate limit ${rl}/min`,
            activity_24h: (c, e, d) => `24h: ${c} llamadas · ${e} errores · ${d} denegadas por RBAC`,
            linked_keys: 'Claves vinculadas',
            no_keys: 'Ninguna clave vinculada.',
            key_never_used: 'nunca usada',
            key_used: (rel) => `usada ${rel}`,
            revoke: 'Revocar',
            mint_ph: 'Nombre de la nueva clave',
            mint: 'Acuñar nueva',
            delete_title: 'Eliminar servidor',
            delete_hint: 'Elimina solo el registro. Las claves vinculadas siguen válidas con el RBAC de la cuenta (quedan huérfanas) — revócalas antes si quieres cortar el acceso.',
            delete: 'Eliminar servidor',
            delete_confirm: '¿Eliminar?',
            close: 'Cerrar',
          },
          connect: {
            title: 'Conexión (.mcp.json)',
            host_label: 'Host del servidor MCP',
            host_hint: 'Dirección donde está publicado el proceso oltm-mcp-server (la Sesión 08 cierra el compose).',
            note: 'El Bearer aquí es MCP_AUTH_TOKEN — el secreto del propio proceso MCP. La clave oltmk_ de la cuenta va en OLTM_API_KEY / X-API-Key en el proceso, no aquí.',
            copy: 'Copiar',
            copied: 'Copiado',
          },
          about: {
            title: 'Acerca de / Cómo conectar',
            sub: 'Un agente con una clave de API de OLT Manager opera toda la instancia como un operador humano — por las mismas rutas REST, con el mismo RBAC.',
            security_title: 'Modelo de seguridad',
            security: [
              'La clave es la cuenta: resuelve a un usuario real y hereda exactamente sus permisos.',
              'El RBAC es el techo. El backend es el único punto de enforcement (RequirePermission por ruta) — igual para agente y humano, y ahora bloquea de verdad para claves.',
              'Los alcances del servidor solo restan (solo lectura, sin peligrosas, allowlist de categorías). Nunca amplían lo que la clave ya puede.',
              'El log está en el backend, en la rama de auth por clave — captura todo, incluso llamadas por curl. Los headers X-MCP-Server/X-MCP-Tool solo enriquecen, nunca son confianza.',
            ],
            retention_title: 'Retención, redacción y límites',
            retention: [
              'Log retenido 90 días (MCP_LOG_RETENTION_DAYS), limpieza por loop de background.',
              'Cuerpo de la solicitud grabado con claves sensibles enmascaradas (password, secret, token, *_hash…) y truncado a 8 KiB. La respuesta no se graba — solo estado y tamaño; un modo opt-in por servidor graba los primeros 4 KiB.',
              'Rate limit por clave (por defecto 120 req/min), configurable por servidor.',
              'Diseño stateless: sin session id, sin push del servidor.',
            ],
            practices_title: 'Buenas prácticas',
            practices: [
              'Un usuario/grupo dedicado por MCP, con el mínimo de permisos.',
              'read_only para agentes de análisis.',
              'Revisar Reportes → Uso de Integraciones → Denegaciones por permiso para ver dónde el agente choca con el RBAC.',
            ],
            limits_title: 'Limitaciones conocidas',
            limits: [
              'Subidas binarias (fotos de equipos, backup como archivo) no se exponen vía MCP.',
              'La sesión SSH interactiva de la OLT no se expone (es WS/stream, no REST).',
              'oltm_rest (escape hatch para rutas no mapeadas) es solo-GET.',
            ],
            reference: 'Referencia: docs/ApiMcpOLTm/ (00-VISAO-GERAL.md §7) y el README de oltm-mcp-server.',
          },
          erps: {
            title: 'ERPs',
            coming_soon: 'Próximamente',
            banner: 'Las integraciones con ERPs están en desarrollo. Abajo, los sistemas que planeamos soportar. Marca tu interés para recibir aviso cuando esté listo.',
            interest: 'Me interesa',
            interest_done: 'Interés registrado',
            interest_ok: 'Interés registrado — te avisaremos cuando la integración esté lista.',
            interest_err: 'No se pudo registrar tu interés. Inténtalo de nuevo.',
            items: {
              ixc: 'ERP/ISP más usado en Brasil — clientes, contratos, finanzas y órdenes de servicio.',
              sgp: 'Sistema de gestión de proveedores — cobranza, clientes y soporte.',
              voalle: 'Plataforma de gestión y automatización para proveedores.',
              hubsoft: 'ERP para ISPs — atención, finanzas y aprovisionamiento.',
              mk_auth: 'Gestión de proveedor y RADIUS (legado, aún común).',
              routerbox: 'ERP/ISP — clientes, finanzas y monitoreo.',
              topsapp: 'Gestión para proveedores de pequeño y mediano porte.',
              ispbox: 'Suite de gestión para ISP.',
              synsuite: 'ERP/CRM para telecom.',
              uzzysoft: 'Gestión y cobranza para proveedores.',
              radius_generico: 'Integración vía RADIUS/API para aprovisionamiento.',
              webhook_generico: 'Notificaciones de eventos (ONU autorizada, caída de PON) para cualquier sistema.',
            },
          },
          errors: {
            create_failed: 'Error al registrar el servidor MCP.',
            update_failed: 'Error al guardar el servidor MCP.',
            delete_failed: 'Error al eliminar el servidor.',
            mint_failed: 'Error al acuñar la clave.',
            revoke_failed: 'Error al revocar la clave.',
          },
        },
        billing: {
          title: 'Facturación',
          sub: 'Estado de licenciamiento de tus OLTs.',
          sync: 'Sincronizar',
          sync_success: 'Estado de licenciamiento sincronizado',
          sync_error: 'Error al sincronizar licenciamiento',
          olt_licenses: 'Licencias por OLT',
          loading: 'Cargando...',
          no_olts: 'No hay OLTs registradas',
          expires: 'Expira el',
          no_expiry: 'Sin fecha de expiración',
          status_none: 'sin licencia',
          renew: 'Renovar',
          checkout_started: 'Checkout iniciado',
          checkout_error: 'Error al iniciar checkout',
          col_id: 'ID del OLT',
          col_name: 'Nombre del OLT',
          col_status: 'Estado de la suscripción',
          col_expires_at: 'Fecha de fin de la suscripción (inclusive)',
          payment_options: 'Ver opciones de pago',
          portal_error: 'Error al abrir el portal de pago',
          invoices_title: 'Facturas',
          invoices_empty: 'Aún no hay pagos registrados.',
          col_inv_date: 'Fecha',
          col_inv_desc: 'Descripción',
          col_inv_olts: 'OLTs',
          col_inv_gateway: 'Pagado con',
          col_inv_amount: 'Importe',
          col_inv_status: 'Estado',
          pay_status_approved: 'aprobado',
          pay_status_pending: 'pendiente',
          pay_status_rejected: 'rechazado',
          pay_status_refunded: 'reembolsado',
          pay_status_expired: 'expirado',
          pay_status_canceled: 'cancelado',
          choose_gateway: 'Elige la forma de pago',
          gateway_default: 'predeterminado',
          pix_title: 'Pago por PIX',
          pix_instructions: 'Escanea el código QR o copia el código de abajo en la app de tu banco.',
          pix_copy: 'Copiar código PIX',
          pix_copied: 'Código copiado',
          close: 'Cerrar',
          cancel: 'Cancelar',
        },
        zones: {
          title: 'Zonas',
          sub: 'Agrupa OLTs y ONUs por áreas geográficas o lógicas de cobertura.',
          new_zone: 'Nueva zona',
          coverage: 'Cobertura',
        },
        odbs: {
          title: 'ODBs (NAPs, CTOs) / Splitters',
          sub: 'Gestione cajas de distribución, capacidad de splitters y ONUs conectadas.',
          map_view: 'Ver en el mapa',
          new_odb: 'Agregar CTO (Splitter)',
          search: 'Buscar por nombre…',
          occupancy: 'Ocupación',
          occupancy_filter_all: 'Todas las ocupaciones',
          occupancy_filter_50: '≥ 50% ocupado',
          occupancy_filter_75: '≥ 75% ocupado',
          occupancy_filter_90: '≥ 90% ocupado',
          occupancy_filter_exceeded: 'Capacidad excedida',
          delete_selected: 'Eliminar seleccionados',
          export: 'Exportar',
          import: 'Importar',
          stat_total: 'Total ODBs',
          stat_ports: 'Total puertos',
          stat_used: 'Puertos usados',
          stat_free: 'Puertos libres',
        },
        onu_types: {
          title: 'Tipos de ONU',
          sub: 'Modelos de ONU soportados por fabricante — capacidades, perfiles de servicio y valores por defecto.',
          register: 'Registrar modelo',
          auto_approved: 'Auto-aprobación',
          configure: 'Configurar',
          import_catalog: 'Importar del catálogo central',
        },
        olt_types: {
          title: 'Tipos de OLT',
          sub: 'Modelos de OLT registrados — metadato complementario, no reemplaza el fabricante/versión de hardware de la OLT.',
          register: 'Registrar modelo',
          import_catalog: 'Importar del catálogo central',
        },
        speed_profiles: {
          title: 'Perfiles de velocidad',
          sub: 'Plantillas de traffic shaping aplicadas a service ports. Separado por descarga y subida.',
          download: 'Descarga',
          upload: 'Subida',
          download_profiles: 'Perfiles de descarga',
          upload_profiles: 'Perfiles de subida',
          burst: 'Burst',
          standard: 'Estándar',
          high: 'Alto',
          is_default_badge: 'Perfil predeterminado',
          set_default: 'Usar como predeterminado',
          default_hint: 'Se aplica automáticamente a equipos autorizados sin un perfil seleccionado.',
          edit: 'Editar',
        },
        olts: {
          title: 'OLTs',
          sub: 'Registra y gestiona terminales de línea óptica. Configura IP, credenciales, puertos y valores por defecto.',
          register: 'Registrar OLT',
          onus: 'ONUs',
          temp: 'Temp',
          uptime: 'Uptime',
          pon_ports: 'Puertos PON en uso',
          polled: 'consultada hace 12s',
          manage: 'Gestionar',
          online: 'En línea',
          warning: 'Alerta',
          overheating: 'Sobrecalentamiento',
        },
        auth_presets: {
          title: 'Presets de autorización',
          sub: 'Plantillas que autorizan ONUs entrantes con el VLAN, velocidad y WiFi correctos.',
          new_preset: 'Nuevo preset',
          default: 'Predeterminado',
          vlan: 'VLAN',
          applied_to: 'Aplicado a',
          onus_suffix: 'ONUs',
          wizard_title: 'Crear preset — asistente',
          step_of: 'Paso {a} de {b}',
          steps: [
            { label: 'Básico', desc: 'Nombre, fabricante y descripción' },
            { label: 'Condiciones', desc: 'Cuándo aplicar este preset' },
            { label: 'Config ONU', desc: 'VLAN, service ports, ETH' },
            { label: 'TR069 & Mgmt', desc: 'Perfil de gestión y TR069' },
            { label: 'WiFi', desc: 'SSID, contraseña, radios' },
            { label: 'Revisión', desc: 'Confirmar y activar' },
          ],
          activate: 'Activar preset',
        },
        audit_log: {
          title: 'Log de auditoría',
          sub: 'Cada acción sensible del tenant — quién, qué, cuándo y dónde.',
          filter: 'Filtrar',
          export: 'Exportar CSV',
          search: 'Buscar autor, acción u objetivo…',
          tones: { ok: 'ok', critical: 'crítico', warning: 'alerta', security: 'seguridad', info: 'info' },
        },
      },
      time: {
        min_ago: (n) => `hace ${n} min`,
        hour_ago: (n) => `hace ${n} ${n === 1 ? 'hora' : 'horas'}`,
        day_ago: (n) => `hace ${n} ${n === 1 ? 'día' : 'días'}`,
        days: (n) => `${n} días`,
        yesterday: 'ayer',
        two_days_ago: 'hace 2 días',
        auth: 'autorizada',
        reboot: 'Reinicio',
      },
      reports: {
        common: {
          refresh: 'Actualizar',
          export_csv: 'Exportar CSV',
          export: 'Exportar',
          export_xlsx: 'Hoja de cálculo (.xlsx)',
          export_print: 'Imprimir / PDF',
          loading: 'Cargando…',
          load_failed: 'Error al cargar el informe',
          all_olts: 'Todas las OLTs',
          all_zones: 'Todas las zonas',
          all_statuses: 'Todos los estados',
          view: 'Ver',
          olt: 'OLT',
          customer: 'Cliente',
          zone: 'Zona',
          manufacturer: 'Fabricante',
          status: 'Estado',
          uptime: 'Uptime',
          temperature: 'Temperatura',
          last_poll: 'Última recolección',
          back_to_hub: 'Central de Informes',
          custom_period: 'Personalizado',
          none_registered_olt: 'Ninguna OLT registrada.',
        },
        status_labels: {
          online: 'En línea', high_signal: 'Señal alta', broken: 'Señal crítica',
          offline: 'Fuera de línea', unknown: 'Desconocido',
        },
        hub: {
          title: 'Central de Informes',
          subtitle: 'Elige un informe para ver, filtrar y exportar los datos de tu operación — agrupados por área.',
          coming_soon: 'Pronto',
          groups: {
            maps: { title: 'Mapas y Topología', subtitle: 'Vista geográfica y jerárquica de la red' },
            onus: { title: 'Informes de ONUs', subtitle: 'Inventario, señal y consumo de los clientes conectados' },
            olts: { title: 'Informes de OLTs y Red', subtitle: 'Salud, disponibilidad y rendimiento de los equipos' },
            field: { title: 'Infraestructura de Campo', subtitle: 'Cajas, CTOs y distribución física de la red' },
            admin: { title: 'Administración y Auditoría', subtitle: 'Trazabilidad de acciones y cumplimiento del sistema' },
            finance: { title: 'Finanzas y Comercial', subtitle: 'Facturación, licenciamiento y consumo por cliente' },
          },
          cards: {
            topology: { title: 'Topología de la OLT', desc: 'Árbol visual OLT -> placas -> puertos PON -> splitters -> ONUs, con estado en tiempo real.' },
            map: { title: 'Mapa geográfico de la red', desc: 'OLTs, cajas y CTOs geolocalizados en el mapa, con estado y cobertura por región.' },
            cto_occupancy: { title: 'Ocupación de CTOs en el mapa', desc: 'Densidad de ocupación de las cajas de atención vista geográficamente.' },
            pon_diagram: { title: 'Diagrama de puertos PON', desc: 'Matriz slot x puerto por OLT, cada puerto coloreado por ocupación — vista visual de la flota.' },
            inventory: { title: 'Inventario de ONUs', desc: 'Lista completa de ONUs autorizadas, con estado, señal y datos de aprovisionamiento.' },
            signal_quality: { title: 'Calidad de señal', desc: 'Distribución de señal óptica (Rx) y ONUs fuera del rango aceptable.' },
            traffic_summary: { title: 'Resumen de tráfico', desc: 'Consumo de banda por ONU en las últimas 24h — actual y pico.' },
            onu_models: { title: 'ONUs por tipo/fabricante', desc: 'Distribución del parque de ONUs por modelo y fabricante, útil para compras y soporte.' },
            onu_swaps: { title: 'Historial de cambios de ONU', desc: 'Registro de sustituciones de equipo por cliente a lo largo del tiempo.' },
            speed_plans: { title: 'Clientes por plan de velocidad', desc: 'Cantidad de suscriptores agrupados por perfil de banda contratado.' },
            olt_overview: { title: 'Resumen de OLTs', desc: 'Vista gerencial de la flota (estado, uptime, temperatura) y tendencia de autorizaciones.' },
            pon_outages: { title: 'Caídas por puerto PON', desc: 'Interrupciones que afectan a varias ONUs en el mismo puerto PON a la vez.' },
            poll_history: { title: 'Recolección SNMP/SSH (poll)', desc: 'Estado e historial de los ciclos de recolección de una OLT — dispara un poll inmediato.' },
            hardware_health: { title: 'Salud del hardware', desc: 'Temperatura, alimentación y estado de placas a lo largo del tiempo, con alertas de tendencia.' },
            uptime: { title: 'Disponibilidad (uptime)', desc: 'Porcentaje de disponibilidad de cada OLT en el período, para SLA e informes gerenciales.' },
            pon_capacity: { title: 'Ocupación de puertos PON', desc: 'Capacidad usada frente a disponible en cada puerto PON de cada OLT.' },
            field_boxes: { title: 'Inventario de cajas (CTO/CEO)', desc: 'Lista de cajas registradas, capacidad y vínculo con puertos PON.' },
            box_occupancy: { title: 'Ocupación de cajas', desc: 'Puertos libres frente a ocupados por caja, para planificar expansión.' },
            splitters: { title: 'Splitters y pérdidas ópticas', desc: 'Mapeo de splitters por nivel y estimación de pérdida en el trayecto óptico.' },
            audit_export: { title: 'Exportar auditoría', desc: 'Registro de acciones administrativas del sistema, filtrable y exportable.' },
            external_changes: { title: 'Cambios externos', desc: 'Cambios hechos directamente en la OLT (fuera del sistema) detectados por la recolección.' },
            rbac: { title: 'Usuarios y permisos', desc: 'Informe de usuarios, grupos y permisos efectivos en el sistema (RBAC).' },
            bulk_jobs: { title: 'Registro de tareas en lote', desc: 'Historial de ejecuciones de acciones masivas sobre ONUs y OLTs.' },
            backups: { title: 'Cumplimiento y backups', desc: 'Estado de los backups automáticos de configuración de las OLTs.' },
            mcp_usage: { title: 'Uso de Integraciones / MCP', desc: 'Llamadas de API por clave/servidor MCP, latencia, errores y permisos denegados.' },
            cli_audit: { title: 'Comandos de las OLTs', desc: 'Historial de todo comando CLI enviado a las OLTs: quién lo pidió, cuándo, la respuesta y si falló.' },
            billing_olts: { title: 'Facturación por OLT', desc: 'Consumo de licencias y cobro por OLT contratada en el plan SaaS.' },
            payments: { title: 'Pagos y suscripciones', desc: 'Historial de pagos, métodos y estado de las facturas del proveedor.' },
            customer_consumption: { title: 'Consumo por cliente', desc: 'Uso de banda agregado por cliente, útil para políticas de fair use.' },
          },
        },
        mcp_usage_page: {
          title: 'Uso de Integraciones / MCP',
          subtitle: 'Llamadas de API por clave y servidor MCP: volumen, latencia, errores y permisos denegados. Todo proviene del log del backend.',
          settings_link: 'Configuración › Integraciones',
          win_24h: '24h', win_7d: '7d', win_30d: '30d',
          kpi_calls: 'Llamadas',
          kpi_error_rate: '% error',
          kpi_denied_rate: '% denegado',
          kpi_p50: 'Latencia p50',
          kpi_p95: 'Latencia p95',
          kpi_servers: 'Servidores activos',
          kpi_keys_sub: (n) => `${n} clave(s) activa(s)`,
          timeline_title: 'Línea de tiempo de llamadas',
          timeline_hint: 'llamadas vs. errores en el período',
          timeline_calls: 'Llamadas',
          timeline_errors: 'Errores',
          timeline_empty: 'Sin llamadas en esta ventana.',
          top_tools_title: 'Top herramientas',
          top_tools_hint: 'por volumen de llamadas',
          top_tools_empty: 'Ninguna herramienta identificada (las llamadas directas por curl no envían X-MCP-Tool).',
          top_routes_title: 'Top rutas',
          routes_empty: 'Ninguna ruta registrada en esta ventana.',
          denials_title: 'Permisos denegados',
          denials_sub: 'El agente intentó una acción y el RBAC de la clave la bloqueó.',
          denials_empty: 'Ningún permiso denegado en esta ventana — el RBAC de las claves cubrió todo lo que intentaron los agentes.',
          denials_hint: (perm, n) => `Concede \`${perm}\` al grupo de esta clave para desbloquear ~${n} intento(s)/día.`,
          denials_hint_unknown: (n) => `La denegación no vino de un permiso RBAC (p. ej. un alcance de clave sin escritura): revise el alcance de la clave — ~${n} intento(s)/día.`,
          outcomes_title: 'Distribución por resultado',
          outcomes_empty: 'Sin datos de resultado en esta ventana.',
          outcome_ok: 'OK', outcome_denied: 'Denegado', outcome_error: 'Error', outcome_not_found: 'No encontrado',
          servers_title: 'Salud por servidor',
          servers_empty: 'Ningún servidor MCP registrado.',
          col_method: 'Método', col_route: 'Ruta', col_perm: 'Permiso faltante', col_count: 'Intentos',
          col_hint: 'Acción sugerida', col_tool: 'Herramienta', col_calls: 'Llamadas',
          col_server: 'Servidor', col_last_seen: 'Última actividad', col_avg_ms: 'Latencia media', col_rate_hits: 'Rate-limit (429)',
          empty_title: 'Ninguna llamada de integración en esta ventana',
          empty_body: 'Crea un servidor MCP en Configuración › Integraciones y conecta un agente para empezar a ver uso aquí.',
          empty_cta: 'Abrir Configuración › Integraciones',
          never: 'nunca',
          footer: (win) => `Ventana: ${win}. Retención del log: 90 días.`,
          sheet_kpis: 'KPIs', sheet_timeline: 'Línea de tiempo', sheet_top_tools: 'Top herramientas',
          sheet_top_routes: 'Top rutas', sheet_denials: 'Permisos denegados', sheet_outcomes: 'Resultados', sheet_servers: 'Servidores',
          csv_kpi_h: ['Métrica', 'Valor'],
          csv_timeline_h: ['Instante', 'Llamadas', 'Errores'],
          csv_top_tools_h: ['Herramienta', 'Llamadas'],
          csv_top_routes_h: ['Método', 'Ruta', 'Llamadas'],
          csv_denials_h: ['Método', 'Ruta', 'Permiso faltante', 'Intentos', 'Intentos/día'],
          csv_outcomes_h: ['Resultado', 'Llamadas'],
          csv_servers_h: ['Servidor', 'Última actividad', 'Latencia media (ms)', 'Rate-limit (429)'],
        },
        cli_audit_page: {
          title: 'Comandos de las OLTs',
          subtitle: 'Historial de todo comando CLI enviado a las OLTs — recolección, operación, acciones automáticas, backup y terminal. Contiene datos sensibles; los secretos escritos como comando aparecen enmascarados.',
          period_1h: '1 h', period_24h: '24 h', period_7d: '7 d', period_30d: '30 d', period_custom: 'Personalizado',
          custom_from: 'Desde', custom_to: 'Hasta', custom_apply: 'Aplicar',
          custom_invalid: 'Indique un inicio anterior al fin.',
          custom_clamped: 'La API acepta como máximo 31 días; se ajustó el inicio.',
          window_label: 'Ventana',
          olt_label: 'OLT', olt_all: 'Todas las OLTs', olt_none: 'Ninguna OLT tiene comandos en la ventana.',
          origin_label: 'Origen', origin_all: 'Todos los orígenes',
          actor_label: 'Quién', actor_all: 'Todos', actor_users: 'Usuario específico', actor_types: 'Tipo de actor',
          status_label: 'Estado', status_all: 'Todos los estados',
          selected_n: (n) => `${n} seleccionado(s)`,
          origin_groups: {
            collect: 'Recolección', operation: 'Operación', auto: 'Automática', backup: 'Backup',
            terminal: 'Terminal', unclassified: 'Sin clasificar', other: 'Otros',
          },
          origin_group_hints: {
            collect: 'poll:*, autofind, inventario', operation: 'MÉTODO /api/… (pantallas y API), lotes',
            auto: 'acciones automáticas', backup: 'backup y restauración', terminal: 'terminal interactivo',
            unclassified: 'camino sin origen — investigar', other: 'orígenes no previstos',
          },
          origin_exact: 'Origen',
          actor_type_names: {
            user: 'Usuario', system: 'Sistema', auto_task: 'Acción automática', api_key: 'Clave de API', unknown: 'Desconocido',
          },
          actor_auto_task: (id) => (id ? `Acción automática #${id}` : 'Acción automática'),
          status_names: {
            ok: 'OK', device_error: 'Error del equipo', timeout: 'Timeout', transport_error: 'Falla de transporte', canceled: 'Cancelado',
          },
          only_writes: 'Solo escrituras', only_errors: 'Solo errores', show_bootstrap: 'Mostrar bootstrap',
          search_ph: 'Buscar en el comando…', search_output: 'En la salida',
          search_output_warn: 'La búsqueda en la salida no está indexada y es lenta en ventanas grandes (segundos con 7 días o más).',
          min_duration: 'Duración ≥', min_ph: 'ms',
          clear_filters: 'Limpiar filtros',
          facets_loading: 'Cargando opciones…', facets_error: 'No se pudieron cargar las opciones.',
          retry: 'Reintentar',
          chip_user: 'Usuario', chip_session: 'Sesión', chip_remove: 'Quitar filtro',
          kpi_commands: 'Comandos', kpi_errors: 'Errores', kpi_writes: 'Escrituras', kpi_p95: 'p95 de duración', kpi_sessions: 'Sesiones',
          kpi_errors_sub: (pct) => `${pct} de los comandos`,
          kpi_hint_errors: 'Clic para ver solo los errores',
          kpi_hint_writes: 'Clic para ver solo las escrituras',
          kpi_hint_p95: 'Clic para ver los comandos más lentos que el p95',
          kpi_hint_commands: 'Clic para quitar los filtros de error/escritura/duración',
          kpi_error: 'No se pudieron cargar los indicadores.',
          timeline_title: 'Línea de tiempo',
          timeline_hint: 'Clic en una barra (o arrastre) para acotar el período. Rojo = errores.',
          timeline_empty: 'Sin comandos en esta ventana.',
          tl_total: 'Comandos', tl_ok: 'Sin error', tl_errors: 'Errores', tl_writes: 'Escrituras',
          tl_bucket: (label) => `Barras de ${label}`,
          col_time: 'Hora', col_olt: 'OLT', col_who: 'Quién', col_origin: 'Origen', col_command: 'Comando',
          col_status: 'Estado', col_duration: 'Duración', col_response: 'Respuesta',
          write_badge: 'Escritura en la OLT',
          system_label: 'Sistema',
          ago: (n, unit) => `hace ${n} ${{ s: 's', min: 'min', h: 'h', d: 'd' }[unit]}`,
          filter_by: (what) => `Filtrar por ${what}`,
          session_title: (id, seq) => `Sesión ${id} · comando ${seq}`,
          bootstrap_row: 'bootstrap',
          interactive_row: 'terminal',
          redacted: 'secreto enmascarado',
          loaded_n: (n) => `${n} comando(s) cargado(s)`,
          load_more: 'Cargar más', loading_more: 'Cargando…', end_of_list: 'Fin de la lista.',
          empty_title: 'Ningún comando con este filtro',
          empty_body: 'No hay comandos en la ventana elegida con estos filtros. Amplíe el período, limpie los filtros o marque "Mostrar bootstrap".',
          empty_no_data_title: 'Aún no hay comandos registrados',
          empty_no_data_body: 'En cuanto una recolección, una operación o el terminal hable con una OLT, el comando aparece aquí.',
          error_title: 'No se pudieron cargar los comandos',
          open_detail: 'Abrir detalle',
          open_terminal: 'terminal',
          // ---- Fase 14: detalle, en vivo, exportación ----
          detail_title: (id) => `Comando #${id}`,
          detail_close: 'Cerrar', detail_back: 'Volver a la lista',
          detail_error_title: 'No se pudo cargar el comando',
          detail_not_found_title: 'Comando no encontrado',
          detail_not_found_body: 'El registro pudo haber sido eliminado por la retención (30 días por defecto) o no existe en esta cuenta.',
          copy: 'Copiar', copied: 'Copiado', copy_failed: 'No se pudo copiar',
          detail_command: 'Comando', detail_response: 'Respuesta',
          detail_when: 'Hora', detail_duration: 'Duración', detail_olt: 'OLT', detail_view: 'Modo / vista',
          detail_protocol: 'Protocolo', detail_kind: 'Tipo',
          kind_names: { command: 'comando', bootstrap: 'bootstrap', interactive: 'terminal' },
          response_empty: 'No se registró respuesta para este comando.',
          response_error_lines: (n) => `${n} línea(s) de error del equipo`,
          response_truncated: (shown, total) => `Respuesta truncada: ${shown} de ${total} bytes`,
          response_masked: 'enmascarado',
          response_masked_hint: 'Los secretos aparecen como •••• (enmascarados en la captura).',
          detail_who: 'Quién / desde dónde',
          who_actor: 'Actor', who_ip: 'IP', who_request_id: 'Request ID', who_origin: 'Origen',
          who_auto_task: 'Acción automática', who_api_key: 'Clave de API', who_none: '—',
          open_auto_task: 'Abrir acción automática',
          detail_session: 'Sesión',
          session_pos: (pos, size) => `Comando ${pos} de ${size} en esta conexión`,
          session_prev: 'Comando anterior de la sesión', session_next: 'Siguiente comando de la sesión',
          session_filter: 'Filtrar la lista por esta sesión',
          session_truncated: (n) => `Mostrando solo los primeros ${n} comandos de la sesión.`,
          session_error: 'No se pudo cargar la sesión.', session_loading: 'Cargando la sesión…',
          detail_links: 'Enlaces',
          link_audit_log: 'Ver la acción en el log de auditoría',
          link_audit_log_hint: (email) => `Abre el log de auditoría buscando ${email}. El log de auditoría no guarda el Request ID — úselo para cruzar con el inspector de API.`,
          link_onu: (serial) => `Abrir ONU ${serial}`,
          link_onu_note: 'Serial leído del propio comando (búsqueda simple) y confirmado en el registro de ONUs.',
          link_olt: 'Abrir OLT',
          shortcuts_title: 'Atajos',
          shortcut_prev: 'comando anterior', shortcut_next: 'siguiente comando', shortcut_close: 'cerrar',
          live_label: 'En vivo',
          live_disabled_custom: 'El modo en vivo solo vale para períodos relativos (1 h a 30 d).',
          live_state_running: 'En vivo · cada 5 s',
          live_state_scrolled: 'En pausa al desplazar la lista',
          live_state_detail: 'En pausa con el detalle abierto',
          live_state_hidden: 'Pestaña oculta — sin consultas',
          live_state_error: (msg) => `Falló la actualización: ${msg}`,
          live_new_n: (n) => `${n} nuevo(s)`,
          live_received_n: (n) => `+${n} desde que se activó`,
          live_flush: 'Mostrar ahora',
          live_gap: 'Demasiados comandos nuevos para combinar — actualice la lista',
          export_csv: 'Exportar CSV', export_running: 'Exportando…',
          export_confirm_title: '¿Exportar con los filtros actuales?',
          export_confirm_body: (n, max) => (n == null
            ? `La ventana es grande; el archivo puede tener hasta ${max} filas.`
            : `Unos ${n} comandos; el archivo tiene como máximo ${max} filas.`),
          export_cut_warn: (max) => `Supera el límite: solo se exportarán los ${max} más recientes.`,
          export_include_output: 'Incluir la respuesta del equipo (archivo mucho mayor)',
          export_go: 'Exportar', export_cancel: 'Cancelar',
          export_done: (name) => `CSV descargado: ${name}`,
          export_truncated: (rows, max) => `Exportación cortada en el límite: ${rows} de más de ${max} filas. Restrinja el período o los filtros.`,
          export_interrupted: 'La exportación se interrumpió en el servidor — el archivo está incompleto.',
          export_failed: (msg) => `Falló la exportación: ${msg}`,
          link_commands: 'Comandos ejecutados', link_commands_hint: 'Abre el reporte de comandos de esta OLT de las últimas 24 h.',
        },
        inventory: {
          title: 'Inventario de ONUs',
          subtitle: 'Lista completa de ONUs autorizadas, con estado, señal y datos de aprovisionamiento — filtra y exporta para análisis externo.',
          search_ph: 'Serial, MAC o cliente…',
          stat_total: 'Total en el filtro', stat_online: 'En línea', stat_critical: 'Señal crítica', stat_offline: 'Fuera de línea',
          col_serial_mac: 'Serial / MAC', col_pon: 'PON', col_rx: 'Señal RX', col_type: 'Tipo', col_vlan: 'VLAN', col_authorized_at: 'Autorizada el',
          empty: 'No se encontró ninguna ONU con los filtros actuales.',
          csv_h: ['Estado', 'Cliente', 'Serial', 'MAC', 'OLT', 'PON', 'Señal RX (dBm)', 'Tipo', 'VLAN', 'Modo', 'Autorizada el'],
          mode_routing: 'Enrutamiento', mode_bridge: 'Bridge',
        },
        signal: {
          title: 'Calidad de señal',
          subtitle: 'Distribución de señal óptica (Rx) de las ONUs en línea, destacando las que están fuera del rango aceptable (muy débil o saturando el receptor).',
          stat_with_reading: 'ONUs con lectura', stat_avg: 'Señal media (dBm)', stat_best: 'Mejor señal (dBm)', stat_worst: 'Peor señal (dBm)',
          weak_title: 'Señal crítica (débil)', high_title: 'Señal alta (saturando)',
          weak_empty: 'Ninguna ONU con señal crítica.', high_empty: 'Ninguna ONU con señal saturando.',
          csv_h: ['Motivo', 'Cliente', 'Serial', 'OLT', 'PON', 'Señal RX (dBm)'],
          csv_reason_weak: 'Señal crítica (débil)', csv_reason_high: 'Señal alta (saturando)',
        },
        traffic: {
          title: 'Resumen de tráfico',
          subtitle: 'Consumo de banda por ONU en las últimas 24h — actual y pico, ordenado por los mayores consumidores de la red.',
          load_failed: 'Error al cargar el informe de tráfico',
          fetch_failed: 'Error al cargar el tráfico.',
          search_ph: 'Cliente o dispositivo…',
          stat_count: 'ONUs en el filtro', stat_dl_agg: 'Descarga actual agregada', stat_ul_agg: 'Subida actual agregada', stat_peak_dl: 'Mayor pico (descarga)',
          truncated: (n) => `Lista limitada a las primeras ${n} ONUs para mantener la página ágil — refina el filtro de OLT para ver el resto.`,
          col_onu: 'ONU', col_device: 'Dispositivo', col_dl_cur: 'Descarga actual', col_ul_cur: 'Subida actual', col_dl_peak: 'Pico descarga', col_ul_peak: 'Pico subida',
          empty: 'Ninguna ONU con tráfico en las últimas 24h.',
          csv_h: ['ONU', 'Dispositivo', 'Descarga actual (Mbps)', 'Subida actual (Mbps)', 'Pico descarga (Mbps)', 'Pico subida (Mbps)'],
        },
        pon_outages: {
          title: 'Caídas por puerto PON',
          subtitle: 'Interrupciones detectadas que afectan a varias ONUs en el mismo puerto PON a la vez — normalmente indica un corte de fibra o una falla del puerto/placa de la OLT, no un problema individual del cliente.',
          fetch_failed: 'Error al cargar las caídas por puerto PON.',
          badge_one: 'interrupción no confirmada', badge_many: 'interrupciones no confirmadas',
          search_ph: 'OLT o puerto PON…',
          col_pon: 'Puerto PON', col_affected: 'ONUs afectadas', col_cause: 'Causa probable', col_since: 'Desde',
          empty: 'Ninguna interrupción de puerto PON en este momento.',
          csv_h: ['OLT', 'Puerto PON', 'ONUs afectadas', 'ONUs en total', 'Causa probable', 'Desde'],
        },
        olt_overview: {
          title: 'Resumen de OLTs',
          subtitle: 'Vista gerencial de la flota de OLTs (estado, uptime, temperatura) y de la tendencia de crecimiento de autorizaciones de ONU a lo largo del tiempo.',
          fetch_failed: 'Error al cargar el resumen de OLTs.',
          chart_title: (n) => `Autorizaciones de ONU por día — ${n} en el período`,
          chart_series: 'Autorizaciones',
          search_ph: 'Nombre de la OLT o fabricante…',
          empty: 'Ninguna OLT registrada.',
          csv_h: ['OLT', 'Fabricante', 'Estado', 'Uptime', 'Temperatura (°C)', 'Última recolección'],
        },
        poll_history: {
          title: 'Recolección SNMP/SSH (poll)',
          subtitle: 'Estado e historial de los ciclos de recolección (SNMP/SSH) de una OLT — dispara un poll inmediato o sigue la duración y el resultado de los últimos ciclos programados.',
          status_failed: 'Error al cargar el estado de recolección.',
          trigger_failed: 'Error al disparar la recolección.',
          running: '● Poll en ejecución…',
          waiting: 'Esperando el próximo poll programado',
          trigger: 'Disparar poll inmediato', triggering: 'Disparando…',
          col_start: 'Inicio', col_duration: 'Duración', col_method: 'Método', col_boards: 'Placas', col_ports: 'Puertos', col_onus: 'ONUs',
          empty: 'Sin historial de recolección para esta OLT.',
          csv_h: ['Inicio', 'Duración (ms)', 'Método', 'Estado', 'Placas', 'Puertos', 'ONUs'],
        },
        models: {
          title: 'ONUs por tipo/fabricante',
          subtitle: 'Distribución del parque de ONUs por modelo y fabricante — útil para compras y soporte. Haz clic en un modelo de la tabla para ver sus ONUs.',
          fetch_failed: 'Error al cargar el parque de ONUs.',
          all_vendors: 'Todos los fabricantes',
          kpi_vendors: 'Fabricantes', kpi_models: 'Modelos', kpi_top_model: 'Modelo más común', kpi_top3: 'Top 3 modelos', kpi_no_type: 'Sin tipo identificado',
          loading: 'Cargando el parque de ONUs…',
          chart_treemap: 'Fabricante → modelo', chart_treemap_hint: 'área = nº de ONUs',
          chart_top15: 'Top 15 modelos', chart_top15_hint: 'apilado por estado',
          chart_empty: 'Sin ONUs en el filtro.', onus: 'ONUs',
          col_vendor: 'Fabricante', col_model: 'Modelo', col_category: 'Categoría', col_total: 'Total', col_online: 'En línea', col_offline: 'Fuera de línea', col_critical: 'Señal crítica', col_pct: '% del parque',
          table_empty: 'Ninguna ONU en el filtro actual.',
          footer: (models, onus) => `${models} modelos · ${onus} ONUs en el filtro (parque entero cargado).`,
          drawer_close: 'Cerrar', unknown: 'No identificado',
          mode_routing: 'Enrutamiento', mode_bridge: 'Bridge',
          csv_model_h: ['Fabricante', 'Modelo', 'Categoría', 'Total', 'En línea', 'Fuera de línea', 'Señal crítica', '% del parque'],
          csv_onu_h: ['Serial', 'Cliente', 'Fabricante', 'Modelo', 'Categoría', 'OLT', 'Zona', 'Estado'],
          sheet_by_model: 'Por modelo', sheet_onus: 'ONUs',
        },
        plans: {
          title: 'Clientes por plan de velocidad',
          subtitle: 'Suscriptores agrupados por el par de perfiles de banda (descarga / subida) que OLTM registró haber aplicado. Haz clic en un plan para ver su distribución por OLT.',
          kpi_plans: 'Planes', kpi_subs: 'Suscriptores con plan', kpi_pct: '% del parque con plan', kpi_top: 'Plan más vendido', kpi_no_plan: 'Suscriptores sin plan',
          loading: 'Cargando planes…',
          empty: 'Ningún plan de velocidad aplicado a las ONUs en el filtro actual.',
          no_plan: 'Sin plan', subscribers: 'suscriptores',
          drawer_by_olt: 'Distribución por OLT', drawer_no_dist: 'Sin distribución por OLT.', drawer_close: 'Cerrar',
          chart_subs: 'Suscriptores por plan', chart_subs_hint: (n) => `${n} planes`,
          chart_share: 'Participación', chart_share_hint: 'suscriptores por plan',
          tt_online: 'En línea', tt_subscribers: 'Suscriptores',
          col_plan: 'Plan', col_download: 'Descarga', col_upload: 'Subida', col_subscribers: 'Suscriptores', col_online: 'En línea', col_pct: '% del total',
          table_empty: 'Ningún plan en el filtro actual.',
          disclaimer: 'El informe refleja lo que OLTM registró haber aplicado (onu_speed_profiles), no lo que está configurado en el equipo — el modelo Huawei actual puede no aplicar la banda de hecho en muchos casos.',
          csv_plan_h: ['Plan', 'Descarga (kbps)', 'Subida (kbps)', 'Suscriptores', 'En línea', '% del total'],
          csv_byolt_h: ['Plan', 'OLT', 'Suscriptores'],
          sheet_plans: 'Planes', sheet_byolt: 'Planes x OLT',
        },
        uptime_page: {
          title: 'Disponibilidad (uptime)',
          subtitle: 'Porcentaje de tiempo en que cada OLT estuvo en línea en el período, para SLA e informes gerenciales. El historial empieza cuando el colector registró la primera transición de estado — las ventanas anteriores cuentan como "sin datos", no como caída.',
          sla_meta: 'Meta SLA', no_data_badge: 'sin datos', coverage_short: 'cob.',
          st_error: 'Error de recolección', st_degraded: 'Degradada',
          kpi_fleet: 'Uptime medio de la flota', kpi_worst: 'Peor uptime', kpi_incidents: 'Incidentes en el período', kpi_longest: 'Mayor caída continua', kpi_partial_cov: 'OLTs con cobertura < 100%',
          loading: 'Cargando disponibilidad…', empty: 'Ninguna OLT registrada.',
          since_notice: (d) => `Datos de disponibilidad desde ${d} — el período seleccionado empieza antes de eso, y el tramo anterior aparece como "sin datos" (reduce la cobertura, no cuenta como caída).`,
          no_data_notice: 'El colector aún no ha registrado ninguna transición de estado de OLT. El informe pasa a valer desde el primer cambio detectado.',
          ribbon_title: (from, to) => `Cinta de disponibilidad — ${from} a ${to}`,
          legend_online: 'En línea', legend_down: 'No disponible', legend_no_data: 'Sin datos',
          d_incidents: 'Incidentes', d_downtime: 'Downtime', d_longest: 'Mayor caída',
          d_windows: 'Ventanas de indisponibilidad', d_see_alerts: 'Ver alertas', d_no_incidents: 'Ninguna indisponibilidad registrada en el período.',
          d_uptime_cov: (u, c) => `${u}% de uptime · cobertura ${c}%`, d_no_data_period: 'sin datos de disponibilidad en el período', d_until: 'hasta', d_close: 'Cerrar',
          tip_no_data: 'Sin datos',
          col_uptime: 'Uptime', col_downtime: 'Downtime', col_incidents: 'Incidentes', col_longest: 'Mayor caída', col_coverage: 'Cobertura', col_status_now: 'Estado actual',
          table_empty: 'Ninguna OLT.',
          footer: (n, sla) => `${n} OLTs · uptime medido solo sobre el tiempo con datos (cobertura) · meta de SLA ${sla}% · haz clic en una OLT para ver sus ventanas de caída.`,
          csv_summary_h: ['OLT', 'Uptime %', 'Cobertura %', 'Downtime (s)', 'Incidentes', 'Mayor caída (s)', 'Estado actual'],
          csv_incidents_h: ['OLT', 'Inicio', 'Fin', 'Duración (s)', 'Estado'],
          csv_no_incidents: '— ningún incidente en el período —',
          sheet_summary: 'Resumen', sheet_incidents: 'Incidentes',
        },
        swaps: {
          title: 'Historial de cambios de ONU',
          subtitle: 'Sustituciones de equipo por cliente a lo largo del tiempo — mismo punto/cliente, serial diferente (RMA, upgrade, defecto). Ajusta el motivo directamente en la tabla.',
          req_failed: 'Falló la solicitud.',
          reason_saved: 'Motivo actualizado', reason_save_failed: 'Error al guardar el motivo',
          reasons: { rma: 'RMA', upgrade: 'Upgrade', defect: 'Defecto', reinstall: 'Reinstalación', unknown: 'A clasificar' },
          all_reasons: 'Todos los motivos', all_types: 'Cambios y reinstalaciones', type_swap: 'Solo cambios de equipo', type_reinstall: 'Solo reinstalaciones',
          filter_customer_ph: 'Filtrar por cliente…',
          kpi_swaps: 'Cambios en el período', kpi_customers: 'Clientes afectados', kpi_avg_gap: 'Tiempo medio sin ONU', kpi_top_reason: 'Motivo predominante', kpi_last30: 'Cambios en los últimos 30d',
          loading: 'Cargando cambios…',
          empty: 'Ningún cambio de ONU registrado en el período/filtro actual.',
          months: (n) => `${n} cambio${n > 1 ? 's' : ''}`,
          col_date: 'Fecha', col_pon: 'PON', col_cto: 'Splitter', col_serial: 'Serial (antiguo → nuevo)', col_model: 'Modelo', col_gap: 'Sin ONU', col_reason: 'Motivo', col_detected: 'Detección', col_by: 'Por',
          table_empty: 'Ningún cambio en el filtro actual.',
          footer: (shown, total) => `${shown} de ${total} cambios en el período · detección automática al momento de la autorización + backfill histórico.`,
          d_title: 'Cambio de ONU', d_close: 'Cerrar',
          d_equipment: 'Equipo', d_model: 'Modelo', d_reason: 'Motivo', d_detection: 'Detección', d_gap: 'Cliente sin ONU', d_registered_by: 'Registrado por',
          d_old: 'Antigua', d_new: 'Nueva', d_onu_gone: 'La ONU ya no está en el registro.',
          csv_h: ['Fecha', 'Cliente', 'ONU (nombre)', 'OLT', 'PON', 'Splitter', 'Serial antiguo', 'Serial nuevo', 'Modelo antiguo', 'Modelo nuevo', 'Motivo', 'Detección', 'Registrado por', 'Tiempo sin ONU (s)'],
          sheet: 'Cambios de ONU',
        },
        consumption: {
          title: 'Consumo por cliente',
          subtitle: 'Uso de banda agregado por cliente en el período — P95, media, pico y total en GB. El tráfico de todas las ONUs de un cliente se suma por instante antes del percentil. Útil para políticas de fair use.',
          fetch_failed: 'Error al cargar.',
          search_ph: 'Buscar cliente…', fairuse_label: 'Umbral fair use', only_over: 'Solo por encima del umbral',
          truncated: 'Lista truncada a los 2000 clientes con mayor P95 de descarga. Refina por OLT/zona para ver el resto.',
          kpi_customers: 'Clientes con tráfico', kpi_total: 'Consumo total de la base', kpi_top1: 'Cliente top-1 (P95)', kpi_avg_p95: 'P95 medio de la base', kpi_over: 'Por encima del umbral',
          kpi_over_sub: (gb) => `≥ ${gb} GB`, kpi_over_none: 'define un umbral',
          loading: 'Cargando consumo por cliente…',
          empty: 'Ningún cliente con tráfico recolectado en el período. Verifica que las ONUs tengan el campo "cliente" completo y que la recolección de tráfico esté activa.',
          chart_top20: 'Top 20 clientes por P95 de descarga', chart_hint: (n) => `${n} clientes`, chart_tt: 'P95 descarga',
          col_customer: 'Cliente', col_onus: 'ONUs', col_p95_down: 'P95 down', col_p95_up: 'P95 up', col_avg_down: 'Media down', col_peak_down: 'Pico down', col_total: 'Total (down+up)', col_olts: 'OLT(s)', col_zone: 'Zona',
          table_empty: 'Ningún cliente en el filtro actual.',
          footer: (shown, total) => `${shown} de ${total} clientes · métrica principal: percentil 95 de descarga · haz clic en un cliente para ver la serie agregada y sus ONUs.`,
          d_onus_period: (n) => `${n} ONU${n === 1 ? '' : 's'} · consumo agregado en el período`,
          d_close: 'Cerrar', d_loading_series: 'Cargando serie…',
          d_p95_down: 'P95 descarga', d_peak_down: 'Pico descarga', d_total: 'Total (down+up)',
          d_agg_traffic: 'Tráfico agregado del cliente', d_no_samples: 'Sin muestras de tráfico en el período.',
          d_customer_onus: 'ONUs del cliente', d_no_onu: 'Ninguna ONU con tráfico en el período.',
          csv_h: ['Cliente', 'ONUs', 'P95 down (Mbps)', 'P95 up (Mbps)', 'Media down (Mbps)', 'Pico down (Mbps)', 'Total down (GB)', 'Total up (GB)', 'Total (GB)', 'Por encima del umbral', 'OLT(s)', 'Zona(s)'],
          csv_yes: 'sí', sheet: 'Clientes',
        },
        bulk: {
          title: 'Registro de tareas en lote',
          subtitle: 'Historial de ejecuciones de acciones masivas sobre ONUs — reinicio y cambio de zona aplicados a un conjunto filtrado. Haz clic en una fila para ver los parámetros y el resultado ítem por ítem.',
          req_failed: 'Falló la solicitud.',
          st: { pending: 'En espera', running: 'En ejecución', completed: 'Completado', failed: 'Falló', partial: 'Parcial' },
          ist: { pending: 'En espera', running: 'Procesando', success: 'Éxito', failed: 'Fallo' },
          actions: { restart: 'Reiniciar ONUs', change_zone: 'Cambiar zona' },
          onu_st: { unconfigured: 'no configurada', online: 'en línea', offline: 'fuera de línea', los: 'LOS', dyinggasp: 'dying-gasp', disabled: 'deshabilitada', removed: 'eliminada' },
          unknown_ref: 'desconocida', system_user: 'sistema',
          new_bulk: 'Nueva acción en lote',
          tgt_olt: (n) => `OLT ${n}`, tgt_zone: (n) => `zona ${n}`, tgt_pon: '1 puerto PON',
          tgt_status: (s) => `estado ${s}`, tgt_selected: (n) => `${n} ONUs seleccionadas`, tgt_all: 'todas las ONUs', tgt_suffix: (n) => `${n} ONUs`,
          all_statuses: 'Todos los estados', all_actions: 'Todas las acciones', all_users: 'Todos los usuarios',
          search_ph: 'Buscar en filtro / parámetros…',
          kpi_jobs: 'Jobs en el período', kpi_onus: 'ONUs afectadas', kpi_success_rate: 'Tasa de éxito', kpi_problem: 'Jobs fallidos / parciales', kpi_biggest: 'Mayor job', kpi_biggest_sub: 'ONUs en un único job',
          loading: 'Cargando tareas en lote…', empty: 'Ninguna tarea en lote en el período / filtro actual.',
          chart_daily: 'Jobs por día', chart_daily_hint: 'ONUs procesadas · éxito vs fallo', chart_no_period: 'Sin datos en el período.',
          chart_by_action: 'Jobs por acción', chart_by_action_hint: 'nº de ejecuciones', chart_no_data: 'Sin datos.',
          tt_success: 'Éxito', tt_failure: 'Fallo', tt_jobs: 'jobs',
          col_date: 'Fecha', col_action: 'Acción', col_user: 'Usuario', col_target: 'Objetivo', col_progress: 'Progreso', col_status: 'Estado', col_duration: 'Duración',
          table_empty: 'Ningún job en el filtro actual.',
          footer: (shown, total) => `${shown} de ${total} jobs en el período.`, footer_more: ' Mostrando los 500 jobs más recientes — reduce el período para ver más.',
          prog: (ok, fail, total) => `${ok} ok · ${fail} fallo · ${total} total`,
          d_close: 'Cerrar', d_status: 'Estado', d_total_onus: 'Total ONUs', d_success_fail: 'Éxito / Fallo', d_duration: 'Duración',
          d_filter: 'Filtro del job', d_no_filter: '— sin filtro (todas las ONUs) —', d_params: 'Parámetros', d_no_params: '— ninguno —',
          d_items: (n) => `Ítems (${n})`, d_loading_items: 'Cargando ítems…', d_no_items: 'Este job no tiene ítems.',
          d_showing_items: (shown, total) => `Mostrando los primeros ${shown} de ${total} ítems.`,
          col_serial: 'Serial', col_error: 'Error',
          csv_jobs_h: ['Fecha', 'Acción', 'Usuario', 'Objetivo', 'Total ONUs', 'Éxito', 'Fallo', 'Estado', 'Inicio', 'Fin', 'Duración'],
          csv_items_h: ['Fecha del job', 'Acción', 'Serial', 'Cliente', 'OLT', 'Estado', 'Error'],
          csv_items_failed: 'Error al cargar ítems para el Excel', csv_cap: (n) => `Exportación de ítems limitada a ${n} filas.`,
          sheet_jobs: 'Jobs', sheet_items: 'Ítems',
        },
      },
    },
  },
};
